export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
	  };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * Represents non-fractional signed whole numeric values. Since the value may
	 * exceed the size of a 32-bit integer, it's encoded as a string.
	 */
	BigInt: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values. The Decimal appears in a JSON response as a string to preserve
	 * precision.
	 */
	Decimal: { input: string; output: string };
	/** Url to uploaded upload */
	File: { input: string; output: string };
	/** Represents untyped JSON */
	JSON: { input: { [key: string]: any }; output: { [key: string]: any } };
	/** A number - float or integer */
	Number: { input: number; output: number };
	/** String removes all html tags */
	SanitizedString: { input: string; output: string };
	/** A float that can be a string */
	StringFloat: { input: string | number; output: string | number };
	/** A valid timestamp in seconds, transported as an integer */
	Timestamp: { input: number; output: number };
	/** URL starting with http/https */
	UrlString: { input: string; output: string };
}

/** The name of the resource type that is being reported. */
export type AbuseReportCategoryResourceTypes =
	/** Page */
	"Page";

/** Visibility of an abuse report category */
export type AbuseReportCategoryVisibility =
	/** Hidden */
	| "hidden"
	/** Live */
	| "live";

/** The status of the abuse report */
export type AbuseReportStatus =
	/** Accepted */
	| "accepted"
	/** Canceled */
	| "canceled"
	/** Pending */
	| "pending"
	/** Rejected */
	| "rejected";

/** The high level payment processor options. */
export type AcceptedPaymentMethods =
	| "apple"
	| "coinbase"
	| "free"
	| "multi_psp"
	| "paypal"
	| "platform_balance"
	| "sezzle"
	| "splitit"
	| "stripe";

/** The access level a given user (or company) has to an access pass or company. */
export type AccessLevel = "admin" | "customer" | "no_access";

/** The ways a relation of AccessPasses can be ordered */
export type AccessPassAffiliateOrder =
	| "cached_referrals_count"
	| "cached_usd_rewards"
	| "created_at";

/** An AccessPassAffiliate status */
export type AccessPassAffiliateStatuses =
	/** Active */
	| "active"
	/** Archived */
	| "archived";

/** The types of categories that can be used for AccessPass attachments. */
export type AccessPassAttachmentCategories =
	| "affiliate_assets"
	| "gallery_images";

/** The conditions that an access pass can have */
export type AccessPassConditions = "has_plans";

/** Values to filter access passes on */
export interface AccessPassFilters {
	/**
	 * Whether or not this creator achieved the 3k in 30 milestone
	 * @deprecated No longer available.
	 */
	achievedThreeKInThirty?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/**
	 * Whether or not to only return discoverable access passes.
	 * @deprecated We only return discoverable access passes now.
	 */
	discoverable?: InputMaybe<Scalars["Boolean"]["input"]>;
	/**
	 * The discovery category to filter by
	 * @deprecated The discovery AI API is no longer used.
	 */
	discoveryCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The max global affiliate percentage */
	globalAffiliatePercentageMaximum?: InputMaybe<Scalars["Float"]["input"]>;
	/** The min global affiliate percentage */
	globalAffiliatePercentageMinimum?: InputMaybe<Scalars["Float"]["input"]>;
	/** The global affiliate status */
	globalAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** An array, in order, of the category route tree that is being traversed. */
	marketplaceCategoryRoutes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The max global affiliate percentage */
	memberAffiliatePercentageMaximum?: InputMaybe<Scalars["Float"]["input"]>;
	/** The min global affiliate percentage */
	memberAffiliatePercentageMinimum?: InputMaybe<Scalars["Float"]["input"]>;
	/** The status of the member affiliate program for this access pass. */
	memberAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** What to order the results by. */
	order?: InputMaybe<PublicAccessPassesOrder>;
	/** The max price */
	priceMaximum?: InputMaybe<Scalars["Float"]["input"]>;
	/** The min price */
	priceMinimum?: InputMaybe<Scalars["Float"]["input"]>;
	/** Filter to show only passes owned by students of the specified access pass */
	studentsOfAccessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/**
	 * Whether or not the access pass' company uses whop four
	 * @deprecated No longer applies.
	 */
	usesWhopFour?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** The onboarding versions for access passes */
export type AccessPassOnboardingVersionTypes = "mar_2025";

/** The ways a relation of AccessPasses can be ordered */
export type AccessPassOrder =
	| "active_memberships_count"
	| "created_at"
	| "usd_gmv"
	| "usd_gmv_30_days";

/** Input for creating a product highlight */
export interface AccessPassProductHighlightInput {
	/**
	 * Text to display to describe the product highlight (max length 250 for
	 * qualification or benefits, 170 for who this is for, 140 for pricing features).
	 */
	content: Scalars["String"]["input"];
	/** The type of this highlight. */
	highlightType: ProductHighlightTypes;
	/** The title of the product highlight, if applicable. */
	title?: InputMaybe<Scalars["String"]["input"]>;
}

/** Input for creating a social link for an access pass */
export interface AccessPassSocialLinkInput {
	/** The URL of the social link */
	url: Scalars["UrlString"]["input"];
	/** The website this link is for */
	website: SocialLinkWebsites;
}

/** The different types an access pass can be. */
export type AccessPassTypes =
	/** Api Only */
	| "api_only"
	/** App */
	| "app"
	/** Experience Upsell */
	| "experience_upsell"
	/** Regular */
	| "regular";

/** Which columns can be used to sort. */
export type AccessPassesSortableColumns =
	| "active_members_count"
	| "active_memberships_count"
	| "created_at"
	| "id";

/** The types of payouts an affiliate can have */
export type AffiliatePayoutTypes = "flat_fee" | "percentage";

/** Which columns can be used to sort. */
export type AffiliatePlansSortableColumns = "created_at" | "id";

/** Values to filter affiliate referral logs on */
export interface AffiliateReferralLogFilters {
	/** Specific affiliates. */
	affiliateIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** A specific affiliate type. */
	affiliateType?: InputMaybe<AffiliateTypes>;
	/** Specific plans. */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** Specific users. */
	userIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}

/** Which columns can be used to sort. */
export type AffiliateReferralLogsSortableColumns = "created_at" | "id";

/** The scope of an affiliate (company based, global, etc.) */
export type AffiliateTypes =
	/** Custom */
	| "custom"
	/** Global */
	| "global"
	/** Marketplace */
	| "marketplace"
	/** Passholder */
	| "passholder";

/** Which columns can be used to sort. */
export type AffiliatesSortableColumns =
	| "cached_total_referrals"
	| "cached_total_rewards"
	| "created_at"
	| "id";

/** Autogenerated input type of AnalyzeAttachment */
export interface AnalyzeAttachmentInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID returned by the direct upload mutation */
	directUploadId: Scalars["String"]["input"];
	/** The type of media to analyze */
	mediaType: Media;
	/** The parts of the multipart upload */
	multipartParts?: InputMaybe<Array<UploadPartInput>>;
	/** The ID returned by the direct upload mutation */
	multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
}

/** The different types of permissions an api key can have. */
export type ApiKeyPermissions =
	/** Add free days membership */
	| "add_free_days_membership"
	/** Cancel membership */
	| "cancel_membership"
	/** Create checkout request */
	| "create_checkout_request"
	/** Create checkout session */
	| "create_checkout_session"
	/** Create plan */
	| "create_plan"
	/** Create promo code */
	| "create_promo_code"
	/** Create push notification */
	| "create_push_notification"
	/** Create quick link */
	| "create_quick_link"
	/** Create webhook */
	| "create_webhook"
	/** Delete checkout session */
	| "delete_checkout_session"
	/** Delete experience */
	| "delete_experience"
	/** Delete promo code */
	| "delete_promo_code"
	/** Delete webhook */
	| "delete_webhook"
	/** List access passes */
	| "list_access_passes"
	/** List checkout sessions */
	| "list_checkout_sessions"
	/** List customers */
	| "list_customers"
	/** List experiences */
	| "list_experiences"
	/** List licenses */
	| "list_licenses"
	/** List members */
	| "list_members"
	/** List memberships */
	| "list_memberships"
	/** List payment fees */
	| "list_payment_fees"
	/** List payment methods */
	| "list_payment_methods"
	/** List payments */
	| "list_payments"
	/** List plans */
	| "list_plans"
	/** List products */
	| "list_products"
	/** List promo codes */
	| "list_promo_codes"
	/** List reviews */
	| "list_reviews"
	/** List webhooks */
	| "list_webhooks"
	/** Refund payment */
	| "refund_payment"
	/** Retrieve access pass */
	| "retrieve_access_pass"
	/** Retrieve checkout request */
	| "retrieve_checkout_request"
	/** Retrieve checkout session */
	| "retrieve_checkout_session"
	/** Retrieve company */
	| "retrieve_company"
	/** Retrieve customer */
	| "retrieve_customer"
	/** Retrieve experience */
	| "retrieve_experience"
	/** Retrieve member */
	| "retrieve_member"
	/** Retrieve membership */
	| "retrieve_membership"
	/** Retrieve payment */
	| "retrieve_payment"
	/** Retrieve plan */
	| "retrieve_plan"
	/** Retrieve product */
	| "retrieve_product"
	/** Retrieve promo code */
	| "retrieve_promo_code"
	/** Retrieve review */
	| "retrieve_review"
	/** Retrieve webhook */
	| "retrieve_webhook"
	/** Send notification customers */
	| "send_notification_customers"
	/** Send notification members */
	| "send_notification_members"
	/** Terminate membership */
	| "terminate_membership"
	/** Update access pass */
	| "update_access_pass"
	/** Update experience */
	| "update_experience"
	/** Update membership */
	| "update_membership"
	/** Update plan */
	| "update_plan"
	/** Update product */
	| "update_product"
	/** Update promo code */
	| "update_promo_code"
	/** Update webhook */
	| "update_webhook"
	/** Validate license */
	| "validate_license";

/** The different API versions */
export type ApiVersion = "v1" | "v2" | "v5";

/** The different platforms an app build can target. */
export type AppBuildPlatforms = "android" | "ios" | "web";

/** The different statuses an AppBuild can be in. */
export type AppBuildStatuses = "approved" | "draft" | "pending" | "rejected";

/** Image styles for app. */
export type AppImageStyles = "s16" | "s24" | "s32" | "s40" | "s48" | "s80";

/** Input for creating a requested permission */
export interface AppRequestedPermissionInput {
	/** The action that the app will request off of users when a user installs the app. */
	action: Scalars["String"]["input"];
	/** Whether the action is required for the app to function. */
	isRequired: Scalars["Boolean"]["input"];
	/** The reason for requesting the action. */
	justification: Scalars["String"]["input"];
}

/** The status of an experience interface */
export type AppStatuses =
	/** Hidden */
	| "hidden"
	/** Live */
	| "live"
	/** Unlisted */
	| "unlisted";

/** These are the scopes an app can request on behalf of a user */
export type AppValidScopes =
	/** Read User */
	"read_user";

/** The different types of an app view */
export type AppViewTypes =
	/** Analytics */
	| "analytics"
	/** Dash */
	| "dash"
	/** Dashboard */
	| "dashboard"
	/** Discover */
	| "discover"
	/** Hub */
	| "hub";

/** The criteria for an application to the marketplace. */
export type ApplicationCriteriaIdentifier =
	/** App */
	| "app"
	/** Available Plan */
	| "available_plan"
	/** Benefit */
	| "benefit"
	/** Choose Category */
	| "choose_category"
	/** Description */
	| "description"
	/** Gallery Images */
	| "gallery_images"
	/** Headline */
	| "headline"
	/** Logo */
	| "logo"
	/** Setup Payouts */
	| "setup_payouts"
	/** Title */
	| "title"
	/** Visibility */
	| "visibility";

/** The types of records that an attachment can be attached to */
export type AttachableRecords =
	| "abuse_report"
	| "access_pass"
	| "access_pass_collection"
	| "app"
	| "assessment_question"
	| "automated_messages_config"
	| "bot"
	| "bounty"
	| "bounty_submission"
	| "competition_prize"
	| "content_reward_campaign"
	| "content_reward_submission"
	| "course_lesson"
	| "dispute"
	| "dms_post"
	| "experience"
	| "forum_post"
	| "information_request_item"
	| "resolution_event_upload"
	| "review"
	| "review_report"
	| "user";

/** Input for an attachment */
export interface AttachmentInput {
	/**
	 * This ID should be used the first time you upload an attachment. It is the ID
	 * of the direct upload that was created when uploading the file to S3 via the
	 * mediaDirectUpload mutation.
	 */
	directUploadId?: InputMaybe<Scalars["ID"]["input"]>;
	/**
	 * The ID of an existing attachment object. Use this when updating a resource and
	 * keeping a subset of the attachments. Don't use this unless you know what you're doing.
	 */
	id?: InputMaybe<Scalars["ID"]["input"]>;
}

/** Which columns can be used to sort. */
export type AuditLogsSortableColumns = "created_at" | "id";

/** The possible 2FA authentication types. */
export type AuthenticationMethods = "authenticator" | "sms";

/** Valid resource types for authorizations */
export type AuthorizationResourceTypes =
	/** An app */
	| "app"
	/** A company */
	| "company"
	/** An experience */
	| "experience"
	/** A product */
	| "product";

/** Possible roles an authorized user can have */
export type AuthorizedUserRoles =
	/** Admin */
	| "admin"
	/** App Manager */
	| "app_manager"
	/** Manager */
	| "manager"
	/** Moderator */
	| "moderator"
	/** Owner */
	| "owner"
	/** Sales Manager */
	| "sales_manager"
	/** Support */
	| "support";

/** The different categories of automated messages triggers. */
export type AutomatedMessagesTriggerCategories = "access_pass" | "app";

/** Image styles for avatar. */
export type AvatarImageStyles =
	| "s16"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s64"
	| "s80"
	| "s128"
	| "s180";

/** Balance reservation reservation types. */
export type BalanceReservationReservationTypes = "bnpl" | "regular";

/** The reasons for banning a user */
export type BanReasons =
	| "botting_content_rewards"
	| "botting_negative_reviews"
	| "control_center_blocked_country"
	| "harassment"
	| "other"
	| "spamming";

/** Autogenerated input type of BanUser */
export interface BanUserInput {
	/** The ID of the access pass to ban the user from */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The custom reason for banning the user */
	customReason?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the feed to delete messages from */
	deleteMessagesInFeedId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The reason for banning the user */
	reason?: InputMaybe<BanReasons>;
	/** The ID of the user to ban */
	userId: Scalars["ID"]["input"];
}

/** The reason why a specific payment was billed */
export type BillingReasons =
	/** Manual */
	| "manual"
	/** One Time */
	| "one_time"
	/** Subscription */
	| "subscription"
	/** Subscription Create */
	| "subscription_create"
	/** Subscription Cycle */
	| "subscription_cycle"
	/** Subscription Update */
	| "subscription_update";

/** The BNPL (Buy Now Pay Later) providers for a company */
export type BnplProvider =
	| "afterpay_clearpay"
	| "klarna"
	| "sezzle"
	| "splitit"
	| "zip";

/** Values to filter bounties on */
export interface BountyFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** Ability to filter bounties by access passes in specific marketplace categories. */
	marketplaceCategoryRoutes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** Whether to only include bounties that are not whop bounties. */
	nonWhopOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** What to order the results by. */
	order?: InputMaybe<PublicBountiesOrder>;
}

/** The type of update an event is. */
export type BusinessActivityEventTypes =
	/** Member Canceled */
	| "member_canceled"
	/** Member Churned */
	| "member_churned"
	/** Member Joined */
	| "member_joined"
	/** New Dispute */
	| "new_dispute"
	/** New Marketplace Sale */
	| "new_marketplace_sale"
	/** New Payment */
	| "new_payment"
	/** New Waitlist Entry */
	| "new_waitlist_entry";

/** Image styles for business_affiliate. */
export type BusinessAffiliateImageStyles =
	| "s16"
	| "s20"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s64"
	| "s80"
	| "s128"
	| "s180"
	| "s600x200"
	| "s800x200"
	| "s900x300"
	| "s1200x630"
	| "s1600x400";

/** The different business types a company can be. */
export type BusinessTypes =
	/** Agency */
	| "agency"
	/** Brick And Mortar */
	| "brick_and_mortar"
	/** Coaching */
	| "coaching"
	/** Coaching And Courses */
	| "coaching_and_courses"
	/** Community */
	| "community"
	/** Course */
	| "course"
	/** Education Program */
	| "education_program"
	/** Events */
	| "events"
	/** Newsletter */
	| "newsletter"
	/** Other */
	| "other"
	/** Paid Group */
	| "paid_group"
	/** Physical Products */
	| "physical_products"
	/** Saas */
	| "saas"
	/** Software */
	| "software";

/** The modes for the buyer fee. */
export type BuyerFeeMode = "use_account_fee" | "use_experiment_fee";

/** The different reasons a user can choose for why they are canceling their membership. */
export type CancelOptions =
	| "bad_experience"
	| "missing_features"
	| "other"
	| "switching"
	| "technical_issues"
	| "testing"
	| "too_expensive";

/** The over-arching state of the resolution. */
export type CaseStates = "closed" | "open";

/** Autogenerated input type of ChangeCardMyMembership */
export interface ChangeCardMyMembershipInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that this membership is on behalf of. */
	companyBuyerId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the membership to cancel at the end of the period. */
	membershipId: Scalars["ID"]["input"];
	/** The URL you want to take the user to when they return */
	redirectUrl?: InputMaybe<Scalars["UrlString"]["input"]>;
}

/** The different card funding methods a charge can have. */
export type ChargeCardFunding =
	/** Credit */
	| "credit"
	/** Debit */
	| "debit"
	/** Prepaid */
	| "prepaid"
	/** Unknown */
	| "unknown";

/** The different risk levels a charge can have. */
export type ChargeOutcomeRiskLevels =
	/** Elevated */
	| "elevated"
	/** Highest */
	| "highest"
	/** Normal */
	| "normal"
	/** Not Assessed */
	| "not_assessed"
	/** Unknown */
	| "unknown";

/** Autogenerated input type of ChargeUser */
export interface ChargeUserInput {
	/** The affiliate code to use for the checkout session */
	affiliateCode?: InputMaybe<Scalars["String"]["input"]>;
	/** The amount to charge the user */
	amount: Scalars["Float"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The currency to charge in */
	currency: Currencies;
	/** The description of the charge. Maximum 200 characters. */
	description?: InputMaybe<Scalars["String"]["input"]>;
	/** Additional metadata for the charge */
	metadata?: InputMaybe<Scalars["JSON"]["input"]>;
	/** The URL to redirect the user to after the checkout session is created */
	redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the user to charge */
	userId: Scalars["ID"]["input"];
}

/** The possible statuses for a charge user response */
export type ChargeUserResponseStatus =
	/** The charge requires additional action from the user. */
	| "needs_action"
	/** The charge was successful */
	| "success";

/** Chart interval (period). */
export type ChartIntervals =
	| "daily"
	| "hourly"
	| "monthly"
	| "weekly"
	| "yearly";

/** Input for a chat feed */
export interface ChatFeedInput {
	/** Whether or not media is banned in this chat */
	banMedia?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether or not URLs are banned in this chat */
	banUrls?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** List of banned words in this chat */
	bannedWords?: InputMaybe<Array<Scalars["String"]["input"]>>;
	/** The unique identifier for the feed */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The number of seconds a user needs to wait before posting again, if any */
	userPostsCooldownSeconds?: InputMaybe<Scalars["Int"]["input"]>;
	/** Who can post on this chat */
	whoCanPost?: InputMaybe<WhoCanPostTypes>;
	/** Who can react on this chat */
	whoCanReact?: InputMaybe<WhoCanReactTypes>;
}

/** The type of checkout session being made */
export type CheckoutSessionTypes = "in_app_purchase" | "purchase";

/** The state of the Coinbase Commerce connection. */
export type CoinbaseCommerceStatuses =
	/** The Coinbase commerce connection is broken and needs to be fixed with a new API key. */
	| "broken"
	/** The Coinbase Commerce account is missing a settlement address. This needs to be set from the coinbase dashboard. */
	| "missing_settlement_address"
	/** The Coinbase commerce connection is setup and ready to be used. */
	| "setup"
	/** The webhook connection has not been tested / verified. */
	| "webhook_not_verified";

/** The ways a relation of Companies can be ordered */
export type CompaniesOrder = "created_at" | "id" | "total_memberships_earnings";

/** The types of categories that can be used for company attachments. */
export type CompanyAttachmentCategories = "gallery_images";

/** Image styles for company. */
export type CompanyImageStyles =
	| "s16"
	| "s20"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s64"
	| "s80"
	| "s128"
	| "s180"
	| "s600x200"
	| "s800x200"
	| "s900x300"
	| "s1200x630"
	| "s1600x400";

/** Attributes collected during company onboarding */
export interface CompanyOnboardingPlanOptions {
	/** The respective currency identifier for the plan. */
	baseCurrency?: InputMaybe<Currencies>;
	/** The interval at which the plan charges (renewal plans). */
	billingPeriod?: InputMaybe<Scalars["Int"]["input"]>;
	/** An array of custom field objects. */
	customFields?: InputMaybe<Array<CustomFieldInput>>;
	/** An additional amount charged upon first purchase. */
	initialPrice?: InputMaybe<Scalars["Float"]["input"]>;
	/** Indicates if the plan is a one time payment or recurring. */
	planType?: InputMaybe<PlanTypes>;
	/** The method by which the plan is released to the public. */
	releaseMethod?: InputMaybe<ReleaseMethod>;
	/** The amount the customer is charged every billing period. */
	renewalPrice?: InputMaybe<Scalars["Float"]["input"]>;
	/** The visibility of the plan. */
	visibility?: InputMaybe<Visibility>;
}

/** DEPRECATED: The different types a company can be. */
export type CompanyTypes =
	| "app"
	| "bot"
	| "community"
	| "nft"
	| "other"
	| "proxy"
	| "server";

/** The different types a competition can be */
export type CompetitionMetricTypes =
	/** Earnings Inside Access Pass */
	| "earnings_inside_access_pass"
	/** Global Earnings */
	| "global_earnings";

/** The different types a competition prize can be */
export type CompetitionPrizeTypes =
	/** Cash */
	| "cash"
	/** Custom */
	| "custom";

/** Statuses for connected accounts */
export type ConnectedAccountStatuses =
	| "connected"
	| "needs_completion"
	| "rejected"
	| "requirements_not_met"
	| "under_review";

/** Different types of how a company's marketplace card should display its pricing / access. */
export type ConnectedAccountTypes =
	/** Custom */
	| "custom"
	/** Express */
	| "express"
	/** Personal */
	| "personal"
	/** Platform Managed */
	| "platform_managed"
	/** Standard */
	| "standard"
	/** Whop Credit */
	| "whop_credit";

/** The ordering options for content rewards */
export type ContentRewardsCampaignOrder =
	| "amount_paid_out"
	| "expires_at"
	| "pending_submissions_count"
	| "submissions_count"
	| "total_budget";

/** The different statuses content reward campaigns can be assigned to */
export type ContentRewardsCampaignStatus =
	/** Active */
	| "active"
	/** Archived */
	| "archived"
	/** Expired */
	| "expired"
	/** Pending */
	| "pending";

/** Values to filter content rewards on */
export interface ContentRewardsCampaignsFilters {
	/** The direction to order by */
	direction?: InputMaybe<Direction>;
	/** The ID to filter campaigns for */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The order of the rewards */
	order?: InputMaybe<ContentRewardsCampaignOrder>;
	/** The status of the reward */
	status?: InputMaybe<ContentRewardsCampaignStatus>;
}

/** The different categories content reward campaigns can be assigned to */
export type ContentRewardsCategory =
	/** Brand */
	| "brand"
	/** Creator */
	| "creator"
	/** E Commerce */
	| "e_commerce"
	/** Entertainment */
	| "entertainment"
	/** Influencer */
	| "influencer"
	/** Logo */
	| "logo"
	/** Music */
	| "music"
	/** Musician */
	| "musician"
	/** Other */
	| "other"
	/** Personal Brand */
	| "personal_brand"
	/** Podcast */
	| "podcast"
	/** Products */
	| "products"
	/** Software */
	| "software"
	/** Stream */
	| "stream"
	/** Streamer */
	| "streamer";

/** The different types of content accepted by a content reward campaign */
export type ContentRewardsContentType =
	/** Clipping */
	| "clipping"
	/** Faceless */
	| "faceless"
	/** Other */
	| "other"
	/** Ugc */
	| "ugc";

/** The different platforms that content rewards submissions can be for */
export type ContentRewardsPlatform =
	/** Instagram */
	| "instagram"
	/** Tiktok */
	| "tiktok"
	/** X */
	| "x"
	/** Youtube */
	| "youtube";

/** The ordering options for public content rewards campaigns */
export type ContentRewardsPublicCampaignOrder =
	| "amount_paid_out"
	| "budget_left"
	| "created_at"
	| "expires_at";

/** Values to filter public content rewards on */
export interface ContentRewardsPublicCampaignsFilters {
	/** The direction to order by */
	direction?: InputMaybe<Direction>;
	/** The order of the rewards */
	order?: InputMaybe<ContentRewardsPublicCampaignOrder>;
	/** The status of the reward */
	status?: InputMaybe<ContentRewardsCampaignStatus>;
}

/** The different results of submission analysis */
export type ContentRewardsSubmissionAnalysisResults =
	/** Fail */
	| "fail"
	/** Pass */
	| "pass"
	/** Unknown */
	| "unknown";

/** The reasons a content rewards submission can be flagged for. */
export type ContentRewardsSubmissionFlagReasons =
	/** Engagement Ratio */
	| "engagement_ratio"
	/** Ml Analysis */
	| "ml_analysis"
	/** Reported Botter */
	| "reported_botter"
	/** Text Analysis */
	| "text_analysis"
	/** Video Analysis */
	| "video_analysis"
	/** View Acceleration */
	| "view_acceleration"
	/** View Spike */
	| "view_spike";

/** The different statuses content reward submissions can be assigned to */
export type ContentRewardsSubmissionStatus =
	/** Approved */
	| "approved"
	/** Flagged */
	| "flagged"
	/** Pending */
	| "pending"
	/** Rejected */
	| "rejected";

/** The configuration for a chart. */
export interface ContentRewardsSubmissionViewsChartConfigInput {
	/** The interval to group the data by. */
	interval?: InputMaybe<ChartIntervals>;
	/** The time zone used for start of day calculations. */
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
	/** The week mode to group the data by. For details, look at https://clickhouse.com/docs/en/sql-reference/functions/date-time-functions#toweek */
	weekMode?: InputMaybe<Scalars["Int"]["input"]>;
}

/** Values to filter content rewards submissions on */
export interface ContentRewardsSubmissionsFilters {
	/**
	 * The type of attachment required on the submission
	 * @deprecated No longer available
	 */
	attachmentType?: InputMaybe<FileAttachmentTypes>;
	/** The campaign ID to filter by */
	campaignId?: InputMaybe<Scalars["ID"]["input"]>;
	/** Filter submissions by date created after */
	createdAtAfter?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** Filter submissions by date created before */
	createdAtBefore?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The direction to order by */
	direction?: InputMaybe<Direction>;
	/** Whether to exclude banned users from the results */
	excludeBannedUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The experience ID to filter by */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** Whether the submission was flagged by AI */
	flaggedByAi?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The order to sort the results by */
	order?: InputMaybe<ContentRewardsSubmissionsOrder>;
	/** Whether the submission has reached the minimum payout */
	reachedMinimumPayout?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The status of the submissions */
	status?: InputMaybe<ContentRewardsSubmissionStatus>;
	/** Filter submissions by partial username match */
	username?: InputMaybe<Scalars["String"]["input"]>;
	/** The result of the video analysis */
	videoAnalysisResult?: InputMaybe<ContentRewardsSubmissionAnalysisResults>;
}

/** The ordering options for content rewards submissions */
export type ContentRewardsSubmissionsOrder =
	| "created_at"
	| "total_paid"
	| "total_view_count";

/** Which columns can be used to sort. */
export type ContentRewardsSubmissionsSortableColumns =
	| "cached_total_paid"
	| "cached_total_view_count"
	| "created_at"
	| "id"
	| "status";

/** The configuration for a chart. */
export interface ContentRewardsViewsChartConfigInput {
	/** The ID of the campaign to filter by */
	campaignId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the experience to filter by */
	experienceId: Scalars["ID"]["input"];
	/** The start date to take into account. */
	from: Scalars["Timestamp"]["input"];
	/** The interval to group the data by. */
	interval?: InputMaybe<ChartIntervals>;
	/** The time zone used for start of day calculations. */
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
	/** The end date to take into account. */
	to: Scalars["Timestamp"]["input"];
	/** The week mode to group the data by. For details, look at https://clickhouse.com/docs/en/sql-reference/functions/date-time-functions#toweek */
	weekMode?: InputMaybe<Scalars["Int"]["input"]>;
}

/** The available types for an assessment question */
export type CoursesAssessmentQuestionTypes =
	/** Multiple choice */
	| "multiple_choice"
	/** Multiple select */
	| "multiple_select"
	/** Short answer */
	| "short_answer"
	/** True false */
	| "true_false";

/** Autogenerated input type of CreateAccessPass */
export interface CreateAccessPassInput {
	/** A banner image for the access pass in png, jpeg format */
	bannerImage?: InputMaybe<AttachmentInput>;
	/** The business type of the access pass. */
	businessType?: InputMaybe<BusinessTypes>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company to create the access pass for. */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The creator pitch for the access pass. */
	creatorPitch?: InputMaybe<Scalars["String"]["input"]>;
	/** The custom call to action for the access pass. */
	customCta?: InputMaybe<CustomCtas>;
	/** The custom call to action URL for the access pass. */
	customCtaUrl?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The custom statement descriptor for the access pass i.e. WHOP*SPORTS, must be
	 * between 5 and 22 characters, contain at least one letter, and not contain any
	 * of the following characters: <, >, \, ', "
	 */
	customStatementDescriptor?: InputMaybe<Scalars["String"]["input"]>;
	/** A written description of the access pass. */
	description?: InputMaybe<Scalars["String"]["input"]>;
	/** An array of experience IDs that this pass has */
	experienceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The percentage of the revenue that goes to the global affiliate program. */
	globalAffiliatePercentage?: InputMaybe<Scalars["Float"]["input"]>;
	/** The status of the global affiliate program for this access pass. */
	globalAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** The headline of the access pass. */
	headline?: InputMaybe<Scalars["String"]["input"]>;
	/** The URLs of the images to upload to the access pass. */
	imageUrls?: InputMaybe<Array<Scalars["String"]["input"]>>;
	/** The industry type of the access pass. */
	industryType?: InputMaybe<IndustryTypes>;
	/** The logo for the access pass in png, jpeg, or gif format */
	logo?: InputMaybe<AttachmentInput>;
	/** The ID of the marketplace category to assign to the access pass. */
	marketplaceCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The percentage of the revenue that goes to the member affiliate program. */
	memberAffiliatePercentage?: InputMaybe<Scalars["Float"]["input"]>;
	/** The status of the member affiliate program for this access pass. */
	memberAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** The details to assign an autogenerated plan. */
	planOptions?: InputMaybe<CompanyOnboardingPlanOptions>;
	/** The product highlights for the access pass. */
	productHighlights?: InputMaybe<Array<AccessPassProductHighlightInput>>;
	/** The ID of the product tax code to apply to this access pass. */
	productTaxCodeId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The URL to redirect the customer to after a purchase. */
	redirectPurchaseUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** The route of the access pass. */
	route?: InputMaybe<Scalars["String"]["input"]>;
	/** A short description of what the access pass offers or does. Must be 150 chars or less. */
	shortenedDescription?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not to show the member count on the access pass. */
	showMemberCount?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether or not to show reviews on the access pass. */
	showReviewsDtc?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The social links for the access pass. */
	socialLinks?: InputMaybe<Array<AccessPassSocialLinkInput>>;
	/** The title of the access pass. */
	title: Scalars["String"]["input"];
	/** Whether or not customers can upgrade to different plans on this access pass. */
	upgradeable?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** This access pass will/will not be displayed publicly. */
	visibility?: InputMaybe<Visibility>;
}

/** Autogenerated input type of CreateAffiliate */
export interface CreateAffiliateInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that the affiliate will be created for. */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The fee that the affiliate will receive for each referral (either a percentage or a flat fee). */
	fee?: InputMaybe<Scalars["StringFloat"]["input"]>;
	/** Whether the affiliate will only receive one payout. */
	onlyOnePayout?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether the fee is a percentage or a flat fee. */
	payoutType: PayoutTypes;
	/** The ID of the plan that the affiliate can refer. */
	planId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The IDs of the plans that the affiliate can refer. */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The username of the user who will become an affiliate */
	username: Scalars["String"]["input"];
}

/** Autogenerated input type of CreateAgentUser */
export interface CreateAgentUserInput {
	/** The ID of the app to create the agent user for. */
	appId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The name of the agent user. */
	name?: InputMaybe<Scalars["String"]["input"]>;
	/** An image for the user for their avatar. */
	profilePhoto?: InputMaybe<Scalars["File"]["input"]>;
	/** The username of the agent user. */
	username?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of CreateAppBuild */
export interface CreateAppBuildInput {
	/** The ID of the app to create a build for. By default the current app from the api key is used. */
	appId?: InputMaybe<Scalars["ID"]["input"]>;
	/**
	 * Attachment input for the app build file. This should be an upload in .zip
	 * format. The zip should contain at least one main_js_bundle.hbc file and
	 * optionally an assets folder next to it.
	 */
	attachment: AttachmentInput;
	/**
	 * Checksum of the app build file. This is generated by the client and used to
	 * verify the integrity of the file that is submitted when un-packaged later on a device.
	 */
	checksum: Scalars["String"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The platform of the app build (ios, android, web) */
	platform: AppBuildPlatforms;
	/**
	 * Supported app view types for the app build. A build can specify multiple view
	 * types, but should only specify ones that its code supports.
	 */
	supportedAppViewTypes?: InputMaybe<Array<AppViewTypes>>;
}

/** Autogenerated input type of CreateApp */
export interface CreateAppInput {
	/** The base URL of the app to be created */
	baseUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company to create the app for */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The name of the app to be created */
	name: Scalars["String"]["input"];
}

/** Autogenerated input type of CreateAssessmentQuestion */
export interface CreateAssessmentQuestionInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The correct answer to the assessment question */
	correctAnswer: Scalars["String"]["input"];
	/** The ID of the lesson to create the assessment question in */
	lessonId: Scalars["ID"]["input"];
	/** The text of the question being asked */
	questionText: Scalars["String"]["input"];
	/** The type of the assessment question */
	questionType: CoursesAssessmentQuestionTypes;
}

/** Autogenerated input type of CreateChapter */
export interface CreateChapterInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the course to create the chapter in */
	courseId: Scalars["ID"]["input"];
	/** The title of the chapter */
	title?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of CreateChat */
export interface CreateChatInput {
	/** The ID of the access pass (whop) to attach the chat experience to. It looks like prod_xxxx. */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The ID of an existing experience. If supplied, this new chat experience will
	 * be attached to the first access pass (whop) of this experience. It looks like exp_xxxx.
	 */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The expiration date of the chat experience to be created. After this timestamp, the experience disappears. */
	expiresAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The name of the chat experience to be created, shown to users in the UI. */
	name: Scalars["String"]["input"];
	/**
	 * The upsell plan details to add for the chat experience. This allows you to
	 * require paid access for the chat within the whop.
	 */
	price?: InputMaybe<UpsellPlanInput>;
	/**
	 * This is who is allowed to send messages inside the chat. Select 'admin' if you
	 * only want the team members to message, or select 'everyone' if any member of
	 * the whop can send messages.
	 */
	whoCanPost?: InputMaybe<WhoCanPostTypes>;
}

/** Autogenerated input type of CreateCheckoutSession */
export interface CreateCheckoutSessionInput {
	/** The affiliate code to use for the checkout session */
	affiliateCode?: InputMaybe<Scalars["String"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The metadata to use for the checkout session */
	metadata?: InputMaybe<Scalars["JSON"]["input"]>;
	/** The ID of the plan to use for the checkout session */
	planId: Scalars["ID"]["input"];
	/** The URL to redirect the user to after the checkout session is created */
	redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of CreateCompanyMutedUser */
export interface CreateCompanyMutedUserInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The time the user is muted until, in milliseconds. If not provided, the user will be muted indefinitely */
	mutedUntil?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The ID of the user to mute */
	userId: Scalars["ID"]["input"];
}

/** Autogenerated input type of CreateCourse */
export interface CreateCourseInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The cover image URL of the course */
	coverImage?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the experience to create the course in */
	experienceId: Scalars["ID"]["input"];
	/** The tagline of the course */
	tagline?: InputMaybe<Scalars["String"]["input"]>;
	/** The title of the course */
	title: Scalars["String"]["input"];
}

/** Autogenerated input type of CreateForum */
export interface CreateForumInput {
	/** The ID of the access pass (whop) to attach the experience to. It looks like prod_xxxx. */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The ID of an existing experience. If supplied, this new forum experience will
	 * be attached to the first access pass (whop) of this experience. It looks like exp_xxxx.
	 */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The expiration date of the experience to be created. After this timestamp, the experience is deleted. */
	expiresAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The name of the forum experience to be created, shown to the user on the UI. */
	name: Scalars["String"]["input"];
	/**
	 * The upsell plan details to add for the forum experience. This allows you to
	 * require paid access for the forum within the whop.
	 */
	price?: InputMaybe<UpsellPlanInput>;
	/**
	 * This is who is allowed to create posts inside the forum. Select 'admin' if you
	 * only want the team members to post, or select 'everyone' if any member of the
	 * whop can post. Default value is 'admins'.
	 */
	whoCanPost?: InputMaybe<ForumWhoCanPostTypes>;
}

/** Autogenerated input type of CreateForumPost */
export interface CreateForumPostInput {
	/** The attachments for this post, such as videos or images. */
	attachments?: InputMaybe<Array<AttachmentInput>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The content of the post. This is the main body of the post. Hidden if paywalled. */
	content: Scalars["String"]["input"];
	/** The ID of the forum experience to send the message in. This will look like exp_xxxx. */
	forumExperienceId: Scalars["String"]["input"];
	/**
	 * This is used to determine if the post should be sent as a 'mention'
	 * notification to all of the users who are in the experience. This means that
	 * anyone with 'mentions' enabled will receive a notification about this post.
	 */
	isMention?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The ID of the parent post, if applicable (Used when making a comment) */
	parentId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The amount to paywall this post by. A paywalled post requires the user to purchase it in order to view its content. */
	paywallAmount?: InputMaybe<Scalars["Float"]["input"]>;
	/** The currency to paywall this post by. A paywalled post requires the user to purchase it in order to view its content. */
	paywallCurrency?: InputMaybe<Currencies>;
	/** Whether the post should be pinned */
	pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The poll for this post. A poll lets you collect responses to a multiple choice question. */
	poll?: InputMaybe<PollInput>;
	/** The title of the post. Visible if paywalled. */
	title?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of CreateInvoice */
export interface CreateInvoiceInput {
	/** Whether or not to charge the customer a buyer fee. */
	chargeBuyerFee?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The method of collection for this invoice. If using charge_automatically, you must provide a payment_token. */
	collectionMethod: InvoiceCollectionMethods;
	/** The company ID to create this invoice for. */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/**
	 * The name of the customer to create this invoice for. This is required if you
	 * want to create an invoice for a customer who does not have a member of your company yet.
	 */
	customerName?: InputMaybe<Scalars["String"]["input"]>;
	/** The date the invoice is due, if applicable. */
	dueDate: Scalars["Timestamp"]["input"];
	/**
	 * The email address to create this invoice for. This is required if you want to
	 * create an invoice for a user who does not have a member of your company yet.
	 */
	emailAddress?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The member ID to create this invoice for. Include this if you want to create
	 * an invoice for an existing member. If you do not have a member ID, you must
	 * provide an email_address and customer_name.
	 */
	memberId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The payment token ID to use for this invoice. If using charge_automatically, you must provide a payment_token. */
	paymentTokenId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The properties of the plan to create for this invoice. */
	plan: InvoicePlanInput;
	/**
	 * The properties of the access pass to create for this invoice. Include this if
	 * you want to create an invoice for a new product.
	 */
	product?: InputMaybe<InvoiceAccessPassInput>;
	/** The access pass ID to create this invoice for. Include this if you want to create an invoice for an existing product. */
	productId?: InputMaybe<Scalars["ID"]["input"]>;
}

/** Autogenerated input type of CreateLesson */
export interface CreateLessonInput {
	/** The ID of the chapter to create the lesson in */
	chapterId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The content of the lesson */
	content?: InputMaybe<Scalars["String"]["input"]>;
	/** Days from course start until unlock */
	daysFromCourseStartUntilUnlock?: InputMaybe<Scalars["Int"]["input"]>;
	/** The type of the lesson */
	lessonType: LessonTypes;
	/** The title of the lesson */
	title?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of CreatePromoCode */
export interface CreatePromoCodeInput {
	/** The access pass to lock the promo code to, if any. */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The amount off (% or flat amount) for the promo. */
	amountOff: Scalars["StringFloat"]["input"];
	/** The monetary currency of the promo code. */
	baseCurrency: Currencies;
	/** Restricts promo use to only users who have churned from the company before. */
	churnedUsersOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The specific code used to apply the promo at checkout. */
	code: Scalars["String"]["input"];
	/** The id of the company to create the promo code for. */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** Whether this promo code is for existing memberships only (cancelations) */
	existingMembershipsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The date/time of when the promo expires. */
	expirationDatetime?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** Restricts promo use to only users who have never purchased from the company before. */
	newUsersOnly: Scalars["Boolean"]["input"];
	/** The number of billing cycles the promo is applied for. */
	numberOfIntervals: Scalars["Int"]["input"];
	/** Restricts promo use to only be applied once per customer. */
	onePerCustomer?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The IDs of the plans that the affiliate can refer. */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The type (% or flat amount) of the promo. */
	promoType: PromoTypes;
	/** The quantity limit on the number of uses. */
	stock?: InputMaybe<Scalars["Int"]["input"]>;
	/** Whether or not the promo code should have unlimited stock. */
	unlimitedStock?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** Autogenerated input type of CreateWebhook */
export interface CreateWebhookInput {
	/** The API version for this webhook */
	apiVersion?: InputMaybe<ApiVersion>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not the webhook is enabled. */
	enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The events to send the webhook for. */
	events?: InputMaybe<Array<WebhookEvent>>;
	/** The resource to create the webhook for. By default this will use current company */
	resourceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The URL to send the webhook to. */
	url: Scalars["UrlString"]["input"];
}

/** Cancelation discounts for creator dashboard */
export type CreatorDashboardCancelationDiscounts =
	| "canceled"
	| "used_discount_and_canceled"
	| "used_discount_and_did_not_cancel";

/** The configuration for a chart. */
export interface CreatorDashboardChartConfigInput {
	/** The access pass ids (tags) to filter the data by. */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The currency to use for the chart. */
	currency?: InputMaybe<Currencies>;
	/** The start date to take into account. */
	from: Scalars["Timestamp"]["input"];
	/** The interval to group the data by. */
	interval?: InputMaybe<CreatorDashboardChartIntervals>;
	/** The time zone used for start of day calculations. */
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
	/** The end date to take into account. */
	to: Scalars["Timestamp"]["input"];
	/** The week mode to group the data by. For details, look at https://clickhouse.com/docs/en/sql-reference/functions/date-time-functions#toweek */
	weekMode?: InputMaybe<Scalars["Int"]["input"]>;
}

/** Chart interval (period). */
export type CreatorDashboardChartIntervals =
	| "daily"
	| "hourly"
	| "monthly"
	| "weekly"
	| "yearly";

/** The different types of activity for a credit transaction */
export type CreditTransactionActivityTypes =
	| "deductions"
	| "deposits"
	| "withdrawals";

/** Values to filter the credits on. */
export interface CreditTransactionFilters {
	/** Filter by activity type */
	activityType?: InputMaybe<CreditTransactionActivityTypes>;
	/** Filter by currency */
	currency?: InputMaybe<Currencies>;
	/** Filter by status */
	statuses?: InputMaybe<Array<CreditTransactionStatuses>>;
}

/** The statuses a credit transaction can have */
export type CreditTransactionStatuses =
	/** Finalized */
	| "finalized"
	/** Pending */
	| "pending";

/** The reasons for a credit transaction transfer */
export type CreditTransactionTransferReasons =
	| "bounty_payout"
	| "content_reward_fixed_payout"
	| "content_reward_payout"
	| "content_reward_return"
	| "creator_to_creator"
	| "creator_to_user"
	| "pool_top_up"
	| "team_member_payout"
	| "user_to_creator"
	| "user_to_user"
	| "wadmin_transferred_funds";

/** The statuses a credit transaction transfer can have */
export type CreditTransactionTransferStatuses = "completed";

/** The type a credit transaction transfer can have */
export type CreditTransactionTransferTypes =
	/** Admin */
	| "admin"
	/** User */
	| "user";

/** Which columns can be used to sort. */
export type CreditTransactionTransfersSortableColumns = "amount" | "created_at";

/** The eligible networks for a CryptoWallet */
export type CryptoWalletNetworks =
	/** Bitcoin */
	| "bitcoin"
	/** Ethereum */
	| "ethereum"
	/** Solana */
	| "solana";

/** The available currencies on the platform */
export type Currencies =
	| "aed"
	| "all"
	| "amd"
	| "ape"
	| "ars"
	| "aud"
	| "bam"
	| "bgn"
	| "bhd"
	| "bob"
	| "brl"
	| "bsd"
	| "btc"
	| "cad"
	| "chf"
	| "clp"
	| "cop"
	| "crc"
	| "czk"
	| "dkk"
	| "dop"
	| "dzd"
	| "egp"
	| "etb"
	| "eth"
	| "eur"
	| "gbp"
	| "ghs"
	| "gmd"
	| "gtq"
	| "gyd"
	| "hkd"
	| "huf"
	| "idr"
	| "ils"
	| "inr"
	| "jmd"
	| "jod"
	| "jpy"
	| "kes"
	| "khr"
	| "krw"
	| "kwd"
	| "lkr"
	| "mad"
	| "mdl"
	| "mga"
	| "mkd"
	| "mnt"
	| "mop"
	| "mur"
	| "mxn"
	| "myr"
	| "nad"
	| "ngn"
	| "nok"
	| "nzd"
	| "omr"
	| "pen"
	| "php"
	| "pkr"
	| "pln"
	| "pyg"
	| "qar"
	| "ron"
	| "rsd"
	| "rub"
	| "rwf"
	| "sar"
	| "sek"
	| "sgd"
	| "thb"
	| "tnd"
	| "try"
	| "ttd"
	| "twd"
	| "tzs"
	| "usd"
	| "uyu"
	| "uzs"
	| "vnd"
	| "xcd"
	| "xof"
	| "zar";

/** The different types of custom CTAs that can be selected. */
export type CustomCtas =
	/** Apply Now */
	| "apply_now"
	/** Call Now */
	| "call_now"
	/** Complete Order */
	| "complete_order"
	/** Contact Us */
	| "contact_us"
	/** Donate Now */
	| "donate_now"
	/** Get Access */
	| "get_access"
	/** Get Offer */
	| "get_offer"
	/** Join */
	| "join"
	/** Order Now */
	| "order_now"
	/** Purchase */
	| "purchase"
	/** Shop Now */
	| "shop_now"
	/** Sign Up */
	| "sign_up"
	/** Subscribe */
	| "subscribe";

export interface CustomFieldInput {
	/** The type of the custom field. */
	fieldType: CustomFieldTypes;
	/** The ID of the custom field (if being updated) */
	id?: InputMaybe<Scalars["ID"]["input"]>;
	/** The name of the custom field. */
	name: Scalars["String"]["input"];
	/** The order of the field. */
	order?: InputMaybe<Scalars["Int"]["input"]>;
	/** The placeholder value of the field. */
	placeholder?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not the field is required. */
	required?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** The type of the custom field. */
export type CustomFieldTypes =
	/** Text */
	"text";

/** Autogenerated input type of DeleteAccessPass */
export interface DeleteAccessPassInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The internal ID (tag) of the access pass to delete. */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteAssessmentQuestionImage */
export interface DeleteAssessmentQuestionImageInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the attachment to delete */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteChapter */
export interface DeleteChapterInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the chapter to delete */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteCompanyMutedUser */
export interface DeleteCompanyMutedUserInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the user to unmute */
	userId: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteLessonAttachment */
export interface DeleteLessonAttachmentInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the attachment to delete */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteLesson */
export interface DeleteLessonInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the lesson to delete */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeletePromoCode */
export interface DeletePromoCodeInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The internal ID of the promo code to archive. */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of DeleteWebhook */
export interface DeleteWebhookInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the webhook to delete. */
	id: Scalars["ID"]["input"];
}

/** The type of device a user can use to access Whop */
export type Device = "android" | "desktop_web" | "ios" | "mobile_web";

/** The status of the direct message. */
export type DirectMessageStatus =
	/** Accepted */
	| "accepted"
	/** Archived */
	| "archived"
	/** Closed */
	| "closed"
	/** Hidden */
	| "hidden"
	/** Requested */
	| "requested";

/** Autogenerated input type of DirectUpload */
export interface DirectUploadInput {
	/** The size of the file in bytes */
	byteSize?: InputMaybe<Scalars["Int"]["input"]>;
	/** The size of the file in bytes */
	byteSizeV2?: InputMaybe<Scalars["BigInt"]["input"]>;
	/** The checksum of the file */
	checksum: Scalars["String"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The content type of the file */
	contentType?: InputMaybe<Scalars["String"]["input"]>;
	/** The filename of the file */
	filename: Scalars["String"]["input"];
	/** The metadata of the file */
	metadata?: InputMaybe<Scalars["JSON"]["input"]>;
	/** Whether or not to use multipart upload. The file must be larger than 5MB */
	multipart?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The type of record to attach the file to */
	record: AttachableRecords;
}

/** The direction of the sort. */
export type Direction = "asc" | "desc";

/** Image styles for discord_account. */
export type DiscordAccountImageStyles =
	| "s16"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s64"
	| "s80"
	| "s128"
	| "s180";

/** The available discover statuses to choose from. */
export type DiscoverStatuses =
	/** Live Discover */
	| "live_discover"
	/** Not Available */
	| "not_available";

/** The dispute risk levels of a ledger account, derived from the ledger account stat */
export type DisputeRiskLevels =
	/** At Risk */
	| "at_risk"
	/** High */
	| "high"
	/** Low */
	| "low"
	/** Medium */
	| "medium"
	/** Removal */
	| "removal";

/** The possible statuses of a dispute */
export type DisputeStatuses =
	/** Closed */
	| "closed"
	/** Lost */
	| "lost"
	/** Needs Response */
	| "needs_response"
	/** Other */
	| "other"
	/** Under Review */
	| "under_review"
	/** Warning Closed */
	| "warning_closed"
	/** Warning Needs Response */
	| "warning_needs_response"
	/** Warning Under Review */
	| "warning_under_review"
	/** Won */
	| "won";

/** Which columns can be used to sort. */
export type DisputesSortableColumns =
	| "amount"
	| "created_at"
	| "final_amount"
	| "id"
	| "needs_response_by";

/** Sort options for DM channels */
export type DmsChannelsSortTypes =
	| "created_at"
	| "custom_name"
	| "last_post_sent_at"
	| "query";

/** The input to create a DMs feed */
export interface DmsFeedInput {
	/** The collection ID for the feed */
	collectionIdentifier?: InputMaybe<Scalars["ID"]["input"]>;
	/** The custom name for the feed */
	customName?: InputMaybe<Scalars["String"]["input"]>;
	/** The unique identifier for the entity */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** Input for a DMs feed member */
export interface DmsFeedMemberInput {
	/** The ID of the DM channel */
	feedId: Scalars["ID"]["input"];
	/** The unique identifier for the post */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Timestamp when the member last viewed the channel (in milliseconds since Unix epoch) */
	lastViewedAt?: InputMaybe<Scalars["Float"]["input"]>;
	/** The notification preference for this member (all, mentions, none) */
	notificationPreference?: InputMaybe<DmsFeedMemberNotificationPreferences>;
	/** The status of the member (active, inactive, banned) */
	status?: InputMaybe<DmsFeedMemberStatuses>;
	/** The ID of the user */
	userId: Scalars["ID"]["input"];
}

/** The notification preferences for a DMs feed member */
export type DmsFeedMemberNotificationPreferences =
	/** All */
	| "all"
	/** Mentions */
	| "mentions"
	/** None */
	| "none";

/** The statuses of a DMs feed member */
export type DmsFeedMemberStatuses =
	/** Accepted */
	| "accepted"
	/** Archived */
	| "archived"
	/** Closed */
	| "closed"
	/** Hidden */
	| "hidden"
	/** Requested */
	| "requested";

/** The types of DMs feeds */
export type DmsFeedTypes = "direct_message" | "group_chat";

/** The input to create a post in a feed */
export interface DmsPostInput {
	/** The attachments for this message */
	attachments?: InputMaybe<Array<AttachmentInput>>;
	/** The content of the post */
	content?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the DM channel this post belongs to */
	feedId: Scalars["ID"]["input"];
	/** The type of the feed this post belongs to */
	feedType: FeedTypes;
	/**
	 * The file attachments for this message
	 * @deprecated Use attachments instead
	 */
	fileAttachments?: InputMaybe<Array<FileAttachmentInput>>;
	/** The GIFs attached to this message */
	gifs?: InputMaybe<Array<GifInput>>;
	/** The unique identifier for the post */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether everyone was mentioned in the post */
	isEveryoneMentioned?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether the post is pinned */
	isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The link embeds for this message */
	linkEmbeds?: InputMaybe<Array<LinkEmbedInput>>;
	/** The IDs of the users mentioned in the post */
	mentionedUserIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The ID of the parent post, if applicable */
	parentId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The poll for this message */
	poll?: InputMaybe<PollInput>;
	/** The ID of the message this is replying to, if applicable */
	replyingToPostId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The rich content of the post */
	richContent?: InputMaybe<Scalars["JSON"]["input"]>;
}

/** The types of post */
export type DmsPostTypes = "automated" | "regular" | "system";

/** The types of earnings on the platform */
export type EarningsReportPeriods =
	| "last_7_days"
	| "last_24_hours"
	| "last_30_days"
	| "lifetime";

/** The types of earnings on the platform */
export type EarningsTypes =
	/** Affiliate Payment */
	| "affiliate_payment"
	/** Bounty Payout */
	| "bounty_payout"
	/** Company Referral */
	| "company_referral"
	/** Content Reward Fixed Payout */
	| "content_reward_fixed_payout"
	/** Content Reward Payout */
	| "content_reward_payout"
	/** Creator To Creator */
	| "creator_to_creator"
	/** Creator To User */
	| "creator_to_user"
	/** Membership Referral */
	| "membership_referral"
	/** Payment Payout */
	| "payment_payout"
	/** Team Member Payout */
	| "team_member_payout"
	/** User To Creator */
	| "user_to_creator"
	/** User To User */
	| "user_to_user";

/** The type of entity to fetch */
export type EntityTypes =
	/** Chat Feed */
	| "chat_feed"
	/** Dms Feed */
	| "dms_feed"
	/** Dms Feed Member */
	| "dms_feed_member"
	/** Dms Post */
	| "dms_post"
	/** Forum Feed */
	| "forum_feed"
	/** Forum Post */
	| "forum_post"
	/** Livestream Feed */
	| "livestream_feed"
	/** Muted User */
	| "muted_user"
	/** Reaction */
	| "reaction";

/** Filters for the entries table. */
export interface EntriesFiltersInput {
	/** The access pass IDs to filter the entries by */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The end date to filter the entries by */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The plan IDs to filter the entries by */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The start date to filter the entries by */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The statuses to filter the entries by */
	statuses?: InputMaybe<Array<EntryStatus>>;
}

/** Which columns can be used to sort. */
export type EntriesSortableColumns = "created_at" | "id";

/** Values to filter entries on */
export interface EntryFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What the results should be ordered by. */
	order?: InputMaybe<EntryOrder>;
	/** A specific status */
	status?: InputMaybe<EntryStatus>;
	/** A list of statuses */
	statuses?: InputMaybe<Array<EntryStatus>>;
}

/** The order to sort the entries by */
export type EntryOrder =
	| "created_at"
	| "member_discord"
	| "member_username"
	| "selected";

/** The status of an entry to a waitlist or raffle. */
export type EntryStatus = "any" | "approved" | "denied" | "pending";

/** An entry can either be a watlist or raffle */
export type EntryTypes = "raffle" | "waitlist";

/** The different access levels for experiences (PUBLIC IS NEVER USED ANYMORE). */
export type ExperienceAccessLevels = "private" | "public";

/** The type of content that this experience card contains */
export type ExperienceActivityCardTypes =
	| "availability"
	| "booking"
	| "bounty"
	| "bounty_submission"
	| "calendar_bookings_availability"
	| "calendar_bookings_booking"
	| "campaign"
	| "content"
	| "content_rewards_campaign"
	| "content_rewards_submission"
	| "course"
	| "dms_post"
	| "event"
	| "events_event"
	| "events_rsvp"
	| "feed_dms_post"
	| "feed_forum_post"
	| "feed_livestream_feed"
	| "forum_post"
	| "livestream_feed"
	| "rsvp"
	| "spin"
	| "submission"
	| "wheel"
	| "wheel_spin"
	| "wheel_wheel";

/** Values to filter plans on */
export interface ExperienceFilters {
	/**
	 * The access level to filter on.
	 * @deprecated You can't filter by access level anymore
	 */
	accessLevel?: InputMaybe<ExperienceAccessLevels>;
	/** The ID of the access pass to filter on. */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the experience interface to filter on. */
	appId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The type of experience.. */
	experienceType?: InputMaybe<ExperienceTypes>;
	/** Either includes or excludes experiences on a given access pass. */
	onAccessPass?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The query to search for. */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The types of links that can be generated. */
export type ExperienceLinkModes = "iframe_link" | "link";

/** The different types of experiences that can be created. */
export type ExperienceTypes =
	/** Has Interface */
	"has_interface";

/** The type of feed to fetch from */
export type FeedTypes =
	/** Chat Feed */
	| "chat_feed"
	/** Dms Feed */
	| "dms_feed"
	/** Forum Feed */
	| "forum_feed"
	/** Livestream Feed */
	| "livestream_feed"
	/** Universal Post */
	| "universal_post"
	/** User */
	| "user";

/** Input for a file attachment */
export interface FileAttachmentInput {
	/** The aspect ratio of the image, if applicable */
	aspectRatio?: InputMaybe<Scalars["Float"]["input"]>;
	/** The type of the attachment (e.g., image, video) */
	attachmentType: FileAttachmentTypes;
	/** The blurred data URL for image preview */
	blurUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** The attachment's content type (e.g., image/jpg, video/mp4) */
	contentType?: InputMaybe<Scalars["String"]["input"]>;
	/** The name of the file */
	fileName?: InputMaybe<Scalars["String"]["input"]>;
	/** The size of the file in bytes */
	fileSize?: InputMaybe<Scalars["Int"]["input"]>;
	/** The URL to access the file */
	fileUrl: Scalars["String"]["input"];
	/** The height of the image */
	height?: InputMaybe<Scalars["Int"]["input"]>;
	/** The ID of the file attachment */
	id?: InputMaybe<Scalars["ID"]["input"]>;
	/** The URL to access the thumbnail */
	thumbnailUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** The width of the image */
	width?: InputMaybe<Scalars["Int"]["input"]>;
}

/** The different moderation results for a file attachment. */
export type FileAttachmentModerationResultsTypes =
	/** Nsfw */
	"nsfw";

/** The types of supported file attachments */
export type FileAttachmentTypes =
	/** Audio */
	| "audio"
	/** File */
	| "file"
	/** Image */
	| "image"
	/** Unknown */
	| "unknown"
	/** Video */
	| "video";

/** The duration of a FlashSale */
export type FlashSaleDurations =
	/** Forever */
	| "forever"
	/** Once */
	| "once";

/** The status of a FlashSale */
export type FlashSaleStatuses =
	/** Active */
	| "active"
	/** Archived */
	| "archived"
	/** Draft */
	| "draft";

/** Email notification preference option for a forum feed */
export type ForumEmailNotificationPreferences =
	| "all_admin_posts"
	| "none"
	| "only_weekly_summary";

/** The layout display option of a forum feed */
export type ForumLayoutTypes = "blog" | "feed";

/** The types of post */
export type ForumPostTypes = "automated" | "regular" | "system";

/** Who can comment on a forum feed */
export type ForumWhoCanCommentTypes = "admins" | "everyone";

/** Who can post on a forum feed */
export type ForumWhoCanPostTypes = "admins" | "everyone";

/** The friendly status of a receipt */
export type FriendlyReceiptStatus =
	| "auto_refunded"
	| "canceled"
	| "dispute_warning"
	| "drafted"
	| "failed"
	| "incomplete"
	| "open_dispute"
	| "open_resolution"
	| "partially_refunded"
	| "past_due"
	| "pending"
	| "price_too_low"
	| "refunded"
	| "succeeded"
	| "uncollectible"
	| "unresolved";

/** A gateway for a payment token. */
export type GatewayTypes =
	/** Multi Psp */
	| "multi_psp"
	/** Paypal */
	| "paypal";

/** Input for a GIF attachment */
export interface GifInput {
	/** The height of the GIF in pixels */
	height: Scalars["Int"]["input"];
	/** The original URL of the GIF */
	originalUrl: Scalars["String"]["input"];
	/** The URL for a preview image of the GIF */
	previewUrl: Scalars["String"]["input"];
	/** The provider of the GIF */
	provider: GifProviders;
	/** The unique identifier of the GIF */
	slug: Scalars["ID"]["input"];
	/** The title of the GIF */
	title: Scalars["String"]["input"];
	/** The URL of the full GIF */
	url: Scalars["String"]["input"];
	/** The width of the GIF in pixels */
	width: Scalars["Int"]["input"];
}

/** The types of supported GIFs providers */
export type GifProviders =
	/** Giphy */
	"giphy";

/** The different statuses of the global affiliate program for an access pass. */
export type GlobalAffiliateStatuses = "disabled" | "enabled";

/** The scope of the results to return. */
export type HubMembershipStatus = "active" | "inactive";

/** Predefined attachment variants */
export type ImageAttachmentVariants =
	| "legacy"
	| "original"
	| "s16"
	| "s20"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s48fit"
	| "s64"
	| "s64fit"
	| "s80"
	| "s80fit"
	| "s128"
	| "s180"
	| "s250x125"
	| "s250x125fit"
	| "s440x220"
	| "s440x220fit"
	| "s500x250"
	| "s500x250fit"
	| "s512x288"
	| "s512x288fit"
	| "s600x200"
	| "s600x400"
	| "s600x400fit"
	| "s720x1280"
	| "s720x1280fit"
	| "s800x200"
	| "s900x300"
	| "s1000x500"
	| "s1000x500fit"
	| "s1080x1920"
	| "s1080x1920fit"
	| "s1080x1920fit_h264_vq7"
	| "s1200x630"
	| "s1280x720"
	| "s1280x720fit"
	| "s1600x400"
	| "s1920x1080"
	| "s1920x1080fit"
	| "s1920x1080fit_h264_vq7"
	| "x2"
	| "x5";

/** Allowed image file types for uploading to the platform */
export type ImageExtensions = "GIF" | "JPEG" | "JPG" | "PNG" | "SVG" | "WEBP";

/** Image styles for image. */
export type ImageImageStyles =
	| "original"
	| "s16"
	| "s20"
	| "s24"
	| "s32"
	| "s40"
	| "s48"
	| "s48fit"
	| "s64"
	| "s64fit"
	| "s80"
	| "s80fit"
	| "s128"
	| "s180"
	| "s250x125"
	| "s250x125fit"
	| "s440x220"
	| "s440x220fit"
	| "s500x250"
	| "s500x250fit"
	| "s512x288"
	| "s512x288fit"
	| "s600x200"
	| "s600x400"
	| "s600x400fit"
	| "s800x200"
	| "s900x300"
	| "s1000x500"
	| "s1000x500fit"
	| "s1200x630"
	| "s1280x720"
	| "s1280x720fit"
	| "s1600x400"
	| "s1920x1080"
	| "s1920x1080fit";

/** The different industry types a company can be in. */
export type IndustryTypes =
	/** Accessories */
	| "accessories"
	/** Agencies */
	| "agencies"
	/** Ai */
	| "ai"
	/** Ai Agency */
	| "ai_agency"
	/** Amazon Fba */
	| "amazon_fba"
	/** Auto Repair Shop */
	| "auto_repair_shop"
	/** Beauty And Personal Care */
	| "beauty_and_personal_care"
	/** Bootcamps */
	| "bootcamps"
	/** Business */
	| "business"
	/** Careers */
	| "careers"
	/** Clipping */
	| "clipping"
	/** Clipping Agency */
	| "clipping_agency"
	/** Clothing */
	| "clothing"
	/** Coaching Agency */
	| "coaching_agency"
	/** Coffee Shop */
	| "coffee_shop"
	/** Concerts */
	| "concerts"
	/** Convention */
	| "convention"
	/** Customer Support Agency */
	| "customer_support_agency"
	/** Dating */
	| "dating"
	/** Design Agency */
	| "design_agency"
	/** Development Agency */
	| "development_agency"
	/** Ecommerce */
	| "ecommerce"
	/** Electronics And Gadgets */
	| "electronics_and_gadgets"
	/** Fitness */
	| "fitness"
	/** Fitness Gear */
	| "fitness_gear"
	/** Food And Beverages */
	| "food_and_beverages"
	/** Gym */
	| "gym"
	/** Health And Wellness */
	| "health_and_wellness"
	/** Home Goods */
	| "home_goods"
	/** Home Services */
	| "home_services"
	/** Hotel Lodging */
	| "hotel_lodging"
	/** Kindle Book Publishing */
	| "kindle_book_publishing"
	/** Marketing Agency */
	| "marketing_agency"
	/** Masterminds */
	| "masterminds"
	/** Medical Dentist Office */
	| "medical_dentist_office"
	/** Meetups */
	| "meetups"
	/** Other */
	| "other"
	/** Parties */
	| "parties"
	/** Personal Development */
	| "personal_development"
	/** Personal Finance */
	| "personal_finance"
	/** Public Speaking */
	| "public_speaking"
	/** Real Estate */
	| "real_estate"
	/** Recruiting Agency */
	| "recruiting_agency"
	/** Reselling */
	| "reselling"
	/** Restaurant */
	| "restaurant"
	/** Retail Store */
	| "retail_store"
	/** Sales */
	| "sales"
	/** Sales Agency */
	| "sales_agency"
	/** Salon Spa */
	| "salon_spa"
	/** Social Media */
	| "social_media"
	/** Software */
	| "software"
	/** Spirituality */
	| "spirituality"
	/** Sports Betting */
	| "sports_betting"
	/** Supplements */
	| "supplements"
	/** Trading */
	| "trading"
	/** Travel */
	| "travel"
	/** Vas */
	| "vas"
	/** Video Games */
	| "video_games"
	/** Webinars */
	| "webinars";

/** The collection type for an information request item */
export type InformationRequestItemCollectionType = "multi" | "none" | "single";

/** The format of the text for an information request item */
export type InformationRequestItemTextFormat =
	| "email"
	| "phone"
	| "plain"
	| "url";

/** The statuses an information request can have */
export type InformationRequestStatus =
	| "awaiting_review"
	| "canceled"
	| "completed"
	| "requires_collection";

/** The different error codes for instant payouts */
export type InstantPayoutErrorCodes =
	/** Account Daily Limit Reached */
	| "account_daily_limit_reached"
	/** Amount Too High */
	| "amount_too_high"
	/** Feature Disabled */
	| "feature_disabled"
	/** Only Us Accounts */
	| "only_us_accounts"
	/** Only Usd */
	| "only_usd"
	/** Platform Daily Limit Reached */
	| "platform_daily_limit_reached"
	/** Restricted Account */
	| "restricted_account"
	/** Unsupported External Account */
	| "unsupported_external_account";

/** The properties of the access pass to create for this invoice. */
export interface InvoiceAccessPassInput {
	/** The ID of the product tax code to apply to this access pass. */
	productTaxCodeId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The title of the access pass. */
	title: Scalars["String"]["input"];
}

/** The method of collection for an invoice. */
export type InvoiceCollectionMethods =
	/** Charge a specific payment method for a customer. */
	| "charge_automatically"
	/** Send an invoice to the customer via email. */
	| "send_invoice";

/** The properties of the plan to create for this invoice. */
export interface InvoicePlanInput {
	/** Whether or not ACH payments are accepted */
	achPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The respective currency identifier for the plan. */
	baseCurrency?: InputMaybe<Currencies>;
	/** The interval at which the plan charges (renewal plans). */
	billingPeriod?: InputMaybe<Scalars["Int"]["input"]>;
	/** Whether or not card payments are accepted */
	cardPayments?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Marks whether coinbase commerce payments are/aren't accepted. */
	coinbaseCommerceAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** An array of custom field objects. */
	customFields?: InputMaybe<Array<CustomFieldInput>>;
	/** The description of the plan. */
	description?: InputMaybe<Scalars["String"]["input"]>;
	/** The interval at which the plan charges (expiration plans). */
	expirationDays?: InputMaybe<Scalars["Int"]["input"]>;
	/** An additional amount charged upon first purchase. */
	initialPrice?: InputMaybe<Scalars["StringFloat"]["input"]>;
	/** A personal description or notes section for the business. */
	internalNotes?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not to offer a discount to cancel a subscription. */
	offerCancelDiscount?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Marks whether paypal payments are/aren't accepted. */
	paypalAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Indicates if the plan is a one time payment or recurring. */
	planType?: InputMaybe<PlanTypes>;
	/** Marks whether platform balance payments are/aren't accepted. */
	platformBalanceAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The URL to redirect the customer to after purchase. */
	redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** This is the release method the business uses to sell this plan. */
	releaseMethod?: InputMaybe<ReleaseMethod>;
	/** Configurable settings on how this plan is released. */
	releaseMethodSettings?: InputMaybe<ReleaseMethodSettingsInput>;
	/** The amount the customer is charged every billing period. */
	renewalPrice?: InputMaybe<Scalars["StringFloat"]["input"]>;
	/** The number of payments required before pausing the subscription. */
	splitPayRequiredPayments?: InputMaybe<Scalars["Int"]["input"]>;
	/** Marks whether payments using splitit, a payment processor, are/aren't accepted for the plan. */
	splititAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The number of units available for purchase. */
	stock?: InputMaybe<Scalars["Int"]["input"]>;
	/** The number of free trial days added before a renewal plan. */
	trialPeriodDays?: InputMaybe<Scalars["Int"]["input"]>;
	/** Limits/doesn't limit the number of units available for purchase. */
	unlimitedStock?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Shows or hides the plan from public/business view. */
	visibility?: InputMaybe<Visibility>;
}

/** The different statuses an invoice can be in */
export type InvoiceStatuses =
	/** Open */
	| "open"
	/** Paid */
	| "paid"
	/** Past Due */
	| "past_due"
	/** Void */
	| "void";

/** Filters for the invoices table. */
export interface InvoicesFiltersInput {
	/** The access pass IDs to filter the invoices by */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The collection methods to filter the invoices by */
	collectionMethods?: InputMaybe<Array<InvoiceCollectionMethods>>;
	/** The statuses to filter the invoices by */
	statuses?: InputMaybe<Array<InvoiceStatuses>>;
}

/** Which columns can be used to sort. */
export type InvoicesSortableColumns = "created_at" | "due_date" | "id";

/** A type of order that the ItemOrdering represents. */
export type ItemOrderingOrderTypes =
	/** Experience */
	| "experience"
	/** Hub Creator */
	| "hub_creator"
	/** Hub Customer */
	| "hub_customer";

/** The available languages for a course */
export type Languages =
	/** Bg */
	| "bg"
	/** Ca */
	| "ca"
	/** Cs */
	| "cs"
	/** Da */
	| "da"
	/** De */
	| "de"
	/** El */
	| "el"
	/** En */
	| "en"
	/** Es */
	| "es"
	/** Fi */
	| "fi"
	/** Fr */
	| "fr"
	/** Hr */
	| "hr"
	/** It */
	| "it"
	/** Nl */
	| "nl"
	/** No */
	| "no"
	/** Pl */
	| "pl"
	/** Pt */
	| "pt"
	/** Ro */
	| "ro"
	/** Ru */
	| "ru"
	/** Sk */
	| "sk"
	/** Sv */
	| "sv"
	/** Tr */
	| "tr"
	/** Uk */
	| "uk";

/** The different types of leaderboards that can be fetched */
export type LeaderboardTypes =
	| "affiliate_earnings"
	| "average_time_spent"
	| "money_earned_last_7_days"
	| "money_earned_last_24_hours"
	| "money_earned_last_30_days"
	| "new_users"
	| "top_rated"
	| "total_time_spent"
	| "usd_gmv"
	| "whop_partners_earnings_last_30_days"
	| "whop_partners_gtv_last_30_days";

/** Which columns can be used to sort. */
export type LeadsSortableColumns = "created_at" | "id";

/** The different statuses a LedgerAccountAudit can be */
export type LedgerAccountAuditStatuses =
	/** Requested More Information */
	| "requested_more_information"
	/** Reserves Imposed */
	| "reserves_imposed";

/** The standing of a ledger account, based on their dispute risk scores */
export type LedgerAccountStandings = "at_risk" | "good";

/** The types of ledgers that can be created. */
export type LedgerTypes =
	/** Pool */
	| "pool"
	/** Primary */
	| "primary";

/** The different withdrawal frequencies a LedgerAccount can have */
export type LedgerWithdrawalFrequencies =
	/** Daily */
	| "daily"
	/** Manual */
	| "manual"
	/** Monthly */
	| "monthly"
	/** Weekly */
	| "weekly";

/** The different statuses a LedgerAccount's withdrawal_status can be */
export type LedgerWithdrawalStatuses =
	/** Active */
	| "active"
	/** Inactive */
	| "inactive";

/** The available types for a lesson */
export type LessonTypes =
	/** Knowledge check */
	| "knowledge_check"
	/** Multi */
	| "multi"
	/** Pdf */
	| "pdf"
	/** Quiz */
	| "quiz"
	/** Text */
	| "text"
	/** Video */
	| "video";

/** The available visibilities for a lesson. Determines how / whether a lesson is visible to users. */
export type LessonVisibilities =
	/** Hidden */
	| "hidden"
	/** Visible */
	| "visible";

/** The order to sort liked discover access passes by. */
export type LikedDiscoverAccessPassesOrder =
	/** Sort by promo code presence first, then rated at date */
	| "promo_code_and_rated_at"
	/** Sort by when the access pass was rated */
	| "rated_at";

/** Input for a link embed */
export interface LinkEmbedInput {
	/** The URL of the linked content */
	url: Scalars["String"]["input"];
}

/** Possible livestream destinations a user can restream to */
export type LivestreamDestination =
	/** Facebook */
	| "facebook"
	/** Instagram */
	| "instagram"
	/** Kick */
	| "kick"
	/** Rumble */
	| "rumble"
	/** Steam */
	| "steam"
	/** Telegram */
	| "telegram"
	/** Twitch */
	| "twitch"
	/** Vimeo */
	| "vimeo"
	/** X */
	| "x"
	/** Youtube */
	| "youtube";

/** Input for a livestream feed */
export interface LivestreamFeedInput {
	/** Whether or not media is banned in this livestream */
	banMedia?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether or not URLs are banned in this livestream */
	banUrls?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** List of banned words in this livestream */
	bannedWords?: InputMaybe<Array<Scalars["String"]["input"]>>;
	/** The description of this livestream */
	description?: InputMaybe<Scalars["String"]["input"]>;
	/** The empty timeout of this livestream */
	emptyTimeout?: InputMaybe<Scalars["Int"]["input"]>;
	/** The unique identifier for the feed */
	id?: InputMaybe<Scalars["ID"]["input"]>;
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The number of participants that can join the livestream (0 is unlimited) */
	maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
	/** The metadata of this livestream */
	metadata?: InputMaybe<Scalars["JSON"]["input"]>;
	/** Whether or not live reactions are enabled in this livestream */
	reactionsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The destinations to restream to */
	restreamDestinations?: InputMaybe<Array<LivestreamDestination>>;
	/** The scheduled time of this livestream */
	scheduledAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The title of this livestream */
	title?: InputMaybe<Scalars["String"]["input"]>;
	/** The number of seconds a user needs to wait before posting again, if any */
	userPostsCooldownSeconds?: InputMaybe<Scalars["Int"]["input"]>;
	/** Who can post on this livestream */
	whoCanPost?: InputMaybe<LivestreamWhoCanPostTypes>;
	/** Who can react on this livestream */
	whoCanReact?: InputMaybe<LivestreamWhoCanReactTypes>;
}

/** The status of a livestream recording */
export type LivestreamRecordingStatus =
	/** Completed */
	| "completed"
	/** Failed */
	| "failed"
	/** Processing */
	| "processing"
	/** Recording */
	| "recording";

/** Who can post on a livestream feed */
export type LivestreamWhoCanPostTypes = "admins" | "everyone";

/** Who can react on a livestream feed */
export type LivestreamWhoCanReactTypes = "everyone" | "no_one";

/** Values to filter made for you affiliates on */
export interface MadeForYouPlanFilters {
	/** Search by plan name, product name, or company name */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The sub-items that should be displayed for the stripe account. */
export type ManagementItems =
	| "billing_details"
	| "country"
	| "merchant_of_record"
	| "payout_frequency";

/** Autogenerated input type of MarkLessonAsCompleted */
export interface MarkLessonAsCompletedInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the lesson to mark as completed */
	lessonId: Scalars["ID"]["input"];
}

/** The columns that can be used to order. */
export type MarketplaceCategoryOrder =
	| "created_at"
	| "id"
	| "live_access_pass_count"
	| "live_page_count"
	| "manual_position"
	| "name"
	| "random";

/** The marketplace types that are available for categories. */
export type MarketplaceCategoryTypes =
	/** App */
	| "app"
	/** Regular */
	| "regular";

/** The available marketplace statuses to choose from. */
export type MarketplaceStatuses =
	| "live_marketplace"
	| "not_available"
	| "pending_review";

export type Media = "audio" | "image" | "other" | "video";

/** The different most recent actions a member can have. */
export type MemberMostRecentActions =
	/** Canceling */
	| "canceling"
	/** Churned */
	| "churned"
	/** Drafted */
	| "drafted"
	/** Expiring */
	| "expiring"
	/** Finished Split Pay */
	| "finished_split_pay"
	/** Joined */
	| "joined"
	/** Left */
	| "left"
	/** Paid Once */
	| "paid_once"
	/** Paid Subscriber */
	| "paid_subscriber"
	/** Past Due */
	| "past_due"
	/** Paused */
	| "paused"
	/** Pending Entry */
	| "pending_entry"
	/** Renewing */
	| "renewing"
	/** Trialing */
	| "trialing";

/** The different statuses a Member can have. */
export type MemberStatuses =
	/** Drafted */
	| "drafted"
	/** Joined */
	| "joined"
	/** Left */
	| "left";

/** The type of subtext to display for a member */
export type MemberSubtextTypes =
	/** Canceled On */
	| "canceled_on"
	/** Canceling On */
	| "canceling_on"
	/** Ending On */
	| "ending_on"
	/** Finished Split Pay At */
	| "finished_split_pay_at"
	/** Next Payment Attempt */
	| "next_payment_attempt"
	/** Past Due */
	| "past_due"
	/** Paused At */
	| "paused_at"
	/** Renewing On */
	| "renewing_on"
	/** Trial Canceling On */
	| "trial_canceling_on"
	/** Trial Ends At */
	| "trial_ends_at"
	/** Unresolved At */
	| "unresolved_at";

/** Filters for the members table. */
export interface MembersFiltersInput {
	/** The access pass IDs to filter the members by */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The end date to filter the members by */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The membership status to filter the members by */
	membershipStatus?: InputMaybe<MembershipStatus>;
	/** The most recent actions to filter the members by */
	mostRecentActions?: InputMaybe<Array<MemberMostRecentActions>>;
	/** The plan IDs to filter the members by */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The promo code IDs to filter the members by */
	promoCodeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/**
	 * The name, username, or email to filter the members by. The email filter will
	 * only apply if the current actor has the `member:email:read` permission.
	 */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** The start date to filter the members by */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The statuses to filter the members by */
	statuses?: InputMaybe<Array<MemberStatuses>>;
	/** The tracking link IDs to filter the members by */
	trackingLinkIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}

/** Which columns can be used to sort. */
export type MembersSortableColumns =
	| "created_at"
	| "id"
	| "joined_at"
	| "most_recent_action"
	| "usd_total_spent";

/** The actions that can be performed on a membership */
export type MembershipActions =
	| "add_discord_roles"
	| "add_free_days"
	| "cancel_membership"
	| "fulfill_trading_view_indicators"
	| "pause_subscription_payments"
	| "reset_license"
	| "retry_payment"
	| "shuffle_license"
	| "terminate_membership"
	| "unlink_discord"
	| "unpause_subscription_payments";

/** The state of a membership, based on a company's accepted sub statuses. */
export type MembershipHeaderStatus = "active" | "churned";

/** Image styles for membership. */
export type MembershipImageStyles = "s40";

/** The payment processor used for a membership */
export type MembershipPaymentProcessor =
	/** Apple */
	| "apple"
	/** Coinbase */
	| "coinbase"
	/** Crypto */
	| "crypto"
	/** Free */
	| "free"
	/** Multi Psp */
	| "multi_psp"
	/** Paypal */
	| "paypal"
	/** Platform Balance */
	| "platform_balance"
	/** Sezzle */
	| "sezzle"
	/** Splitit */
	| "splitit"
	/** Stripe */
	| "stripe";

/** Whether or not to send push notifications to the user of a membership */
export type MembershipPushNotification =
	/** Disabled */
	| "disabled"
	/** Enabled */
	| "enabled";

/** The status of a membership */
export type MembershipStatus =
	/** Active */
	| "active"
	/** Canceled */
	| "canceled"
	/** Completed */
	| "completed"
	/** Drafted */
	| "drafted"
	/** Expired */
	| "expired"
	/** Past Due */
	| "past_due"
	/** Trialing */
	| "trialing"
	/** Unresolved */
	| "unresolved";

/** Filters for the memberships table. */
export interface MembershipsFiltersInput {
	/** The access pass IDs to filter the memberships by */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The access pass types to filter the memberships by */
	accessPassTypes?: InputMaybe<Array<AccessPassTypes>>;
	/** The cancelation reasons to filter the memberships by */
	cancelationReasons?: InputMaybe<Array<CancelOptions>>;
	/** The end date to filter the memberships by */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** Whether the memberships have a cancelation reason */
	hasCancelationReason?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The header filter to filter the memberships by */
	headerFilter?: InputMaybe<MembershipHeaderStatus>;
	/** The membership status to filter the memberships by */
	membershipStatus?: InputMaybe<HubMembershipStatus>;
	/** The plan IDs to filter the memberships by */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The promo code IDs to filter the memberships by */
	promoCodeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The start date to filter the memberships by */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The statuses to filter the memberships by */
	statuses?: InputMaybe<Array<MembershipStatus>>;
	/** The tracking link IDs to filter the memberships by */
	trackingLinkIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}

/** Which columns can be used to sort. */
export type MembershipsSortableColumns =
	| "canceled_at"
	| "created_at"
	| "date_joined"
	| "id"
	| "status"
	| "total_spend";

/** The different moderation results for an attachment */
export type ModerationResults =
	/** Nsfw */
	"nsfw";

/** Autogenerated input type of MoveCourse */
export interface MoveCourseInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the course to move */
	courseId: Scalars["ID"]["input"];
	/** The experience to move the course into */
	destinationExperienceId: Scalars["ID"]["input"];
}

/** Input for a feed muted member */
export interface MutedUserInput {
	/** The ID of the feed */
	feedId: Scalars["ID"]["input"];
	/** The feed type */
	feedType?: FeedTypes;
	/** The unique identifier for the muted user */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The time the user is muted till */
	mutedUntil?: InputMaybe<Scalars["Float"]["input"]>;
	/** The ID of the user */
	userId: Scalars["ID"]["input"];
}

/** Mux asset statuses */
export type MuxAssetStatuses =
	/** Created */
	| "created"
	/** Ready */
	| "ready"
	/** Uploading */
	| "uploading";

/** The different types of Stripe Accounts. */
export type NormalizedAccountTypes =
	| "custom"
	| "express"
	| "personal"
	| "standard"
	| "whop_credit";

/** The channel for a notification preference */
export type NotificationPreferenceChannel =
	/** In App */
	| "in_app"
	/** Mobile */
	| "mobile";

/** Values to filter preferences on */
export interface NotificationPreferencesFilters {
	/** The channel to retrieve a user's preferences for */
	channel?: InputMaybe<NotificationPreferenceChannel>;
	/** The company to retrieve a user's preferences for */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The company team ID to retrieve a user's preferences for */
	companyTeamId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The experience to retrieve a user's preferences for */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The topic to retrieve a user's preferences for */
	topicId?: InputMaybe<Scalars["ID"]["input"]>;
}

/** Values to filter preferences on */
export interface NotificationPreferencesFiltersV3 {
	/** The channel to retrieve a user's preferences for */
	channel?: InputMaybe<NotificationPreferenceChannel>;
	/** The company to retrieve a user's preferences for */
	companyId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The company team ID to retrieve a user's preferences for */
	companyTeamId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The experience to retrieve a user's preferences for */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The topic to retrieve a user's preferences for */
	topicId?: InputMaybe<Scalars["ID"]["input"]>;
}

/** The status of the notification topic. If it's active, they will send. */
export type NotificationTopicStatus =
	/** Active */
	| "active"
	/** Inactive */
	| "inactive";

/** The type for the notification topic. */
export type NotificationTopicTypes =
	/** Company */
	| "company"
	/** Company Team */
	| "company_team"
	/** User */
	| "user";

/** The visibility of the notification topic. If it's hidden, it won't show on the UI. */
export type NotificationTopicVisibility =
	/** Hidden */
	| "hidden"
	/** Visible */
	| "visible";

/** Values to filter notifications on */
export interface NotificationsV4Filters {
	/**
	 * The client's last fetched at timestamp. If passed will only return
	 * notifications created after this timestamp. NOT YET IMPLEMENTED
	 */
	clientLastFetchedAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The company ID that you want to filter by. Will return notifications sent to this team. */
	companyTeamId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The experience ID that you want to filter by */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The experience IDs that you want to filter by. Overrides experience_id. */
	experienceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** Whether the notifications are mentions or not */
	isMention?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether to only return unread notifications */
	unreadOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
}

/** Values to paginate notifications on */
export interface NotificationsV4Pagination {
	/** Filter all notifications made after this */
	after?: InputMaybe<Scalars["ID"]["input"]>;
	/** Filter all notifications made before this */
	before?: InputMaybe<Scalars["ID"]["input"]>;
	/** The number of notifications to return. Default is 50 */
	limit?: InputMaybe<Scalars["Int"]["input"]>;
}

/** The different providers that can be used for onboarding a ledger account. */
export type OnboardingProviders = "generic" | "stripe";

/** The different onboarding types for a company. */
export type OnboardingTypes =
	/** Payments */
	| "payments"
	/** Products */
	| "products";

/** The different variants of OpenGraph images for a company. */
export type OpengraphImageVariants =
	/** Black */
	| "black"
	/** Orange */
	| "orange"
	/** White */
	| "white";

/** The account_types for a payment account object */
export type PaymentAccountAccountTypes =
	/** Custom */
	| "custom"
	/** Express */
	| "express"
	/** Personal */
	| "personal"
	/** Platform Managed */
	| "platform_managed"
	/** Standard */
	| "standard"
	/** Whop Credit */
	| "whop_credit";

/** The different action banners that can be shown for a payment account */
export type PaymentAccountActionBanners = "requires_additional_information";

/** The providers for a payment account object */
export type PaymentAccountProviders =
	/** Coinbase */
	| "coinbase"
	/** Paypal */
	| "paypal"
	/** Stripe */
	| "stripe";

/** The different statuses for a payment account object */
export type PaymentAccountStatuses =
	/** Broken */
	| "broken"
	/** Connected */
	| "connected"
	/** Disabled By Whop */
	| "disabled_by_whop"
	/** Missing Settlement Address */
	| "missing_settlement_address"
	/** Needs Completion */
	| "needs_completion"
	/** Needs Reauthorization */
	| "needs_reauthorization"
	/** Oauth Integration Not Found */
	| "oauth_integration_not_found"
	/** Payments Not Receivable */
	| "payments_not_receivable"
	/** Primary Email Not Confirmed */
	| "primary_email_not_confirmed"
	/** Reconnect Api Keys */
	| "reconnect_api_keys"
	/** Rejected */
	| "rejected"
	/** Requirements Not Met */
	| "requirements_not_met"
	/** Setup */
	| "setup"
	/** Under Review */
	| "under_review"
	/** Webhook Not Verified */
	| "webhook_not_verified";

/** The high level payment processor options. */
export type PaymentMethods =
	/** Apple */
	| "apple"
	/** Coinbase */
	| "coinbase"
	/** Crypto */
	| "crypto"
	/** Free */
	| "free"
	/** Multi Psp */
	| "multi_psp"
	/** Nft */
	| "nft"
	/** Paypal */
	| "paypal"
	/** Platform Balance */
	| "platform_balance"
	/** Sezzle */
	| "sezzle"
	/** Splitit */
	| "splitit"
	/** Stripe */
	| "stripe";

/** The high level payment processor options. */
export type PaymentProcessor =
	| "apple"
	| "coinbase"
	| "free"
	| "multi_psp"
	| "paypal"
	| "platform_balance"
	| "sezzle"
	| "splitit"
	| "stripe"
	| "venmo";

/** The different payment providers. */
export type PaymentProviders =
	/** Apple */
	| "apple"
	/** Coinbase */
	| "coinbase"
	/** Multi Psp */
	| "multi_psp"
	/** Paypal */
	| "paypal"
	/** Platform Balance */
	| "platform_balance"
	/** Sezzle */
	| "sezzle"
	/** Splitit */
	| "splitit"
	/** Stripe */
	| "stripe";

/** The different providers of payment transactions. */
export type PaymentTransactionProviders =
	/** Multi Psp */
	| "multi_psp"
	/** Splitit */
	| "splitit";

/** The different statuses a payment transaction can be in. */
export type PaymentTransactionStatuses =
	/** Created */
	| "created"
	/** Declined */
	| "declined"
	/** Error */
	| "error"
	/** Expired */
	| "expired"
	/** Lost */
	| "lost"
	/** Pending */
	| "pending"
	/** Rejected */
	| "rejected"
	/** Succeeded */
	| "succeeded"
	/** Won */
	| "won";

/** The different types of payment transactions. */
export type PaymentTransactionTypes =
	/** Authorization */
	| "authorization"
	/** Authorize */
	| "authorize"
	/** Cancel */
	| "cancel"
	/** Capture */
	| "capture"
	/** Chargeback */
	| "chargeback"
	/** Fraud Screening */
	| "fraud_screening"
	/** Installment */
	| "installment"
	/** Purchase */
	| "purchase"
	/** Refund */
	| "refund"
	/** Three D Secure */
	| "three_d_secure"
	/** Verify */
	| "verify";

/** The different approval statuses an account can have. */
export type PaymentsApprovalStatuses =
	/** Approved */
	| "approved"
	/** Monitoring */
	| "monitoring"
	/** Pending */
	| "pending"
	/** Rejected */
	| "rejected";

/** The different providers a payout account can be. */
export type PayoutAccountProviders =
	/** Masspay */
	"masspay";

/** The different statuses payout account can be. */
export type PayoutAccountStatuses =
	/** Connected */
	| "connected"
	/** Disabled */
	| "disabled"
	/** Needs Completion */
	| "needs_completion";

/** The different delivery_types for a payout or payout destination. */
export type PayoutDeliveryTypes =
	/** Bank Deposit */
	| "bank_deposit"
	/** Bill */
	| "bill"
	/** Cash Pickup */
	| "cash_pickup"
	/** Cryptocurrency */
	| "cryptocurrency"
	/** Home Delivery */
	| "home_delivery"
	/** Masspay Card */
	| "masspay_card"
	/** Mobile Wallet */
	| "mobile_wallet"
	/** Paper Check */
	| "paper_check";

/** The different platform statuses a payout destination can be in. */
export type PayoutDestinationPlatformStatuses =
	/** Hidden */
	| "hidden"
	/** Visible */
	| "visible";

/** The different providers a payout destination can be. */
export type PayoutDestinationProviders =
	/** Masspay */
	"masspay";

/** The different statuses a payout destination can be in. */
export type PayoutDestinationStatuses =
	/** Active */
	| "active"
	/** Disabled */
	| "disabled";

/** The different destination types for a payout destination. */
export type PayoutDestinationTypes =
	/** Instant */
	| "instant"
	/** Regular */
	| "regular";

/** The different error codes a payout can be in. */
export type PayoutErrorCodes =
	/** Account Closed */
	| "account_closed"
	/** Account Does Not Exist */
	| "account_does_not_exist"
	/** Account Information Invalid */
	| "account_information_invalid"
	/** Amount Out Of Bounds */
	| "amount_out_of_bounds"
	/** Attributes Not Validated */
	| "attributes_not_validated"
	/** B2b Payments Prohibited */
	| "b2b_payments_prohibited"
	/** Bank Statement Required */
	| "bank_statement_required"
	/** Compliance Review */
	| "compliance_review"
	/** Deposit Failed */
	| "deposit_failed"
	/** Deposit Rejected */
	| "deposit_rejected"
	/** Destination Unavailable */
	| "destination_unavailable"
	/** Exceeded Account Limit */
	| "exceeded_account_limit"
	/** Expired Quote */
	| "expired_quote"
	/** Generic Payout Error */
	| "generic_payout_error"
	/** Identification Number Invalid */
	| "identification_number_invalid"
	/** Invalid Account Number */
	| "invalid_account_number"
	/** Invalid Bank Code */
	| "invalid_bank_code"
	/** Invalid Beneficiary */
	| "invalid_beneficiary"
	/** Invalid Branch Number */
	| "invalid_branch_number"
	/** Invalid Phone Number */
	| "invalid_phone_number"
	/** Invalid Routing Number */
	| "invalid_routing_number"
	/** Invalid Swift Code */
	| "invalid_swift_code"
	/** Misc Error */
	| "misc_error"
	/** Missing City And Country */
	| "missing_city_and_country"
	/** Missing Phone Number */
	| "missing_phone_number"
	/** Missing Remittance Info */
	| "missing_remittance_info"
	/** Receiving Account Locked */
	| "receiving_account_locked"
	/** Rejected By Compliance */
	| "rejected_by_compliance"
	/** Source Token Insufficient Funds */
	| "source_token_insufficient_funds"
	/** Ssn Invalid */
	| "ssn_invalid"
	/** Wallet Screenshot Required */
	| "wallet_screenshot_required";

/** The interval at which a Connected Account is paid out */
export type PayoutIntervals = "daily" | "manual" | "monthly" | "weekly";

/** The payout methods that can be configured for a company. */
export type PayoutMethods = "coinbase_commerce" | "paypal" | "stripe";

/** The different statuses as payout object can be. */
export type PayoutStatuses =
	/** Canceled */
	| "canceled"
	/** Completed */
	| "completed"
	/** Error */
	| "error"
	/** Expired */
	| "expired"
	/** Hold */
	| "hold"
	/** Pending */
	| "pending"
	/** Processing */
	| "processing"
	/** Ready For Pickup */
	| "ready_for_pickup"
	/** Scheduled */
	| "scheduled";

/** The different types of attributes that can be saved for a PayoutTokenAttribute. */
export type PayoutTokenAttributeDataTypes =
	/** Address1 */
	| "Address1"
	/** Bank Account Branch Number */
	| "BankAccountBranchNumber"
	/** Bank Account Name */
	| "BankAccountName"
	/** Bank Account Number */
	| "BankAccountNumber"
	/** Bank Account Type */
	| "BankAccountType"
	/** Bank City */
	| "BankCity"
	/** Bank Name */
	| "BankName"
	/** Bank Routing Number */
	| "BankRoutingNumber"
	/** Bank State */
	| "BankState"
	/** Bill Reference Number */
	| "BillReferenceNumber"
	/** Birth Country */
	| "BirthCountry"
	/** Card Expiration */
	| "CardExpiration"
	/** Card Number */
	| "CardNumber"
	/** Card Zip */
	| "CardZip"
	/** City */
	| "City"
	/** Country */
	| "Country"
	/** Date Of Birth */
	| "DateOfBirth"
	/** Employment Address */
	| "EmploymentAddress"
	/** Employment Name */
	| "EmploymentName"
	/** Employment Occupation */
	| "EmploymentOccupation"
	/** Employment Phone */
	| "EmploymentPhone"
	/** Employment Supervisor */
	| "EmploymentSupervisor"
	/** Gender */
	| "Gender"
	/** Guardian Consent */
	| "GuardianConsent"
	/** Guardian Full Name */
	| "GuardianFullName"
	/** Guardian Gov Id Number */
	| "GuardianGovIDNumber"
	/** Guardian Gov Id Type */
	| "GuardianGovIDType"
	/** Id Selfie Collection */
	| "IDSelfieCollection"
	/** I Frame Payment Collection */
	| "IFramePaymentCollection"
	/** Identification Expiration */
	| "IdentificationExpiration"
	/** Identification Number */
	| "IdentificationNumber"
	/** Identification Type */
	| "IdentificationType"
	/** Maiden Name */
	| "MaidenName"
	/** Phone Number */
	| "PhoneNumber"
	/** Postal Code */
	| "PostalCode"
	/** Relationship */
	| "Relationship"
	/** Remittance Reason */
	| "RemittanceReason"
	/** Swift */
	| "SWIFT"
	/** Second Last Name */
	| "SecondLastName"
	/** Social Security */
	| "SocialSecurity"
	/** Source Of Funds */
	| "SourceOfFunds";

/** The different types of inputs for a payout token attribute. This is the type of form that will be submitted in the data. */
export type PayoutTokenAttributeInputTypes =
	/** Date */
	| "date"
	/** Options */
	| "options"
	/** Text */
	| "text";

/** The type of information being submitted in the value field. */
export type PayoutTokenAttributeValueTypes = "raw" | "vault_token";

/** The different providers a payout token can be. */
export type PayoutTokenProviders =
	/** Masspay */
	"masspay";

/** The different statuses a payout token can have. */
export type PayoutTokenStatuses =
	/** Active */
	| "active"
	/** Broken */
	| "broken"
	/** Created */
	| "created";

/** Whether a payout is one-time or recurring */
export type PayoutTypes =
	/** Flat Fee */
	| "flat_fee"
	/** Percentage */
	| "percentage";

/** Statuses for paypal accounts */
export type PaypalAccountStatuses =
	| "broken"
	| "connected"
	| "disabled_by_whop"
	| "oauth_integration_not_found"
	| "payments_not_receivable"
	| "primary_email_not_confirmed";

/** The status of an entry for a perk. */
export type PerkStatus = "completed" | "pending";

/** The type of direct link to generate */
export type PlanDirectLink = "checkout" | "product_page";

/** Values to filter plans on */
export interface PlanFilters {
	/** A specific access pass to filter the scope by. */
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	/** If true, it returns plans that have affiliates */
	affiliates?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What to order the results by. */
	order?: InputMaybe<PlanOrder>;
	/** If true, it returns plans that have member/passholder affiliates set to true */
	passholderAffiliate?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** If true, it returns raffles that have ended. */
	raffleEnded?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The release method to filter the scope by. */
	releaseMethod?: InputMaybe<ReleaseMethod>;
	/** The visibility to filter the scope by. */
	visibility?: InputMaybe<VisibilityFilter>;
}

/** The order to sort the results by. */
export type PlanOrder =
	| "active_memberships_count"
	| "affiliates"
	| "created_at"
	| "expires_at"
	| "internal_notes";

/** The type of plan that can be attached to an access pass */
export type PlanTypes =
	/** One Time */
	| "one_time"
	/** Renewal */
	| "renewal";

/** The ways a relation of Plans can be ordered */
export type PlansOrder =
	| "active_members_count"
	| "created_at"
	| "expires_at"
	| "id"
	| "internal_notes";

/** Which columns can be used to sort. */
export type PlansSortableColumns =
	| "active_members_count"
	| "active_memberships_count"
	| "cached_initial_price_due"
	| "cached_usd_income"
	| "created_at"
	| "id"
	| "stock";

/** Input type for creating a poll in a feed post */
export interface PollInput {
	/** The options for the poll. Must have sequential IDs starting from 1 */
	options: Array<PollOptionInput>;
}

/** Input type for a single poll option */
export interface PollOptionInput {
	/** Sequential ID for the poll option (starting from '1') */
	id: Scalars["String"]["input"];
	/** The text of the poll option */
	text: Scalars["String"]["input"];
}

/** The type of feed to fetch from */
export type PostTypes =
	/** Dms */
	| "dms"
	/** Dms Post */
	| "dms_post"
	/** Forum Post */
	| "forum_post";

/** Autogenerated input type of ProcessEntities */
export interface ProcessEntitiesInput {
	/** The ID of the app */
	appId: Scalars["ID"]["input"];
	/** The chat feed posts to process */
	chatFeeds?: InputMaybe<Array<ChatFeedInput>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The DMs feed members to process */
	dmsFeedMembers?: InputMaybe<Array<DmsFeedMemberInput>>;
	/** The DMs feeds to process */
	dmsFeeds?: InputMaybe<Array<DmsFeedInput>>;
	/** The DMs posts to process */
	dmsPosts?: InputMaybe<Array<DmsPostInput>>;
	/** The livestream feeds to process */
	livestreamFeeds?: InputMaybe<Array<LivestreamFeedInput>>;
	/** The chat feed muted members to process */
	mutedUsers?: InputMaybe<Array<MutedUserInput>>;
	/** The reactions to process */
	reactions?: InputMaybe<Array<ReactionInput>>;
}

/** Types of product highlight */
export type ProductHighlightTypes =
	| "benefit"
	| "pricing_feature"
	| "qualification"
	| "who_this_is_for";

/** Image styles for product. */
export type ProductImageStyles =
	| "s48"
	| "s48fit"
	| "s64"
	| "s64fit"
	| "s80"
	| "s80fit"
	| "s128"
	| "s180"
	| "s250x125"
	| "s250x125fit"
	| "s440x220"
	| "s440x220fit"
	| "s500x250"
	| "s500x250fit"
	| "s512x288"
	| "s512x288fit"
	| "s600x400"
	| "s600x400fit"
	| "s1000x500"
	| "s1000x500fit"
	| "s1280x720"
	| "s1280x720fit"
	| "s1920x1080"
	| "s1920x1080fit";

/** The product_type of the ProductTaxCode */
export type ProductTaxCodeProductTypes = "digital" | "physical" | "services";

/** Values to filter users on */
export interface ProductUserFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What to order the results by. */
	order?: InputMaybe<ProductUserOrder>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The order to sort the results by. */
export type ProductUserOrder =
	| "date_joined"
	| "last_seen_at"
	| "name"
	| "paid_out_by_company"
	| "time_spent_in_whop";

/** The different levels of visibility for resources */
export type ProfileVisibilities = "hidden" | "visible";

/** Values to filter promo codes on */
export interface PromoCodeFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** Filter whether to return active or expired (archived and inactive). */
	newStatus?: InputMaybe<PromoCodeNewStatus>;
	/** What to order the results by. */
	order?: InputMaybe<PromoCodeOrder>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** The state of promo code. */
	status?: InputMaybe<PromoCodeStatus>;
}

/** The new statuses to filter the results by. */
export type PromoCodeNewStatus = "active" | "expired";

/** The order to sort the results by. */
export type PromoCodeOrder = "code" | "created_at";

/** Statuses for promo codes */
export type PromoCodeStatus =
	/** Active */
	| "active"
	/** Archived */
	| "archived"
	/** Inactive */
	| "inactive";

/** Which columns can be used to sort. */
export type PromoCodesSortableColumns =
	| "created_at"
	| "expiration_datetime"
	| "id";

/** The duration setting for the promo code */
export type PromoDurations =
	/** Forever */
	| "forever"
	/** Once */
	| "once"
	/** Repeating */
	| "repeating";

/** The type of promo code used to discount a plan */
export type PromoTypes =
	/** Flat Amount */
	| "flat_amount"
	/** Percentage */
	| "percentage";

/** Autogenerated input type of PromoteAppBuildToProduction */
export interface PromoteAppBuildToProductionInput {
	/** The ID of the app build to promote. */
	appBuildId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
}

/** The order to sort the results by. */
export type PublicAccessPassesOrder =
	| "average_review_rating"
	| "average_time_spent_24_hours"
	| "created_at"
	| "global_affiliate_percentage"
	| "highest_bounties"
	| "id"
	| "last_24_hours_total_seconds"
	| "most_affiliate_earnings_24_hours"
	| "most_money_made_24_hours"
	| "most_reviews_7_days"
	| "most_reviews_24_hours"
	| "newest_arrivals"
	| "trending"
	| "trending_3_hours";

/** The order to sort the results by. */
export type PublicBountiesOrder = "created_at" | "total_paid";

/** Input for a reaction */
export interface ReactionInput {
	/** The ID of the feed this reaction belongs to */
	feedId: Scalars["ID"]["input"];
	/** The type of the feed this reaction belongs to */
	feedType: FeedTypes;
	/** The unique identifier for the reaction */
	id: Scalars["ID"]["input"];
	/** Whether the entity has been deleted */
	isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The ID of the post this reaction belongs to */
	postId: Scalars["ID"]["input"];
	/** The type of the post (e.g., 'dms_post') */
	postType: PostTypes;
	/** The type of reaction (e.g., 'like', 'vote', 'view', 'emoji') */
	reactionType: ReactionTypes;
	/** The score of the reaction */
	score: Scalars["Int"]["input"];
	/** The value of the reaction (e.g., specific emoji) */
	value: Scalars["String"]["input"];
}

/** The type of reactions */
export type ReactionTypes =
	/** Emoji */
	| "emoji"
	/** Like */
	| "like"
	/** View */
	| "view"
	/** Vote */
	| "vote";

/** The status of the abuse report */
export type ReceiptFeeTypes =
	/** Other Fee */
	| "other_fee"
	/** Processing Fee */
	| "processing_fee"
	/** Whop Fee */
	| "whop_fee";

/** The payment processor of a receipt */
export type ReceiptPaymentProcessor =
	/** Apple */
	| "apple"
	/** Coinbase */
	| "coinbase"
	/** Crypto */
	| "crypto"
	/** Free */
	| "free"
	/** Multi Psp */
	| "multi_psp"
	/** Nft */
	| "nft"
	/** Paypal */
	| "paypal"
	/** Platform Balance */
	| "platform_balance"
	/** Sezzle */
	| "sezzle"
	/** Splitit */
	| "splitit"
	/** Stripe */
	| "stripe";

/** The status of a receipt */
export type ReceiptStatus =
	/** Draft */
	| "draft"
	/** Open */
	| "open"
	/** Paid */
	| "paid"
	/** Pending */
	| "pending"
	/** Uncollectible */
	| "uncollectible"
	/** Unresolved */
	| "unresolved"
	/** Void */
	| "void";

/** The status of a receipt */
export type ReceiptStatusV2 =
	| "failed"
	| "partially_refunded"
	| "past_due"
	| "refunded"
	| "succeeded";

/**
 * The type of tax inclusivity applied to the receipt, for determining whether the
 * tax is included in the final price, or paid on top.
 */
export type ReceiptTaxBehaviors =
	/** Exclusive */
	| "exclusive"
	/** Inclusive */
	| "inclusive"
	/** Unspecified */
	| "unspecified";

/** Values to filter receipts on */
export interface ReceiptV2Filters {
	/** A specific access pass. */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The billing reason for the payment */
	billingReasons?: InputMaybe<Array<BillingReasons>>;
	/** The currency of the payment. */
	currencies?: InputMaybe<Array<Currencies>>;
	/** Which way to order the results. */
	direction?: InputMaybe<Direction>;
	/** To get all memberships created before this certain time. */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** How to order the results. */
	order?: InputMaybe<ReceiptV2Order>;
	/** How the payment was made (method). */
	paymentMethods?: InputMaybe<Array<PaymentMethods>>;
	/** A specific plan. */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** To get all memberships created after this certain time. */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The state of the payment. */
	statuses?: InputMaybe<Array<ReceiptStatusV2>>;
}

/** The order to sort the results by. */
export type ReceiptV2Order = "created_at" | "final_amount" | "paid_at";

/** Which columns can be used to sort. */
export type ReceiptsSortableColumns =
	| "created_at"
	| "final_amount"
	| "id"
	| "paid_at"
	| "presented_final_amount";

/** The different statuses for a Refund object */
export type RefundStatuses =
	| "canceled"
	| "failed"
	| "pending"
	| "requires_action"
	| "succeeded";

/** The methods of how a plan can be released (including raffles and waitlists). */
export type ReleaseMethod =
	/** Buy Now */
	| "buy_now"
	/** Raffle */
	| "raffle"
	/** Waitlist */
	| "waitlist";

export interface ReleaseMethodSettingsInput {
	/** When the raffle will expire */
	expiresAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The maximum number of entries allowed for the raffle or waitlist */
	maxEntries?: InputMaybe<Scalars["Int"]["input"]>;
	/** If this is enabled, the raffle will get entries based off of how many NFTs the user owns */
	nftWeightedEntries?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** When the raffle will start */
	startsAt?: InputMaybe<Scalars["Timestamp"]["input"]>;
}

/** The types of reports that can be generated. */
export type ReportTypes =
	/** Bookmark */
	| "bookmark"
	/** Downvote */
	| "downvote"
	/** Share */
	| "share"
	/** Upvote */
	| "upvote";

/** The different types of actions for a resolution event */
export type ResolutionActions =
	/** Accepted */
	| "accepted"
	/** Appealed */
	| "appealed"
	/** Created */
	| "created"
	/** Denied */
	| "denied"
	/** Dispute Customer Won */
	| "dispute_customer_won"
	/** Dispute Merchant Won */
	| "dispute_merchant_won"
	/** Dispute Opened */
	| "dispute_opened"
	/** Escalated */
	| "escalated"
	/** Requested More Info */
	| "requested_more_info"
	/** Responded */
	| "responded"
	/** Withdrew */
	| "withdrew";

/** The types of responses a customer can make to a resolution. */
export type ResolutionCustomerResponses = "appeal" | "respond" | "withdraw";

/** Filters for the resolutions */
export interface ResolutionFilters {
	/** A specific access pass. */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** Filter by their case state */
	caseState?: InputMaybe<CaseStates>;
	/** The direction to filter */
	direction?: InputMaybe<Direction>;
	/** Filter by the end date */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The order to filter */
	order?: InputMaybe<ResolutionOrder>;
	/** How the payment was made (method). */
	paymentMethods?: InputMaybe<Array<PaymentMethods>>;
	/** The text to search by */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** Filter by the start date */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** Filter by their status */
	statuses?: InputMaybe<Array<ResolutionStatuses>>;
}

/** A reason why a specific receipt cannot have a resolution created. */
export type ResolutionIneligibilityReason =
	| "already_opened"
	| "already_refunded"
	| "free"
	| "not_paid"
	| "out_of_date"
	| "unsupported_payment_processor";

/** The different types of issues a resolution can be */
export type ResolutionIssueTypes =
	/** Forgot To Cancel */
	| "forgot_to_cancel"
	/** Item Not Received */
	| "item_not_received"
	/** Product Unacceptable */
	| "product_unacceptable"
	/** Significantly Not As Described */
	| "significantly_not_as_described"
	/** Unauthorized Transaction */
	| "unauthorized_transaction";

/** The types of responses a merchant can make to a resolution. */
export type ResolutionMerchantResponses =
	| "accept"
	| "appeal"
	| "deny"
	| "request_more_info"
	| "respond";

/** Possible values to filter user on */
export type ResolutionOrder = "due_date" | "id";

/** The types of responses the platform can make to a resolution. */
export type ResolutionPlatformResponses =
	| "merchant_refund"
	| "merchant_wins"
	| "platform_refund"
	| "request_buyer_info"
	| "request_merchant_info";

/** The different types of reporters for a resolution event */
export type ResolutionReporters =
	/** Customer */
	| "customer"
	/** Merchant */
	| "merchant"
	/** Platform */
	| "platform"
	/** System */
	| "system";

/** The statuses a resolution object can have */
export type ResolutionStatuses =
	/** Customer Info Needed */
	| "customer_info_needed"
	/** Customer Response Needed */
	| "customer_response_needed"
	/** Customer Withdrew */
	| "customer_withdrew"
	/** Customer Won */
	| "customer_won"
	/** Merchant Info Needed */
	| "merchant_info_needed"
	/** Merchant Response Needed */
	| "merchant_response_needed"
	/** Merchant Won */
	| "merchant_won"
	/** Under Platform Review */
	| "under_platform_review";

/** Which columns can be used to sort. */
export type ResolutionsSortableColumns = "created_at" | "due_date" | "id";

/** The different reason codes. */
export type RestrictionSetReasonCodes = "blocked_country";

/** Autogenerated input type of RetryPaymentMyMembership */
export interface RetryPaymentMyMembershipInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that this membership is on behalf of. */
	companyBuyerId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the membership to retry the payment for. */
	membershipId: Scalars["ID"]["input"];
}

/** The status of a review report */
export type ReviewReportStatus =
	/** Accepted */
	| "accepted"
	/** Pending */
	| "pending"
	/** Rejected */
	| "rejected";

/** The statuses a review can have */
export type ReviewStatus =
	/** Pending */
	| "pending"
	/** Published */
	| "published"
	/** Removed */
	| "removed";

/** Which columns can be used to sort. */
export type ReviewsSortableColumns = "created_at" | "id" | "stars";

/** The available reward units to choose from. */
export type RewardUnits =
	/** Per Submission */
	| "per_submission"
	/** Per View */
	| "per_view";

/** The status of an RFI */
export type RfiStatuses =
	/** Ignored */
	| "ignored"
	/** Pending Provider */
	| "pending_provider"
	/** Resolved */
	| "resolved"
	/** Waiting For Platform */
	| "waiting_for_platform"
	/** Waiting For User */
	| "waiting_for_user";

/** The level of security an account has */
export type SecurityLevels = "none" | "two_factor";

/** Autogenerated input type of SendMessage */
export interface SendMessageInput {
	/** The attachments for this message, such as videos or images. */
	attachments?: InputMaybe<Array<AttachmentInput>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the chat experience to send the message in. */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the feed to send to. */
	feedId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The type of the feed to send to. */
	feedType?: InputMaybe<FeedTypes>;
	/** The message to send. */
	message: Scalars["String"]["input"];
	/** The user to send the direct message to. */
	toUserId?: InputMaybe<Scalars["ID"]["input"]>;
}

/** Autogenerated input type of SendNotification */
export interface SendNotificationInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company team to send the notification to */
	companyTeamId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The content of the notification */
	content: Scalars["String"]["input"];
	/** The ID of the experience to send the notification to */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** An external ID for the notification */
	externalId?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether the notification is a mention */
	isMention?: InputMaybe<Scalars["Boolean"]["input"]>;
	/**
	 * The link to open when the notification is clicked. If you just want to append
	 * a rest path use the restPath parameter. You can link to any url here.
	 */
	link?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The rest path to append to the generated deep link that opens your app. Use
	 * [restPath] in your app path in the dashboard to read this parameter.
	 */
	restPath?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the user sending the notification */
	senderUserId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The subtitle of the notification */
	subtitle?: InputMaybe<Scalars["String"]["input"]>;
	/** The title of the notification */
	title: Scalars["String"]["input"];
	/** The IDs of the users to send the notification to. */
	userIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
}

/** The status of a simple notification preference */
export type SimpleNotificationPreferenceStatus =
	/** Everything */
	| "everything"
	/** Nothing */
	| "nothing"
	/** Only Mentions */
	| "only_mentions";

/** The different websites you can have social links for */
export type SocialLinkWebsites =
	| "facebook"
	| "instagram"
	| "linkedin"
	| "tiktok"
	| "twitch"
	| "website"
	| "x"
	| "youtube";

/** The origin of the specific fee */
export type SpecificFeeOrigins =
	/** Affiliate Fee */
	| "affiliate_fee"
	/** Apple Processing Fee */
	| "apple_processing_fee"
	/** Billing Percentage Fee */
	| "billing_percentage_fee"
	/** Buyer Fee */
	| "buyer_fee"
	/** Cross Border Percentage Fee */
	| "cross_border_percentage_fee"
	/** Crypto Fee */
	| "crypto_fee"
	/** Dispute Alert Fee */
	| "dispute_alert_fee"
	/** Dispute Fee */
	| "dispute_fee"
	/** Fx Percentage Fee */
	| "fx_percentage_fee"
	/** Marketplace Affiliate Fee */
	| "marketplace_affiliate_fee"
	/** Orchestration Percentage Fee */
	| "orchestration_percentage_fee"
	/** Payment Processing Fixed Fee */
	| "payment_processing_fixed_fee"
	/** Payment Processing Percentage Fee */
	| "payment_processing_percentage_fee"
	/** Paypal Fee */
	| "paypal_fee"
	/** Platform Balance Processing Fee */
	| "platform_balance_processing_fee"
	/** Sales Tax Remittance */
	| "sales_tax_remittance"
	/** Sales Tax Remittance Reversal */
	| "sales_tax_remittance_reversal"
	/** Sezzle Processing Fee */
	| "sezzle_processing_fee"
	/** Splitit Processing Fee */
	| "splitit_processing_fee"
	/** Stripe Billing Fee */
	| "stripe_billing_fee"
	/** Stripe Domestic Processing Fee */
	| "stripe_domestic_processing_fee"
	/** Stripe Fixed Processing Fee */
	| "stripe_fixed_processing_fee"
	/** Stripe International Processing Fee */
	| "stripe_international_processing_fee"
	/** Stripe Payout Fee */
	| "stripe_payout_fee"
	/** Stripe Radar Fee */
	| "stripe_radar_fee"
	/** Stripe Sales Tax Fee */
	| "stripe_sales_tax_fee"
	/** Stripe Standard Processing Fee */
	| "stripe_standard_processing_fee"
	/** Three Ds Fixed Fee */
	| "three_ds_fixed_fee"
	/** Whop Processing Fee */
	| "whop_processing_fee";

/** The configuration for receipts stats query. */
export interface StatsConfigInput {
	/** The access pass ids to filter the data by. */
	accessPassIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The bot ids to filter the data by. */
	botIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The currency to use for the chart. */
	currency?: InputMaybe<Currencies>;
	/** Whether or not to filter data by direct to consumer or marketplace */
	directToConsumer?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The feed ids to filter the data by. */
	feedIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The start date to take into account. */
	from: Scalars["Timestamp"]["input"];
	/** The interval to group the data by. */
	interval?: InputMaybe<ChartIntervals>;
	/** The plan ids to filter the data by. */
	planIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	/** The time zone used for start of day calculations. */
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
	/** The end date to take into account. */
	to: Scalars["Timestamp"]["input"];
	/** The week mode to group the data by. For details, look at https://clickhouse.com/docs/en/sql-reference/functions/date-time-functions#toweek */
	weekMode?: InputMaybe<Scalars["Int"]["input"]>;
}

/** Statuses for resources */
export type Status = "active" | "archived" | "deleted";

/** The available bounty statuses to choose from. */
export type Statuses =
	/** Archived */
	| "archived"
	/** Published */
	| "published";

/** Statuses for stripe accounts */
export type StripeAccountStatuses =
	| "connected"
	| "disabled_by_whop"
	| "needs_completion"
	| "needs_reauthorization"
	| "reconnect_api_keys"
	| "rejected"
	| "requirements_not_met"
	| "under_review";

/** Types of Stripe accounts */
export type StripeAccountTypes =
	| "connect"
	| "custom"
	| "express"
	| "personal"
	| "standard";

/** The status that an external payout account can have */
export type StripeExternalAccountStatuses =
	/** Errored */
	| "errored"
	/** New */
	| "new"
	/** Validated */
	| "validated"
	/** Verification Failed */
	| "verification_failed"
	/** Verified */
	| "verified";

/** The methods that a StripePayout can have */
export type StripePayoutMethods =
	/** Instant */
	| "instant"
	/** Standard */
	| "standard";

/** The payout types that a StripePayout can have */
export type StripePayoutPayoutTypes =
	/** Bank Account */
	| "bank_account"
	/** Card */
	| "card";

/** The status that a StripePayout can have */
export type StripePayoutStatuses =
	/** Canceled */
	| "canceled"
	/** Failed */
	| "failed"
	/** In Transit */
	| "in_transit"
	/** Paid */
	| "paid"
	/** Pending */
	| "pending";

/** The status that a StripePayout's trace can have */
export type StripePayoutTraceStatuses =
	/** Pending */
	| "pending"
	/** Supported */
	| "supported"
	/** Unsupported */
	| "unsupported";

/** Whether or not the tax is included in a plan's price (or if it hasn't been set up) */
export type TaxTypes =
	/** Tax is exclusive in the price of the plan. If its $20 before tax, its $25 after tax. The user is paying tax */
	| "exclusive"
	/** Tax is inclusive in the price of the plan. If its $20, its $20. The company already factored in tax and is paying tax */
	| "inclusive"
	/** The company hasn't set up tax yet */
	| "unspecified";

/** Autogenerated input type of TerminateMyMembership */
export interface TerminateMyMembershipInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that this membership is on behalf of. */
	companyBuyerId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The internal ID of the membership to terminate. */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of TestWebhookV2 */
export interface TestWebhookV2Input {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The event to test the webhook for. */
	event: WebhookEvent;
	/** The ID of the webhook to test. */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of ToggleCancelMyMembership */
export interface ToggleCancelMyMembershipInput {
	/** A multiple choice selection for why the user canceled. */
	cancelOption?: InputMaybe<CancelOptions>;
	/** The custom input from the user for canceling the membership. */
	cancelationReason?: InputMaybe<Scalars["String"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that this membership is on behalf of. */
	companyBuyerId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the membership to cancel at the end of the period. */
	membershipId: Scalars["ID"]["input"];
}

/** The destination of the custom link */
export type TrackingLinkDestination =
	/** Access Pass Page */
	| "access_pass_page"
	/** Bot Page */
	| "bot_page"
	/** Checkout Page */
	| "checkout_page";

/** Which columns can be used to sort. */
export type TrackingLinksSortableColumns =
	| "clicks"
	| "conversion_rate"
	| "converted_users"
	| "created_at"
	| "id"
	| "revenue_generated";

/** The different types for a tracking pixel */
export type TrackingPixelTypes =
	/** Hubspot Pixel */
	| "hubspot_pixel_id"
	/** X Checkout Initiated Event */
	| "x_checkout_initiated_event"
	/** X Payment Method Event */
	| "x_payment_method_event"
	/** X Purchase Event */
	| "x_purchase_event";

/** Autogenerated input type of TransferFunds */
export interface TransferFundsInput {
	/** The amount to withdraw */
	amount: Scalars["Float"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The currency that is being withdrawn. */
	currency: Currencies;
	/** The ID of the destination (either a User tag, Bot tag, or LedgerAccount tag) */
	destinationId: Scalars["ID"]["input"];
	/** The feed identifier to notify of the transfer. */
	feedId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The feed type to notify of the transfer. */
	feedType?: InputMaybe<FeedTypes>;
	/** A unique key to ensure idempotence. Use a UUID or similar. */
	idempotenceKey: Scalars["String"]["input"];
	/** The ledger account id to transfer from. */
	ledgerAccountId: Scalars["ID"]["input"];
	/** Notes for the transfer. Maximum of 50 characters. */
	notes?: InputMaybe<Scalars["String"]["input"]>;
	/** The reason for the transfer. */
	reason?: InputMaybe<CreditTransactionTransferReasons>;
	/** The fee that the client thinks it is being charged for the transfer. Used to verify the fee. */
	transferFee?: InputMaybe<Scalars["Float"]["input"]>;
}

/** Autogenerated input type of TransferLinkMyMembership */
export interface TransferLinkMyMembershipInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the company that this membership is on behalf of. */
	companyBuyerId?: InputMaybe<Scalars["ID"]["input"]>;
	/** This is the ID of the membership you want to create a transfer link for. */
	id: Scalars["ID"]["input"];
}

/** Autogenerated input type of UnassignProductionAppBuild */
export interface UnassignProductionAppBuildInput {
	/** The ID of the app to unassign the production build from. */
	appId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** What platform should be unassigned */
	platform: AppBuildPlatforms;
}

/** Autogenerated input type of UnbanUser */
export interface UnbanUserInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the user to unban */
	userId: Scalars["ID"]["input"];
}

/** The types of universal post feeds that you can retrieve */
export type UniversalPostFeedTypes =
	| "access_pass"
	| "discover"
	| "home"
	| "recent_content_reward_submissions"
	| "user_profile";

/** Autogenerated input type of UpdateAccessPass */
export interface UpdateAccessPassInput {
	/** A banner image for the access pass in png, jpeg format */
	bannerImage?: InputMaybe<AttachmentInput>;
	/** The business type of the access pass. */
	businessType?: InputMaybe<BusinessTypes>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The creator pitch for the access pass. */
	creatorPitch?: InputMaybe<Scalars["String"]["input"]>;
	/** The custom call to action for the access pass. */
	customCta?: InputMaybe<CustomCtas>;
	/** The custom call to action URL for the access pass. */
	customCtaUrl?: InputMaybe<Scalars["String"]["input"]>;
	/**
	 * The custom statement descriptor for the access pass i.e. WHOP*SPORTS, must be
	 * between 5 and 22 characters, contain at least one letter, and not contain any
	 * of the following characters: <, >, \, ', "
	 */
	customStatementDescriptor?: InputMaybe<Scalars["String"]["input"]>;
	/** The percentage of the revenue that goes to the global affiliate program. */
	globalAffiliatePercentage?: InputMaybe<Scalars["Float"]["input"]>;
	/** The status of the global affiliate program for this access pass. */
	globalAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** The headline of the access pass. */
	headline?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID (tag) of the access pass */
	id: Scalars["ID"]["input"];
	/** The industry type of the access pass. */
	industryType?: InputMaybe<IndustryTypes>;
	/** The logo for the access pass in png, jpeg, or gif format */
	logo?: InputMaybe<AttachmentInput>;
	/** The percentage of the revenue that goes to the member affiliate program. */
	memberAffiliatePercentage?: InputMaybe<Scalars["Float"]["input"]>;
	/** The status of the member affiliate program for this access pass. */
	memberAffiliateStatus?: InputMaybe<GlobalAffiliateStatuses>;
	/** The ID of the product tax code to apply to this access pass. */
	productTaxCodeId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The URL to redirect the customer to after a purchase. */
	redirectPurchaseUrl?: InputMaybe<Scalars["String"]["input"]>;
	/** The route of the access pass. */
	route?: InputMaybe<Scalars["String"]["input"]>;
	/** A short description of what the access pass offers or does. Must be 150 chars or less. */
	shortenedDescription?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not to show the member count on the access pass. */
	showMemberCount?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether or not to show the offers on the access pass. */
	showOffers?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** Whether or not to show reviews on the access pass. */
	showReviewsDtc?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The title of the access pass. */
	title?: InputMaybe<Scalars["String"]["input"]>;
	/** This access pass will/will not be displayed publicly. */
	visibility?: InputMaybe<Visibility>;
}

/** Autogenerated input type of UpdateAffiliate */
export interface UpdateAffiliateInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The amount the affiliate will earn (either amount or percent 1-100) */
	fee?: InputMaybe<Scalars["StringFloat"]["input"]>;
	/** The ID (tag) of the affiliate. */
	id: Scalars["ID"]["input"];
	/** Whether or not the affiliate will only get one payout or it will be recurring. */
	onlyOnePayout?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The type of payout. */
	payoutType?: InputMaybe<PayoutTypes>;
	/** The IDs of the plans that the affiliate can refer. */
	planId: Scalars["String"]["input"];
	/** Sets the affiliate as active/inactive. */
	status?: InputMaybe<Status>;
}

/** Autogenerated input type of UpdateAgentUser */
export interface UpdateAgentUserInput {
	/** The ID of the app to create the agent user for. */
	appId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The name of the agent user. */
	name?: InputMaybe<Scalars["String"]["input"]>;
	/** An image for the user for their avatar. */
	profilePhoto?: InputMaybe<Scalars["File"]["input"]>;
	/** The ID of the user to update. */
	userId: Scalars["ID"]["input"];
	/** The username of the agent user. */
	username?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of UpdateApp */
export interface UpdateAppInput {
	/** The description of the app for the app store in-depth app view. */
	appStoreDescription?: InputMaybe<Scalars["String"]["input"]>;
	/** The base developer url of the app */
	baseDevUrl?: InputMaybe<Scalars["UrlString"]["input"]>;
	/** The base preview url of the app */
	basePreviewUrl?: InputMaybe<Scalars["UrlString"]["input"]>;
	/** The base production url of the app */
	baseUrl?: InputMaybe<Scalars["UrlString"]["input"]>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The path for the dashboard view of the app */
	dashboardPath?: InputMaybe<Scalars["String"]["input"]>;
	/** The default agent user ID for the app */
	defaultAgentUserId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The description of the app */
	description?: InputMaybe<Scalars["String"]["input"]>;
	/** The path for the discover view of the app */
	discoverPath?: InputMaybe<Scalars["String"]["input"]>;
	/** The path for the hub view of the app */
	experiencePath?: InputMaybe<Scalars["String"]["input"]>;
	/** If the apps experience's should force showing the pre-checkout iframe, and not rely on app connections. */
	forceCheckoutIframe?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The hub call to action text of the app */
	hubCta?: InputMaybe<Scalars["String"]["input"]>;
	/** The icon for the app */
	icon?: InputMaybe<AttachmentInput>;
	/** The ID of the app */
	id: Scalars["ID"]["input"];
	/**
	 * The image for the app
	 * @deprecated Use icon instead
	 */
	image?: InputMaybe<Scalars["File"]["input"]>;
	/** The name of the app */
	name?: InputMaybe<Scalars["String"]["input"]>;
	/** The product page text of the app */
	productPage?: InputMaybe<Scalars["String"]["input"]>;
	/** The scopes that the app will request off of users when a user installs the app. */
	requiredScopes?: InputMaybe<Array<AppValidScopes>>;
	/**
	 * If the status is live, the app is visible on Whop discovery. In order to be
	 * live, you need to set the name, icon, and description. Being unlisted or
	 * hidden means it's not visible on Whop but you can still install the app via
	 * direct link. To remove the app from whop discovery, you should set the status to unlisted.
	 */
	status?: InputMaybe<AppStatuses>;
}

/** Autogenerated input type of UpdateAppPermissionRequirements */
export interface UpdateAppPermissionRequirementsInput {
	/** The ID of the app the permission requirements are being updated for */
	appId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The permissions that the app will request off of users when a user installs the app. */
	requestedPermissions: Array<AppRequestedPermissionInput>;
}

/** Autogenerated input type of UpdateChapter */
export interface UpdateChapterInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the chapter to update */
	id: Scalars["ID"]["input"];
	/** The title of the chapter */
	title: Scalars["String"]["input"];
}

/** Autogenerated input type of UpdateChapterOrder */
export interface UpdateChapterOrderInput {
	/** The ID of the chapter to place this chapter below */
	belowChapterId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the chapter to reorder */
	chapterId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
}

/** Autogenerated input type of UpdateLesson */
export interface UpdateLessonInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The content of the lesson */
	content?: InputMaybe<Scalars["String"]["input"]>;
	/** Days from course start until unlock */
	daysFromCourseStartUntilUnlock?: InputMaybe<Scalars["Int"]["input"]>;
	/** The ID of the lesson to update */
	id: Scalars["ID"]["input"];
	/** The type of the lesson */
	lessonType?: InputMaybe<LessonTypes>;
	/** The ID of the Mux asset to attach to this lesson */
	muxAssetId?: InputMaybe<Scalars["String"]["input"]>;
	/** The title of the lesson */
	title?: InputMaybe<Scalars["String"]["input"]>;
	/** Determines how / whether this lesson is visible to users. */
	visibility?: InputMaybe<LessonVisibilities>;
}

/** Autogenerated input type of UpdateLessonOrder */
export interface UpdateLessonOrderInput {
	/** The ID of the lesson to place this lesson below */
	belowLessonId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The ID of the chapter to move the lesson to */
	chapterId: Scalars["ID"]["input"];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the lesson to reorder */
	lessonId: Scalars["ID"]["input"];
}

/** Autogenerated input type of UpdateMembership */
export interface UpdateMembershipInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The number of trial days to add to the membership to extend it. */
	freeDays?: InputMaybe<Scalars["Int"]["input"]>;
	/** The ID (tag) of the membership. */
	id: Scalars["ID"]["input"];
	/** The action being applied to the specific membership. */
	membershipAction: MembershipActions;
}

/** Autogenerated input type of UpdateWebhook */
export interface UpdateWebhookInput {
	/** The API version for this webhook */
	apiVersion?: InputMaybe<ApiVersion>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** Whether or not the webhook is enabled. */
	enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
	/** The events to send the webhook for. */
	events?: InputMaybe<Array<WebhookEvent>>;
	/** The ID of the Webhook to update */
	id: Scalars["ID"]["input"];
	/** The URL to send the webhook to. */
	url?: InputMaybe<Scalars["UrlString"]["input"]>;
}

export interface UploadPartInput {
	/** The ETag of the part */
	etag: Scalars["String"]["input"];
	/** The part number of the part */
	partNumber: Scalars["Int"]["input"];
}

export interface UpsellPlanInput {
	/** The base currency of the upsell. */
	baseCurrency?: InputMaybe<Currencies>;
	/** An array of custom field objects. */
	customFields?: InputMaybe<Array<CustomFieldInput>>;
	/** The interval at which the plan charges (expiration plans). */
	expirationDays?: InputMaybe<Scalars["Int"]["input"]>;
	/** The price of the upsell. */
	initialPrice?: InputMaybe<Scalars["Float"]["input"]>;
	/** The method of release for the upsell. */
	releaseMethod?: InputMaybe<ReleaseMethod>;
}

/** The different types of upsells an experience can have. */
export type UpsellTypes =
	/** After Checkout */
	| "after_checkout"
	/** Before Checkout */
	| "before_checkout"
	/** Only In Whop */
	| "only_in_whop";

/** Filters for the user affiliate referral logs search */
export interface UserAffiliateReferralLogFilters {
	/** Which direction the order should be in. */
	direction?: InputMaybe<Direction>;
	/** How you want to order the results. */
	order?: InputMaybe<UserAffiliateReferralLogOrder>;
	/** What to search by: whop username, access pass name, or bot title */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The order to sort the logs by */
export type UserAffiliateReferralLogOrder = "id";

/** The configuration for a chart. */
export interface UserChartConfigInput {
	/** The currency to use for the chart. */
	currency?: InputMaybe<Currencies>;
	/** The start date to take into account. */
	from: Scalars["Timestamp"]["input"];
	/** The interval to group the data by. */
	interval?: InputMaybe<ChartIntervals>;
	/** The time zone used for start of day calculations. */
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
	/** The end date to take into account. */
	to: Scalars["Timestamp"]["input"];
	/** The week mode to group the data by. For details, look at https://clickhouse.com/docs/en/sql-reference/functions/date-time-functions#toweek */
	weekMode?: InputMaybe<Scalars["Int"]["input"]>;
}

/** Values to filter content rewards submissions on */
export interface UserContentRewardsSubmissionsFilters {
	/** The campaign ID to filter by */
	campaignId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The direction to order by */
	direction?: InputMaybe<Direction>;
	/** The experience ID to filter by */
	experienceId?: InputMaybe<Scalars["ID"]["input"]>;
	/** The order to sort the results by */
	order?: InputMaybe<UserContentRewardsSubmissionsOrder>;
	/** The status of the submissions */
	status?: InputMaybe<ContentRewardsSubmissionStatus>;
}

/** The ordering options for content rewards submissions */
export type UserContentRewardsSubmissionsOrder =
	| "amount_paid_out"
	| "created_at"
	| "expires_at"
	| "total_view_count";

/** The channel of the user notification preference */
export type UserNotificationPreferenceChannel =
	/** In App */
	| "in_app"
	/** Mobile */
	| "mobile";

/** The steps a user can follow to complete onboarding */
export type UserOnboardingStepsTypes =
	| "add_birthday"
	| "add_email"
	| "add_name"
	| "add_phone"
	| "add_profile_picture"
	| "add_username"
	| "download_mobile_app"
	| "join_a_whop"
	| "select_interests"
	| "verify_email"
	| "verify_phone";

/** Values to filter user receipts on */
export interface UserReceiptFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What to order the results by. */
	order?: InputMaybe<UserReceiptOrder>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** Filter receipts by 'free', 'paid', or 'all'. */
	type?: InputMaybe<UserReceiptPaidTypeFilter>;
}

/** The order to sort the results by. */
export type UserReceiptOrder = "paid_at";

/** The filter to apply to the results. */
export type UserReceiptPaidTypeFilter = "all" | "free" | "paid";

/** The different websites you can have social links for */
export type UserSocialLinkWebsites =
	| "facebook"
	| "instagram"
	| "linkedin"
	| "tiktok"
	| "twitch"
	| "website"
	| "x"
	| "youtube";

/** The type of a user */
export type UserTypes =
	/** Agent */
	| "agent"
	/** Human */
	| "human"
	/** System */
	| "system";

/** The order to sort the results by. */
export type ValidMembershipsOrder = "expires_at" | "id" | "ordering_status";

/** A vaulting method for a payment token. */
export type VaultMethods =
	/** Paypal Wallet */
	| "paypal_wallet"
	/** Venmo Wallet */
	| "venmo_wallet";

/** The different providers a vault token can be. */
export type VaultTokenProviders =
	/** Basis Theory */
	"basis_theory";

/** An error code for a verification attempt. */
export type VerificationErrorCodes =
	/** Abandoned */
	| "abandoned"
	/** Consent Declined */
	| "consent_declined"
	/** Country Not Supported */
	| "country_not_supported"
	/** Device Not Supported */
	| "device_not_supported"
	/** Document Expired */
	| "document_expired"
	/** Document Type Not Supported */
	| "document_type_not_supported"
	/** Document Unverified Other */
	| "document_unverified_other"
	/** Email Unverified Other */
	| "email_unverified_other"
	/** Email Verification Declined */
	| "email_verification_declined"
	/** Id Number Insufficient Document Data */
	| "id_number_insufficient_document_data"
	/** Id Number Mismatch */
	| "id_number_mismatch"
	/** Id Number Unverified Other */
	| "id_number_unverified_other"
	/** Phone Unverified Other */
	| "phone_unverified_other"
	/** Phone Verification Declined */
	| "phone_verification_declined"
	/** Selfie Document Missing Photo */
	| "selfie_document_missing_photo"
	/** Selfie Face Mismatch */
	| "selfie_face_mismatch"
	/** Selfie Manipulated */
	| "selfie_manipulated"
	/** Selfie Unverified Other */
	| "selfie_unverified_other"
	/** Under Supported Age */
	| "under_supported_age";

/** The different providers a payout account can be. */
export type VerificationProviders =
	/** Stripe */
	| "stripe"
	/** Veriff */
	| "veriff";

/** A status for a verification. */
export type VerificationStatuses =
	/** Abandoned */
	| "abandoned"
	/** Approved */
	| "approved"
	/** Canceled */
	| "canceled"
	/** Created */
	| "created"
	/** Declined */
	| "declined"
	/** Expired */
	| "expired"
	/** Processing */
	| "processing"
	/** Requires Input */
	| "requires_input"
	/** Resubmission Requested */
	| "resubmission_requested"
	/** Review */
	| "review"
	/** Started */
	| "started"
	/** Submitted */
	| "submitted"
	/** Verified */
	| "verified";

/** The status of a bots Whop Verified. */
export type VerifiedStatuses = "accepted" | "applied" | "rejected";

/** The types of version events that are possible. */
export type VersionEventTypes = "create" | "destroy" | "update";

/** Filters for the version search */
export interface VersionFilters {
	/** The direction to filter the audit logs */
	direction?: InputMaybe<Direction>;
	/** To get all Audit Logs created before this certain time. */
	endDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The event type to filter by. */
	eventType?: InputMaybe<Array<VersionEventTypes>>;
	/** The object type to filter by. */
	objectType?: InputMaybe<Array<VersionObjects>>;
	/** What to order the results by. */
	order?: InputMaybe<VersionOrder>;
	/** The text that is being searched. Searches the version's identifier, which is usually a name or ID related to the object. */
	query?: InputMaybe<Scalars["String"]["input"]>;
	/** To get all Audit Logs created after this certain time. */
	startDate?: InputMaybe<Scalars["Timestamp"]["input"]>;
	/** The ID of the user who triggered this audit log */
	userId?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

/** The types of objects that have versions available for them. */
export type VersionObjects =
	| "access_pass"
	| "affiliate"
	| "authorized_user"
	| "bot"
	| "discord_server"
	| "experience"
	| "plan"
	| "promo_code"
	| "stripe_account";

/** The order to sort the memberships by */
export type VersionOrder = "event" | "id";

/** Visibility of a resource */
export type Visibility =
	/** Archived */
	| "archived"
	/** Hidden */
	| "hidden"
	/** Quick Link */
	| "quick_link"
	/** Visible */
	| "visible";

/** The different levels of visibility for resources */
export type VisibilityFilter =
	| "all"
	/** Archived */
	| "archived"
	/** Hidden */
	| "hidden"
	| "not_archived"
	| "not_quick_link"
	/** Quick Link */
	| "quick_link"
	/** Visible */
	| "visible";

/** Autogenerated input type of VoidInvoice */
export interface VoidInvoiceInput {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
	/** The ID of the invoice to void */
	id: Scalars["ID"]["input"];
}

/** The different event types available */
export type WebhookEvent =
	| "app_membership_cancel_at_period_end_changed"
	| "app_membership_went_invalid"
	| "app_membership_went_valid"
	| "app_payment_failed"
	| "app_payment_pending"
	| "app_payment_succeeded"
	| "dispute_alert_created"
	| "dispute_created"
	| "dispute_updated"
	| "invoice_created"
	| "invoice_paid"
	| "invoice_past_due"
	| "invoice_voided"
	| "membership_cancel_at_period_end_changed"
	| "membership_experience_claimed"
	| "membership_metadata_updated"
	| "membership_went_invalid"
	| "membership_went_valid"
	| "payment_affiliate_reward_created"
	| "payment_failed"
	| "payment_pending"
	| "payment_succeeded"
	| "refund_created"
	| "refund_updated"
	| "resolution_created"
	| "resolution_decided"
	| "resolution_updated";

/** The anchor for when the Connected Account will be paid out */
export type WeeklyAnchors =
	| "friday"
	| "monday"
	| "saturday"
	| "sunday"
	| "thursday"
	| "tuesday"
	| "wednesday";

/** Who can post on a chat feed */
export type WhoCanPostTypes = "admins" | "everyone";

/** Who can react on a chat feed */
export type WhoCanReactTypes = "everyone" | "no_one";

/** Values to filter users on */
export interface WhopSidebarFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What to order the results by. */
	order?: InputMaybe<WhopSidebarOrderEnum>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The order to sort the results by. */
export type WhopSidebarOrderEnum =
	| "date_joined"
	| "last_seen_at"
	| "name"
	| "paid_out_by_company"
	| "time_spent_in_whop";

/** Values to filter users on */
export interface WhopSidebarWithEarningsFilters {
	/** How to order the results. */
	direction?: InputMaybe<Direction>;
	/** What to order the results by. */
	order?: InputMaybe<WhopSidebarWithEarningsOrderEnum>;
	/** The text that is being searched. */
	query?: InputMaybe<Scalars["String"]["input"]>;
}

/** The order to sort the results by. */
export type WhopSidebarWithEarningsOrderEnum =
	| "last_7_days"
	| "last_24_hours"
	| "last_30_days"
	| "lifetime";

/** The different fee types for a withdrawal. */
export type WithdrawalFeeTypes = "exclusive" | "inclusive";

/** Values to filter the withdrawals on. */
export interface WithdrawalFilters {
	/** Filter by currency */
	currency?: InputMaybe<Currencies>;
	/** The withdrawal status/state */
	statuses?: InputMaybe<Array<WithdrawalStatus>>;
}

/** The method used for withdrawing. */
export type WithdrawalMethods =
	/** Ach */
	| "ach"
	/** Btc */
	| "btc"
	/** Cash App */
	| "cash_app"
	/** Check */
	| "check"
	/** Echeck */
	| "echeck"
	/** Manual */
	| "manual"
	/** Masspay */
	| "masspay"
	/** Paypal */
	| "paypal"
	/** Stripe */
	| "stripe"
	/** Venmo */
	| "venmo"
	/** Wire Transfer */
	| "wire_transfer"
	/** Zelle */
	| "zelle";

/** The statuses a review can have */
export type WithdrawalProviders =
	/** Manual */
	| "manual"
	/** Masspay */
	| "masspay"
	/** Stripe */
	| "stripe"
	/** Tipalti */
	| "tipalti";

/** The different speeds of withdrawals */
export type WithdrawalSpeeds =
	/** Instant */
	| "instant"
	/** Standard */
	| "standard";

/** The status of a withdrawal request */
export type WithdrawalStatus =
	/** Awaiting Payment */
	| "awaiting_payment"
	/** Canceled */
	| "canceled"
	/** Completed */
	| "completed"
	/** Denied */
	| "denied"
	/** Failed */
	| "failed"
	/** In Transit */
	| "in_transit"
	/** Requested */
	| "requested";

/** The types of withdrawals */
export type WithdrawalTypes =
	/** Clawback */
	| "clawback"
	/** Regular */
	| "regular";

/** Which columns can be used to sort. */
export type WithdrawalsSortableColumns = "amount" | "created_at" | "id";

export type AccessPassFragmentFragment = {
	__typename?: "PublicAccessPass";
	id: string;
	title: string;
	shortenedDescription?: string | null;
	verified: boolean;
	visibility: Visibility;
	route: string;
	activeUsersCount: number;
	logo?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
};

export type BaseAccessPassFragment = {
	__typename?: "AccessPass";
	id: string;
	createdAt: number;
	route: string;
	title: string;
	headline?: string | null;
	shortenedDescription?: string | null;
	verified: boolean;
	visibility: Visibility;
	activeUsersCount: number;
	reviewsAverage: number;
	creatorPitch?: string | null;
	updatedAtMs: string;
	showOffers: boolean;
	redirectPurchaseUrl?: string | null;
	customCta: CustomCtas;
	customCtaUrl?: string | null;
	globalAffiliatePercentage?: number | null;
	globalAffiliateStatus: GlobalAffiliateStatuses;
	memberAffiliatePercentage?: number | null;
	memberAffiliateStatus: GlobalAffiliateStatuses;
	showMemberCount: boolean;
	logo?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
	bannerImage?:
		| {
				__typename?: "AudioAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "ImageAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "OtherAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "VideoAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| null;
};

export type BaseAffiliateFragment = {
	__typename?: "Affiliate";
	id: string;
	status?: Status | null;
	activeMembersCount: number;
	affiliateType?: AffiliateTypes | null;
	totalPlanCount: number;
	totalReferralEarnings: string;
	totalReferrals: number;
	totalRevenue: string;
};

export type AffiliateWithUserFragment = {
	__typename?: "Affiliate";
	id: string;
	status?: Status | null;
	activeMembersCount: number;
	affiliateType?: AffiliateTypes | null;
	totalPlanCount: number;
	totalReferralEarnings: string;
	totalReferrals: number;
	totalRevenue: string;
	userAccount: {
		__typename?: "PublicProfileUser";
		id: string;
		name?: string | null;
		username: string;
		phoneVerified: boolean;
		city?: string | null;
		country?: string | null;
		profilePicture?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type BaseAppBuildFragment = {
	__typename?: "AppBuild";
	id: string;
	createdAt: number;
	fileUrl: string;
	checksum: string;
	platform: AppBuildPlatforms;
	reviewMessage?: string | null;
	supportedAppViewTypes: Array<AppViewTypes>;
	status: AppBuildStatuses;
};

export type BaseAppFragment = {
	__typename?: "App";
	id: string;
	name: string;
	description?: string | null;
	status: AppStatuses;
	usingDefaultIcon: boolean;
	baseUrl?: string | null;
	baseDevUrl?: string | null;
	experiencePath?: string | null;
	discoverPath?: string | null;
	dashboardPath?: string | null;
	icon?:
		| {
				__typename?: "AudioAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "ImageAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "OtherAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename?: "VideoAttachment";
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| null;
};

export type BaseAppApiKeyFragment = {
	__typename?: "PrivateApiKey";
	id: string;
	token: string;
	createdAt: number;
};

export type BaseAppAgentUserFragment = {
	__typename?: "User";
	id: string;
	name?: string | null;
	username: string;
};

export type BaseAppStatsFragment = {
	__typename?: "PublicAppStats";
	dau: number;
	mau: number;
	timeSpentLast24HoursInSeconds: number;
	wau: number;
};

type Attachment_AudioAttachment_Fragment = {
	__typename: "AudioAttachment";
	duration?: number | null;
	waveformUrl?: string | null;
	id: string;
	signedId?: string | null;
	analyzed: boolean;
	byteSizeV2?: string | null;
	filename?: string | null;
	contentType?: string | null;
	source: { __typename?: "AttachmentSource"; url: string };
};

type Attachment_ImageAttachment_Fragment = {
	__typename: "ImageAttachment";
	height?: number | null;
	width?: number | null;
	blurhash?: string | null;
	aspectRatio?: number | null;
	id: string;
	signedId?: string | null;
	analyzed: boolean;
	byteSizeV2?: string | null;
	filename?: string | null;
	contentType?: string | null;
	source: { __typename?: "AttachmentSource"; url: string };
};

type Attachment_OtherAttachment_Fragment = {
	__typename: "OtherAttachment";
	id: string;
	signedId?: string | null;
	analyzed: boolean;
	byteSizeV2?: string | null;
	filename?: string | null;
	contentType?: string | null;
	source: { __typename?: "AttachmentSource"; url: string };
};

type Attachment_VideoAttachment_Fragment = {
	__typename: "VideoAttachment";
	height?: number | null;
	width?: number | null;
	duration?: number | null;
	aspectRatio?: number | null;
	id: string;
	signedId?: string | null;
	analyzed: boolean;
	byteSizeV2?: string | null;
	filename?: string | null;
	contentType?: string | null;
	preview: { __typename?: "AttachmentSource"; url: string };
	source: { __typename?: "AttachmentSource"; url: string };
};

export type AttachmentFragment =
	| Attachment_AudioAttachment_Fragment
	| Attachment_ImageAttachment_Fragment
	| Attachment_OtherAttachment_Fragment
	| Attachment_VideoAttachment_Fragment;

export type BaseAuthorizedUserFragment = {
	__typename?: "AuthorizedUser";
	id: string;
	name?: string | null;
	username: string;
	userId: string;
	email?: string | null;
	role: AuthorizedUserRoles;
};

export type BaseInvoiceFragment = {
	__typename?: "Invoice";
	id: string;
	createdAt: number;
	status: InvoiceStatuses;
	number: string;
	dueDate?: number | null;
	emailAddress?: string | null;
	fetchInvoiceToken: string;
	currentPlan: {
		__typename?: "Plan";
		id: string;
		formattedPrice: string;
		baseCurrency: Currencies;
	};
	member?: {
		__typename?: "Member";
		id: string;
		email?: string | null;
		name?: string | null;
		username?: string | null;
	} | null;
};

export type BaseLedgerAccountFragment = {
	__typename?: "LedgerAccount";
	id: string;
	transferFee?: number | null;
	balanceCaches: {
		__typename?: "BalanceCacheConnection";
		nodes?: Array<{
			__typename?: "BalanceCache";
			balance: number;
			pendingBalance: number;
			currency: Currencies;
		} | null> | null;
	};
};

export type BasePublicPlanFragment = {
	__typename?: "PublicPlan";
	id: string;
	baseCurrency: Currencies;
	rawRenewalPrice: number;
	rawInitialPrice: number;
	initialPriceDue: number;
	createdAt: number;
	updatedAt: number;
	billingPeriod?: number | null;
	trialPeriodDays?: number | null;
	expirationDays?: number | null;
	unlimitedStock: boolean;
	paymentLinkDescription?: string | null;
	releaseMethod: ReleaseMethod;
	stock?: number | null;
	visibility: Visibility;
	planType: PlanTypes;
};

export type BasePlanFragment = {
	__typename?: "Plan";
	id: string;
	baseCurrency: Currencies;
	rawRenewalPrice: number;
	rawInitialPrice: number;
	initialPriceDue: number;
	createdAt: number;
	updatedAt: number;
	billingPeriod?: number | null;
	trialPeriodDays?: number | null;
	expirationDays?: number | null;
	unlimitedStock: boolean;
	paymentLinkDescription?: string | null;
	releaseMethod: ReleaseMethod;
	stock: number;
	visibility: Visibility;
	planType: PlanTypes;
	title: string;
	description?: string | null;
	name?: string | null;
	formattedPrice: string;
	formattedBillingPeriod?: string | null;
};

export type BaseReceiptFragment = {
	__typename?: "Receipt";
	id: string;
	settledUsdAmount?: number | null;
	billingReason?: string | null;
	last4?: string | null;
	currency?: Currencies | null;
	status?: ReceiptStatus | null;
	createdAt: number;
	total?: number | null;
	brand?: string | null;
	paymentProcessor?: ReceiptPaymentProcessor | null;
	paymentMethodType?: string | null;
	disputeAlertedAt?: number | null;
	finalAmount: number;
	presentedFinalAmount?: number | null;
	presentedSettledUsdAmount?: number | null;
	refundedAmount?: number | null;
	friendlyStatus: FriendlyReceiptStatus;
	failureMessage?: string | null;
	refundable: boolean;
	retryable: boolean;
	paidAt?: number | null;
	amountAfterFees: number;
	chargeSkippedPriceTooLow: boolean;
	lastPaymentAttempt?: number | null;
	autoRefunded: boolean;
	totalUsdAmount?: number | null;
	mostRecentRiskScore?: number | null;
	address?: {
		__typename?: "Address";
		name?: string | null;
		line1?: string | null;
		line2?: string | null;
		city?: string | null;
		state?: string | null;
		postalCode?: string | null;
		country?: string | null;
	} | null;
	member?: {
		__typename?: "CompanyMember";
		header: string;
		user?: {
			__typename?: "CompanyMemberUser";
			id: string;
			username: string;
			name?: string | null;
			email?: string | null;
			country?: string | null;
			countryName?: string | null;
		} | null;
		imageSrcset: {
			__typename?: "ImgSrcset";
			original: string;
			double: string;
			isVideo: boolean;
		};
	} | null;
	plan?: {
		__typename?: "Plan";
		id: string;
		title: string;
		formattedPrice: string;
		initialPrice: number;
		renewalPrice: number;
		paymentLinkDescription?: string | null;
	} | null;
	membership?: {
		__typename?: "Membership";
		id: string;
		status: MembershipStatus;
	} | null;
	promoCode?: {
		__typename?: "PromoCode";
		id: string;
		code?: string | null;
		amountOff: number;
		baseCurrency: Currencies;
		promoType: PromoTypes;
		numberOfIntervals?: number | null;
	} | null;
	accessPass?: { __typename?: "AccessPass"; id: string; title: string } | null;
};

export type BaseUserFragment = {
	__typename?: "User";
	id: string;
	email?: string | null;
	name?: string | null;
	username: string;
	profilePicture?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
};

export type BasePublicProfileUserFragment = {
	__typename?: "PublicProfileUser";
	id: string;
	name?: string | null;
	username: string;
	phoneVerified: boolean;
	city?: string | null;
	country?: string | null;
	profilePicture?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
};

export type BasicCourseFragment = {
	__typename?: "Course";
	certificateAfterCompletionEnabled?: boolean | null;
	coverImage?: string | null;
	description?: string | null;
	id: string;
	language: Languages;
	requireCompletingLessonsInOrder: boolean;
	tagline?: string | null;
	title?: string | null;
	videoProtectionEnabled: boolean;
	chapters: Array<{
		__typename?: "Chapter";
		id: string;
		title: string;
		order: number;
		lessons: Array<{
			__typename?: "Lesson";
			id: string;
			lessonType: LessonTypes;
			title: string;
			order: number;
			visibility: LessonVisibilities;
			daysFromCourseStartUntilUnlock?: number | null;
			content?: string | null;
			muxAsset?: {
				__typename?: "MuxAsset";
				id: string;
				muxAssetId?: string | null;
				playbackId?: string | null;
				signedPlaybackId?: string | null;
				signedThumbnailPlaybackToken?: string | null;
				signedVideoPlaybackToken?: string | null;
				signedStoryboardPlaybackToken?: string | null;
				durationSeconds?: number | null;
				status: MuxAssetStatuses;
				finishedUploadingAt?: number | null;
			} | null;
		}>;
	}>;
};

export type BasicCourseChapterFragment = {
	__typename?: "Chapter";
	id: string;
	title: string;
	order: number;
	lessons: Array<{
		__typename?: "Lesson";
		id: string;
		lessonType: LessonTypes;
		title: string;
		order: number;
		visibility: LessonVisibilities;
		daysFromCourseStartUntilUnlock?: number | null;
		content?: string | null;
		muxAsset?: {
			__typename?: "MuxAsset";
			id: string;
			muxAssetId?: string | null;
			playbackId?: string | null;
			signedPlaybackId?: string | null;
			signedThumbnailPlaybackToken?: string | null;
			signedVideoPlaybackToken?: string | null;
			signedStoryboardPlaybackToken?: string | null;
			durationSeconds?: number | null;
			status: MuxAssetStatuses;
			finishedUploadingAt?: number | null;
		} | null;
	}>;
};

export type BasicCourseLessonFragment = {
	__typename?: "Lesson";
	id: string;
	lessonType: LessonTypes;
	title: string;
	order: number;
	visibility: LessonVisibilities;
	daysFromCourseStartUntilUnlock?: number | null;
	content?: string | null;
	muxAsset?: {
		__typename?: "MuxAsset";
		id: string;
		muxAssetId?: string | null;
		playbackId?: string | null;
		signedPlaybackId?: string | null;
		signedThumbnailPlaybackToken?: string | null;
		signedVideoPlaybackToken?: string | null;
		signedStoryboardPlaybackToken?: string | null;
		durationSeconds?: number | null;
		status: MuxAssetStatuses;
		finishedUploadingAt?: number | null;
	} | null;
};

export type CompanyFragmentFragment = {
	__typename?: "PublicCompany";
	id: string;
	title: string;
	route: string;
	logo?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
	bannerImage?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
};

export type ExperienceFragmentFragment = {
	__typename?: "CustomPrivate";
	id: string;
	name?: string | null;
	description?: string | null;
	logo?: { __typename?: "ImgSrcset"; sourceUrl: string } | null;
	app: {
		__typename?: "PublicApp";
		id: string;
		name: string;
		icon?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type PublicExperienceFragmentFragment = {
	__typename?: "PublicExperience";
	id: string;
	name: string;
	description?: string | null;
	logo?:
		| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
		| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
		| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
		| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
		| null;
	app: {
		__typename?: "PublicApp";
		id: string;
		name: string;
		icon?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
	company: {
		__typename?: "PublicCompany";
		id: string;
		title: string;
		route: string;
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		bannerImage?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type ForumPostFragmentFragment = {
	__typename?: "ForumPost";
	id: string;
	createdAt: string;
	updatedAt: string;
	content?: string | null;
	richContent?: string | null;
	isDeleted: boolean;
	isEdited: boolean;
	mentionedUserIds: Array<string>;
	parentId?: string | null;
	viewCount?: number | null;
	isPinned: boolean;
	attachments: Array<
		| {
				__typename?: "AudioAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "ImageAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "OtherAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "VideoAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
	>;
	user: {
		__typename?: "PublicProfileUser";
		id: string;
		name?: string | null;
		username: string;
		phoneVerified: boolean;
		city?: string | null;
		country?: string | null;
		profilePicture?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type FullCourseLessonFragment = {
	__typename?: "Lesson";
	id: string;
	lessonType: LessonTypes;
	title: string;
	order: number;
	visibility: LessonVisibilities;
	content?: string | null;
	daysFromCourseStartUntilUnlock?: number | null;
	muxAsset?: {
		__typename?: "MuxAsset";
		id: string;
		muxAssetId?: string | null;
		playbackId?: string | null;
		signedPlaybackId?: string | null;
		signedThumbnailPlaybackToken?: string | null;
		signedVideoPlaybackToken?: string | null;
		signedStoryboardPlaybackToken?: string | null;
		durationSeconds?: number | null;
		status: MuxAssetStatuses;
		finishedUploadingAt?: number | null;
	} | null;
	assessmentQuestions: Array<{
		__typename?: "AssessmentQuestion";
		id: string;
		correctAnswer: string;
		order: number;
		questionText: string;
		questionType: CoursesAssessmentQuestionTypes;
		image?:
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
		options: Array<{
			__typename?: "AssessmentQuestionOption";
			id: string;
			isCorrect: boolean;
			optionText: string;
			order: number;
		}>;
	}>;
	attachments: {
		__typename?: "AttachmentInterfaceConnection";
		nodes?: Array<
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null
		> | null;
	};
	mainPdf?:
		| {
				__typename: "AudioAttachment";
				duration?: number | null;
				waveformUrl?: string | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "ImageAttachment";
				height?: number | null;
				width?: number | null;
				blurhash?: string | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "OtherAttachment";
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "VideoAttachment";
				height?: number | null;
				width?: number | null;
				duration?: number | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				preview: { __typename?: "AttachmentSource"; url: string };
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| null;
};

export type CourseMuxAssetFragment = {
	__typename?: "MuxAsset";
	id: string;
	muxAssetId?: string | null;
	playbackId?: string | null;
	signedPlaybackId?: string | null;
	signedThumbnailPlaybackToken?: string | null;
	signedVideoPlaybackToken?: string | null;
	signedStoryboardPlaybackToken?: string | null;
	durationSeconds?: number | null;
	status: MuxAssetStatuses;
	finishedUploadingAt?: number | null;
};

export type CourseAssessmentQuestionFragment = {
	__typename?: "AssessmentQuestion";
	id: string;
	correctAnswer: string;
	order: number;
	questionText: string;
	questionType: CoursesAssessmentQuestionTypes;
	image?:
		| {
				__typename: "AudioAttachment";
				duration?: number | null;
				waveformUrl?: string | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "ImageAttachment";
				height?: number | null;
				width?: number | null;
				blurhash?: string | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "OtherAttachment";
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "VideoAttachment";
				height?: number | null;
				width?: number | null;
				duration?: number | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				preview: { __typename?: "AttachmentSource"; url: string };
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| null;
	options: Array<{
		__typename?: "AssessmentQuestionOption";
		id: string;
		isCorrect: boolean;
		optionText: string;
		order: number;
	}>;
};

export type BaseCompanyMemberFragment = {
	__typename?: "CompanyMember";
	id: string;
	createdAt: number;
	updatedAtMs: string;
	joinedAt: number;
	status: MemberStatuses;
	phone?: string | null;
	accessLevel: AccessLevel;
	totalSpent: number;
	usdTotalSpent: string;
	mrr: string;
	user?: {
		__typename?: "CompanyMemberUser";
		id: string;
		email?: string | null;
		name?: string | null;
		username: string;
	} | null;
	imageSrcset: { __typename?: "ImgSrcset"; original: string };
};

export type MessageFragment = {
	__typename?: "DmsPost";
	id: string;
	createdAt: string;
	updatedAt: string;
	content?: string | null;
	richContent?: string | null;
	isDeleted: boolean;
	isEdited: boolean;
	isPinned: boolean;
	isEveryoneMentioned: boolean;
	mentionedUserIds: Array<string>;
	messageType: DmsPostTypes;
	replyingToPostId?: string | null;
	viewCount?: number | null;
	attachments: Array<
		| {
				__typename?: "AudioAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "ImageAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "OtherAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
		| {
				__typename?: "VideoAttachment";
				id: string;
				contentType?: string | null;
				sourceUrl?: string | null;
		  }
	>;
	user: {
		__typename?: "PublicProfileUser";
		id: string;
		name?: string | null;
		username: string;
		phoneVerified: boolean;
		city?: string | null;
		country?: string | null;
		profilePicture?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type BasePromoCodeFragment = {
	__typename?: "PromoCode";
	id: string;
	code?: string | null;
	promoType: PromoTypes;
	duration?: PromoDurations | null;
	createdAt: number;
	expirationDatetime?: number | null;
	baseCurrency: Currencies;
	amountOff: number;
	discountOff: string;
	existingMembershipsOnly: boolean;
	numberOfIntervals?: number | null;
	status: PromoCodeStatus;
	stock: number;
	unlimitedStock: boolean;
	uses: number;
	onePerCustomer: boolean;
	churnedUsersOnly: boolean;
	newUsersOnly: boolean;
	accessPass?: { __typename?: "AccessPass"; id: string; title: string } | null;
};

export type BasePublicPromoCodeFragment = {
	__typename?: "PublicPromoCode";
	id: string;
	code: string;
	createdAt: number;
	promoType: PromoTypes;
	baseCurrency: Currencies;
	duration: PromoDurations;
	amountOff: number;
	discountOff: string;
	existingMembershipsOnly: boolean;
	numberOfIntervals: number;
	isPopupPromo: boolean;
};

export type BaseWebhookFragment = {
	__typename?: "Webhook";
	id: string;
	url: string;
	apiVersion: ApiVersion;
	createdAt: number;
	enabled: boolean;
	events: Array<WebhookEvent>;
	resourceId: string;
	webhookSecret: string;
};

export type CreateAccessPassMutationVariables = Exact<{
	input: CreateAccessPassInput;
}>;

export type CreateAccessPassMutation = {
	__typename?: "PublicMutation";
	createAccessPass?: {
		__typename?: "AccessPass";
		id: string;
		createdAt: number;
		route: string;
		title: string;
		headline?: string | null;
		shortenedDescription?: string | null;
		verified: boolean;
		visibility: Visibility;
		activeUsersCount: number;
		reviewsAverage: number;
		creatorPitch?: string | null;
		updatedAtMs: string;
		showOffers: boolean;
		redirectPurchaseUrl?: string | null;
		customCta: CustomCtas;
		customCtaUrl?: string | null;
		globalAffiliatePercentage?: number | null;
		globalAffiliateStatus: GlobalAffiliateStatuses;
		memberAffiliatePercentage?: number | null;
		memberAffiliateStatus: GlobalAffiliateStatuses;
		showMemberCount: boolean;
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		bannerImage?:
			| {
					__typename?: "AudioAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "ImageAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "OtherAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "VideoAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type DeleteAccessPassMutationVariables = Exact<{
	input: DeleteAccessPassInput;
}>;

export type DeleteAccessPassMutation = {
	__typename?: "PublicMutation";
	deleteAccessPass?: boolean | null;
};

export type GetAccessPassQueryVariables = Exact<{
	accessPassId: Scalars["ID"]["input"];
}>;

export type GetAccessPassQuery = {
	__typename?: "PublicQuery";
	accessPass: {
		__typename?: "PublicAccessPass";
		headline?: string | null;
		reviewsAverage: number;
		id: string;
		title: string;
		shortenedDescription?: string | null;
		verified: boolean;
		visibility: Visibility;
		route: string;
		activeUsersCount: number;
		bannerImage?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		company: {
			__typename?: "PublicCompany";
			id: string;
			title: string;
			route: string;
			logo?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
			bannerImage?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
		ownerUser: {
			__typename?: "PublicProfileUser";
			id: string;
			name?: string | null;
			username: string;
			phoneVerified: boolean;
			city?: string | null;
			country?: string | null;
			profilePicture?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
		galleryImages: {
			__typename?: "AttachmentInterfaceConnection";
			nodes?: Array<
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null
			> | null;
		};
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type UpdateAccessPassMutationVariables = Exact<{
	input: UpdateAccessPassInput;
}>;

export type UpdateAccessPassMutation = {
	__typename?: "PublicMutation";
	updateAccessPass?: {
		__typename?: "AccessPass";
		id: string;
		createdAt: number;
		route: string;
		title: string;
		headline?: string | null;
		shortenedDescription?: string | null;
		verified: boolean;
		visibility: Visibility;
		activeUsersCount: number;
		reviewsAverage: number;
		creatorPitch?: string | null;
		updatedAtMs: string;
		showOffers: boolean;
		redirectPurchaseUrl?: string | null;
		customCta: CustomCtas;
		customCtaUrl?: string | null;
		globalAffiliatePercentage?: number | null;
		globalAffiliateStatus: GlobalAffiliateStatuses;
		memberAffiliatePercentage?: number | null;
		memberAffiliateStatus: GlobalAffiliateStatuses;
		showMemberCount: boolean;
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		bannerImage?:
			| {
					__typename?: "AudioAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "ImageAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "OtherAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "VideoAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type CheckIfUserHasAccessToAccessPassQueryVariables = Exact<{
	accessPassId: Scalars["ID"]["input"];
	userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CheckIfUserHasAccessToAccessPassQuery = {
	__typename?: "PublicQuery";
	hasAccessToAccessPass: {
		__typename?: "HasAccessResult";
		hasAccess: boolean;
		accessLevel: AccessLevel;
	};
};

export type CheckIfUserHasAccessToCompanyQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CheckIfUserHasAccessToCompanyQuery = {
	__typename?: "PublicQuery";
	hasAccessToCompany: {
		__typename?: "HasAccessResult";
		hasAccess: boolean;
		accessLevel: AccessLevel;
	};
};

export type CheckIfUserHasAccessToExperienceQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
	userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CheckIfUserHasAccessToExperienceQuery = {
	__typename?: "PublicQuery";
	hasAccessToExperience: {
		__typename?: "HasAccessResult";
		hasAccess: boolean;
		accessLevel: AccessLevel;
	};
};

export type CreateAffiliateMutationVariables = Exact<{
	input: CreateAffiliateInput;
}>;

export type CreateAffiliateMutation = {
	__typename?: "PublicMutation";
	createAffiliate?: {
		__typename?: "Affiliate";
		id: string;
		status?: Status | null;
		activeMembersCount: number;
		affiliateType?: AffiliateTypes | null;
		totalPlanCount: number;
		totalReferralEarnings: string;
		totalReferrals: number;
		totalRevenue: string;
		userAccount: {
			__typename?: "PublicProfileUser";
			id: string;
			name?: string | null;
			username: string;
			phoneVerified: boolean;
			city?: string | null;
			country?: string | null;
			profilePicture?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
	} | null;
};

export type GetAffiliateQueryVariables = Exact<{
	affiliateId: Scalars["ID"]["input"];
	companyId: Scalars["ID"]["input"];
}>;

export type GetAffiliateQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		affiliate: {
			__typename?: "Affiliate";
			id: string;
			status?: Status | null;
			activeMembersCount: number;
			affiliateType?: AffiliateTypes | null;
			totalPlanCount: number;
			totalReferralEarnings: string;
			totalReferrals: number;
			totalRevenue: string;
			userAccount: {
				__typename?: "PublicProfileUser";
				id: string;
				name?: string | null;
				username: string;
				phoneVerified: boolean;
				city?: string | null;
				country?: string | null;
				profilePicture?:
					| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
					| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
					| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
					| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
					| null;
			};
		};
	} | null;
};

export type ListAffiliatesQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	direction?: InputMaybe<Direction>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	order?: InputMaybe<AffiliatesSortableColumns>;
}>;

export type ListAffiliatesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		affiliates: {
			__typename?: "AffiliateConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				startCursor?: string | null;
				hasPreviousPage: boolean;
				hasNextPage: boolean;
				endCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "Affiliate";
				id: string;
				status?: Status | null;
				activeMembersCount: number;
				affiliateType?: AffiliateTypes | null;
				totalPlanCount: number;
				totalReferralEarnings: string;
				totalReferrals: number;
				totalRevenue: string;
				userAccount: {
					__typename?: "PublicProfileUser";
					id: string;
					name?: string | null;
					username: string;
					phoneVerified: boolean;
					city?: string | null;
					country?: string | null;
					profilePicture?:
						| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
						| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
						| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
						| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
						| null;
				};
			} | null> | null;
		};
	} | null;
};

export type UpdateAffiliateMutationVariables = Exact<{
	input: UpdateAffiliateInput;
}>;

export type UpdateAffiliateMutation = {
	__typename?: "PublicMutation";
	updateAffiliate?: {
		__typename?: "Affiliate";
		id: string;
		status?: Status | null;
		activeMembersCount: number;
		affiliateType?: AffiliateTypes | null;
		totalPlanCount: number;
		totalReferralEarnings: string;
		totalReferrals: number;
		totalRevenue: string;
		userAccount: {
			__typename?: "PublicProfileUser";
			id: string;
			name?: string | null;
			username: string;
			phoneVerified: boolean;
			city?: string | null;
			country?: string | null;
			profilePicture?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
	} | null;
};

export type CreateAppBuildMutationVariables = Exact<{
	input: CreateAppBuildInput;
}>;

export type CreateAppBuildMutation = {
	__typename?: "PublicMutation";
	createAppBuild?: {
		__typename?: "AppBuild";
		id: string;
		createdAt: number;
		fileUrl: string;
		checksum: string;
		platform: AppBuildPlatforms;
		reviewMessage?: string | null;
		supportedAppViewTypes: Array<AppViewTypes>;
		status: AppBuildStatuses;
	} | null;
};

export type CreateAppMutationVariables = Exact<{
	input: CreateAppInput;
}>;

export type CreateAppMutation = {
	__typename?: "PublicMutation";
	createApp?: {
		__typename?: "App";
		id: string;
		name: string;
		description?: string | null;
		status: AppStatuses;
		usingDefaultIcon: boolean;
		baseUrl?: string | null;
		baseDevUrl?: string | null;
		experiencePath?: string | null;
		discoverPath?: string | null;
		dashboardPath?: string | null;
		apiKeys: {
			__typename?: "PrivateApiKeyConnection";
			nodes?: Array<{
				__typename?: "PrivateApiKey";
				id: string;
				token: string;
				createdAt: number;
			} | null> | null;
		};
		agentUsers: {
			__typename?: "UserConnection";
			nodes?: Array<{
				__typename?: "User";
				id: string;
				name?: string | null;
				username: string;
			} | null> | null;
		};
		company: { __typename?: "PublicCompany"; id: string };
		accessPass: { __typename?: "AccessPass"; id: string };
		icon?:
			| {
					__typename?: "AudioAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "ImageAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "OtherAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename?: "VideoAttachment";
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type GetAppQueryVariables = Exact<{
	appId: Scalars["ID"]["input"];
	companyId: Scalars["ID"]["input"];
}>;

export type GetAppQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		app: {
			__typename?: "App";
			id: string;
			name: string;
			description?: string | null;
			status: AppStatuses;
			usingDefaultIcon: boolean;
			baseUrl?: string | null;
			baseDevUrl?: string | null;
			experiencePath?: string | null;
			discoverPath?: string | null;
			dashboardPath?: string | null;
			stats?: {
				__typename?: "PublicAppStats";
				dau: number;
				mau: number;
				timeSpentLast24HoursInSeconds: number;
				wau: number;
			} | null;
			apiKeys: {
				__typename?: "PrivateApiKeyConnection";
				nodes?: Array<{
					__typename?: "PrivateApiKey";
					id: string;
					token: string;
					createdAt: number;
				} | null> | null;
			};
			agentUsers: {
				__typename?: "UserConnection";
				nodes?: Array<{
					__typename?: "User";
					id: string;
					name?: string | null;
					username: string;
				} | null> | null;
			};
			accessPass: {
				__typename?: "AccessPass";
				id: string;
				marketplaceStatus: MarketplaceStatuses;
				activeMembershipsCount: number;
				marketplaceCategory?: {
					__typename?: "MarketplaceCategory";
					id: string;
					name: string;
				} | null;
			};
			icon?:
				| {
						__typename?: "AudioAttachment";
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename?: "ImageAttachment";
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename?: "OtherAttachment";
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename?: "VideoAttachment";
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null;
		};
	} | null;
};

export type ListAppsQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListAppsQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		apps: {
			__typename?: "AppConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "App";
				id: string;
				name: string;
				description?: string | null;
				status: AppStatuses;
				usingDefaultIcon: boolean;
				baseUrl?: string | null;
				baseDevUrl?: string | null;
				experiencePath?: string | null;
				discoverPath?: string | null;
				dashboardPath?: string | null;
				stats?: {
					__typename?: "PublicAppStats";
					dau: number;
					mau: number;
					timeSpentLast24HoursInSeconds: number;
					wau: number;
				} | null;
				accessPass: {
					__typename?: "AccessPass";
					id: string;
					marketplaceStatus: MarketplaceStatuses;
				};
				icon?:
					| {
							__typename?: "AudioAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "ImageAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "OtherAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "VideoAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| null;
			} | null> | null;
		};
	} | null;
};

export type PromoteAppBuildMutationVariables = Exact<{
	input: PromoteAppBuildToProductionInput;
}>;

export type PromoteAppBuildMutation = {
	__typename?: "PublicMutation";
	promoteAppBuildToProduction?: boolean | null;
};

export type UnassignAppBuildMutationVariables = Exact<{
	input: UnassignProductionAppBuildInput;
}>;

export type UnassignAppBuildMutation = {
	__typename?: "PublicMutation";
	unassignProductionAppBuild?: boolean | null;
};

export type UpdateAppPermissionsMutationVariables = Exact<{
	input: UpdateAppPermissionRequirementsInput;
}>;

export type UpdateAppPermissionsMutation = {
	__typename?: "PublicMutation";
	updateAppPermissionRequirements?: boolean | null;
};

export type UpdateAppMutationVariables = Exact<{
	input: UpdateAppInput;
}>;

export type UpdateAppMutation = {
	__typename?: "PublicMutation";
	updateApp?: boolean | null;
};

export type GetAttachmentQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type GetAttachmentQuery = {
	__typename?: "PublicQuery";
	attachment:
		| {
				__typename: "AudioAttachment";
				duration?: number | null;
				waveformUrl?: string | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "ImageAttachment";
				height?: number | null;
				width?: number | null;
				blurhash?: string | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "OtherAttachment";
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				source: { __typename?: "AttachmentSource"; url: string };
		  }
		| {
				__typename: "VideoAttachment";
				height?: number | null;
				width?: number | null;
				duration?: number | null;
				aspectRatio?: number | null;
				id: string;
				signedId?: string | null;
				analyzed: boolean;
				byteSizeV2?: string | null;
				filename?: string | null;
				contentType?: string | null;
				preview: { __typename?: "AttachmentSource"; url: string };
				source: { __typename?: "AttachmentSource"; url: string };
		  };
};

export type ProcessAttachmentMutationVariables = Exact<{
	input: AnalyzeAttachmentInput;
}>;

export type ProcessAttachmentMutation = {
	__typename?: "PublicMutation";
	mediaAnalyzeAttachment?: boolean | null;
};

export type UploadMediaMutationVariables = Exact<{
	input: DirectUploadInput;
}>;

export type UploadMediaMutation = {
	__typename?: "PublicMutation";
	mediaDirectUpload?: {
		__typename?: "DirectUpload";
		id: string;
		headers: { [key: string]: any };
		uploadUrl?: string | null;
		multipartUploadId?: string | null;
		multipartUploadUrls?: Array<{
			__typename?: "MultipartUrl";
			partNumber: number;
			url: string;
		}> | null;
	} | null;
};

export type GetCompanyLedgerAccountQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
}>;

export type GetCompanyLedgerAccountQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		ledgerAccount: {
			__typename?: "LedgerAccount";
			id: string;
			transferFee?: number | null;
			balanceCaches: {
				__typename?: "BalanceCacheConnection";
				nodes?: Array<{
					__typename?: "BalanceCache";
					balance: number;
					pendingBalance: number;
					currency: Currencies;
				} | null> | null;
			};
		};
	} | null;
};

export type GetCompanyQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
}>;

export type GetCompanyQuery = {
	__typename?: "PublicQuery";
	company: {
		__typename?: "PublicCompany";
		industryType?: IndustryTypes | null;
		businessType?: BusinessTypes | null;
		id: string;
		title: string;
		route: string;
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		bannerImage?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type GetMemberQueryVariables = Exact<{
	companyMemberId: Scalars["ID"]["input"];
	companyId: Scalars["ID"]["input"];
}>;

export type GetMemberQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		member: {
			__typename?: "CompanyMember";
			id: string;
			createdAt: number;
			updatedAtMs: string;
			joinedAt: number;
			status: MemberStatuses;
			phone?: string | null;
			accessLevel: AccessLevel;
			totalSpent: number;
			usdTotalSpent: string;
			mrr: string;
			user?: {
				__typename?: "CompanyMemberUser";
				id: string;
				email?: string | null;
				name?: string | null;
				username: string;
			} | null;
			imageSrcset: { __typename?: "ImgSrcset"; original: string };
		};
	} | null;
};

export type ListAccessPassesQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	visibility?: InputMaybe<VisibilityFilter>;
	order?: InputMaybe<AccessPassOrder>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	direction?: InputMaybe<Direction>;
	conditions?: InputMaybe<Array<AccessPassConditions> | AccessPassConditions>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	after?: InputMaybe<Scalars["String"]["input"]>;
	accessPassTypes?: InputMaybe<Array<AccessPassTypes> | AccessPassTypes>;
}>;

export type ListAccessPassesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		accessPasses: {
			__typename?: "AccessPassConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "AccessPass";
				id: string;
				createdAt: number;
				route: string;
				title: string;
				headline?: string | null;
				shortenedDescription?: string | null;
				verified: boolean;
				visibility: Visibility;
				activeUsersCount: number;
				reviewsAverage: number;
				creatorPitch?: string | null;
				updatedAtMs: string;
				showOffers: boolean;
				redirectPurchaseUrl?: string | null;
				customCta: CustomCtas;
				customCtaUrl?: string | null;
				globalAffiliatePercentage?: number | null;
				globalAffiliateStatus: GlobalAffiliateStatuses;
				memberAffiliatePercentage?: number | null;
				memberAffiliateStatus: GlobalAffiliateStatuses;
				showMemberCount: boolean;
				logo?:
					| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
					| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
					| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
					| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
					| null;
				bannerImage?:
					| {
							__typename?: "AudioAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "ImageAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "OtherAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename?: "VideoAttachment";
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| null;
			} | null> | null;
		};
	} | null;
};

export type ListAuthorizedUsersQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
}>;

export type ListAuthorizedUsersQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		authorizedUsers: Array<{
			__typename?: "AuthorizedUser";
			id: string;
			name?: string | null;
			username: string;
			userId: string;
			email?: string | null;
			role: AuthorizedUserRoles;
		}>;
	} | null;
};

export type ListMembersQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	direction?: InputMaybe<Direction>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	order?: InputMaybe<MembersSortableColumns>;
	filters?: InputMaybe<MembersFiltersInput>;
}>;

export type ListMembersQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		members: {
			__typename?: "CompanyMemberConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				startCursor?: string | null;
				hasPreviousPage: boolean;
				hasNextPage: boolean;
				endCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "CompanyMember";
				id: string;
				createdAt: number;
				updatedAtMs: string;
				joinedAt: number;
				status: MemberStatuses;
				phone?: string | null;
				accessLevel: AccessLevel;
				totalSpent: number;
				usdTotalSpent: string;
				mrr: string;
				user?: {
					__typename?: "CompanyMemberUser";
					id: string;
					email?: string | null;
					name?: string | null;
					username: string;
				} | null;
				imageSrcset: { __typename?: "ImgSrcset"; original: string };
			} | null> | null;
		};
	} | null;
};

export type ListMembershipsQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	direction?: InputMaybe<Direction>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	order?: InputMaybe<MembershipsSortableColumns>;
	filters?: InputMaybe<MembershipsFiltersInput>;
}>;

export type ListMembershipsQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		memberships: {
			__typename?: "MembershipConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				startCursor?: string | null;
				hasPreviousPage: boolean;
				hasNextPage: boolean;
				endCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "Membership";
				id: string;
				status: MembershipStatus;
				createdAt: number;
				expiresAt?: number | null;
				canceledAt?: number | null;
				totalSpend: number;
				cancelationReason?: string | null;
				member?: {
					__typename?: "Member";
					id: string;
					name?: string | null;
					username?: string | null;
					email?: string | null;
					profilePicture?:
						| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
						| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
						| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
						| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
						| null;
				} | null;
				plan: { __typename?: "Plan"; id: string };
				accessPass: { __typename?: "AccessPass"; id: string; title: string };
				promoCode?: { __typename?: "PromoCode"; code?: string | null } | null;
			} | null> | null;
		};
	} | null;
};

export type ListPlansQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	filter?: InputMaybe<PlanFilters>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListPlansQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		plans: {
			__typename?: "PlanConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "Plan";
				id: string;
				baseCurrency: Currencies;
				rawRenewalPrice: number;
				rawInitialPrice: number;
				initialPriceDue: number;
				createdAt: number;
				updatedAt: number;
				billingPeriod?: number | null;
				trialPeriodDays?: number | null;
				expirationDays?: number | null;
				unlimitedStock: boolean;
				paymentLinkDescription?: string | null;
				releaseMethod: ReleaseMethod;
				stock: number;
				visibility: Visibility;
				planType: PlanTypes;
				title: string;
				description?: string | null;
				name?: string | null;
				formattedPrice: string;
				formattedBillingPeriod?: string | null;
				accessPass?: {
					__typename?: "AccessPass";
					id: string;
					title: string;
					route: string;
					logo?:
						| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
						| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
						| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
						| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
						| null;
				} | null;
			} | null> | null;
		};
	} | null;
};

export type ListWaitlistEntriesQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	direction?: InputMaybe<Direction>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	order?: InputMaybe<EntriesSortableColumns>;
	filters?: InputMaybe<EntriesFiltersInput>;
}>;

export type ListWaitlistEntriesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		entries: {
			__typename?: "EntryConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "Entry";
				id: string;
				name?: string | null;
				status: EntryStatus;
				createdAt?: number | null;
				updatedAtMs: string;
				user: {
					__typename?: "PublicProfileUser";
					id: string;
					name?: string | null;
					username: string;
					profilePicture?:
						| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
						| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
						| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
						| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
						| null;
				};
				plan?: { __typename?: "Plan"; id: string; title: string } | null;
				accessPass?: {
					__typename?: "PublicAccessPass";
					id: string;
					title: string;
				} | null;
				customFieldResponses?: Array<{
					__typename?: "CustomFieldResponse";
					id: string;
					question: string;
					answer: string;
				}> | null;
				member?: {
					__typename?: "Member";
					id: string;
					email?: string | null;
				} | null;
			} | null> | null;
		};
	} | null;
};

export type CreateAssessmentQuestionMutationVariables = Exact<{
	input: CreateAssessmentQuestionInput;
}>;

export type CreateAssessmentQuestionMutation = {
	__typename?: "PublicMutation";
	createAssessmentQuestion?: {
		__typename?: "AssessmentQuestion";
		id: string;
		correctAnswer: string;
		order: number;
		questionText: string;
		questionType: CoursesAssessmentQuestionTypes;
		image?:
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
		options: Array<{
			__typename?: "AssessmentQuestionOption";
			id: string;
			isCorrect: boolean;
			optionText: string;
			order: number;
		}>;
	} | null;
};

export type CreateChapterMutationVariables = Exact<{
	input: CreateChapterInput;
}>;

export type CreateChapterMutation = {
	__typename?: "PublicMutation";
	createChapter?: {
		__typename?: "Chapter";
		id: string;
		title: string;
		order: number;
		lessons: Array<{
			__typename?: "Lesson";
			id: string;
			lessonType: LessonTypes;
			title: string;
			order: number;
			visibility: LessonVisibilities;
			daysFromCourseStartUntilUnlock?: number | null;
			content?: string | null;
			muxAsset?: {
				__typename?: "MuxAsset";
				id: string;
				muxAssetId?: string | null;
				playbackId?: string | null;
				signedPlaybackId?: string | null;
				signedThumbnailPlaybackToken?: string | null;
				signedVideoPlaybackToken?: string | null;
				signedStoryboardPlaybackToken?: string | null;
				durationSeconds?: number | null;
				status: MuxAssetStatuses;
				finishedUploadingAt?: number | null;
			} | null;
		}>;
	} | null;
};

export type CreateCourseMutationVariables = Exact<{
	input: CreateCourseInput;
}>;

export type CreateCourseMutation = {
	__typename?: "PublicMutation";
	createCourse?: {
		__typename?: "Course";
		certificateAfterCompletionEnabled?: boolean | null;
		coverImage?: string | null;
		description?: string | null;
		id: string;
		language: Languages;
		requireCompletingLessonsInOrder: boolean;
		tagline?: string | null;
		title?: string | null;
		videoProtectionEnabled: boolean;
		chapters: Array<{
			__typename?: "Chapter";
			id: string;
			title: string;
			order: number;
			lessons: Array<{
				__typename?: "Lesson";
				id: string;
				lessonType: LessonTypes;
				title: string;
				order: number;
				visibility: LessonVisibilities;
				daysFromCourseStartUntilUnlock?: number | null;
				content?: string | null;
				muxAsset?: {
					__typename?: "MuxAsset";
					id: string;
					muxAssetId?: string | null;
					playbackId?: string | null;
					signedPlaybackId?: string | null;
					signedThumbnailPlaybackToken?: string | null;
					signedVideoPlaybackToken?: string | null;
					signedStoryboardPlaybackToken?: string | null;
					durationSeconds?: number | null;
					status: MuxAssetStatuses;
					finishedUploadingAt?: number | null;
				} | null;
			}>;
		}>;
	} | null;
};

export type CreateLessonMutationVariables = Exact<{
	input: CreateLessonInput;
}>;

export type CreateLessonMutation = {
	__typename?: "PublicMutation";
	createLesson?: {
		__typename?: "Lesson";
		id: string;
		lessonType: LessonTypes;
		title: string;
		order: number;
		visibility: LessonVisibilities;
		content?: string | null;
		daysFromCourseStartUntilUnlock?: number | null;
		muxAsset?: {
			__typename?: "MuxAsset";
			id: string;
			muxAssetId?: string | null;
			playbackId?: string | null;
			signedPlaybackId?: string | null;
			signedThumbnailPlaybackToken?: string | null;
			signedVideoPlaybackToken?: string | null;
			signedStoryboardPlaybackToken?: string | null;
			durationSeconds?: number | null;
			status: MuxAssetStatuses;
			finishedUploadingAt?: number | null;
		} | null;
		assessmentQuestions: Array<{
			__typename?: "AssessmentQuestion";
			id: string;
			correctAnswer: string;
			order: number;
			questionText: string;
			questionType: CoursesAssessmentQuestionTypes;
			image?:
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null;
			options: Array<{
				__typename?: "AssessmentQuestionOption";
				id: string;
				isCorrect: boolean;
				optionText: string;
				order: number;
			}>;
		}>;
		attachments: {
			__typename?: "AttachmentInterfaceConnection";
			nodes?: Array<
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null
			> | null;
		};
		mainPdf?:
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type DeleteAssessmentQuestionImageMutationVariables = Exact<{
	input: DeleteAssessmentQuestionImageInput;
}>;

export type DeleteAssessmentQuestionImageMutation = {
	__typename?: "PublicMutation";
	deleteAssessmentQuestionImage?: boolean | null;
};

export type DeleteChapterMutationVariables = Exact<{
	input: DeleteChapterInput;
}>;

export type DeleteChapterMutation = {
	__typename?: "PublicMutation";
	deleteChapter?: boolean | null;
};

export type DeleteLessonAttachmentMutationVariables = Exact<{
	input: DeleteLessonAttachmentInput;
}>;

export type DeleteLessonAttachmentMutation = {
	__typename?: "PublicMutation";
	deleteLessonAttachment?: boolean | null;
};

export type DeleteLessonMutationVariables = Exact<{
	input: DeleteLessonInput;
}>;

export type DeleteLessonMutation = {
	__typename?: "PublicMutation";
	deleteLesson?: boolean | null;
};

export type GetCourseQueryVariables = Exact<{
	courseId: Scalars["ID"]["input"];
}>;

export type GetCourseQuery = {
	__typename?: "PublicQuery";
	course?: {
		__typename?: "Course";
		certificateAfterCompletionEnabled?: boolean | null;
		coverImage?: string | null;
		description?: string | null;
		id: string;
		language: Languages;
		requireCompletingLessonsInOrder: boolean;
		tagline?: string | null;
		title?: string | null;
		videoProtectionEnabled: boolean;
		chapters: Array<{
			__typename?: "Chapter";
			id: string;
			title: string;
			order: number;
			lessons: Array<{
				__typename?: "Lesson";
				id: string;
				lessonType: LessonTypes;
				title: string;
				order: number;
				visibility: LessonVisibilities;
				daysFromCourseStartUntilUnlock?: number | null;
				content?: string | null;
				muxAsset?: {
					__typename?: "MuxAsset";
					id: string;
					muxAssetId?: string | null;
					playbackId?: string | null;
					signedPlaybackId?: string | null;
					signedThumbnailPlaybackToken?: string | null;
					signedVideoPlaybackToken?: string | null;
					signedStoryboardPlaybackToken?: string | null;
					durationSeconds?: number | null;
					status: MuxAssetStatuses;
					finishedUploadingAt?: number | null;
				} | null;
			}>;
		}>;
	} | null;
};

export type GetLessonQueryVariables = Exact<{
	courseId: Scalars["ID"]["input"];
	lessonId: Scalars["ID"]["input"];
}>;

export type GetLessonQuery = {
	__typename?: "PublicQuery";
	course?: {
		__typename?: "Course";
		lesson?: {
			__typename?: "Lesson";
			id: string;
			lessonType: LessonTypes;
			title: string;
			order: number;
			visibility: LessonVisibilities;
			content?: string | null;
			daysFromCourseStartUntilUnlock?: number | null;
			muxAsset?: {
				__typename?: "MuxAsset";
				id: string;
				muxAssetId?: string | null;
				playbackId?: string | null;
				signedPlaybackId?: string | null;
				signedThumbnailPlaybackToken?: string | null;
				signedVideoPlaybackToken?: string | null;
				signedStoryboardPlaybackToken?: string | null;
				durationSeconds?: number | null;
				status: MuxAssetStatuses;
				finishedUploadingAt?: number | null;
			} | null;
			assessmentQuestions: Array<{
				__typename?: "AssessmentQuestion";
				id: string;
				correctAnswer: string;
				order: number;
				questionText: string;
				questionType: CoursesAssessmentQuestionTypes;
				image?:
					| {
							__typename: "AudioAttachment";
							duration?: number | null;
							waveformUrl?: string | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "ImageAttachment";
							height?: number | null;
							width?: number | null;
							blurhash?: string | null;
							aspectRatio?: number | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "OtherAttachment";
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "VideoAttachment";
							height?: number | null;
							width?: number | null;
							duration?: number | null;
							aspectRatio?: number | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							preview: { __typename?: "AttachmentSource"; url: string };
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| null;
				options: Array<{
					__typename?: "AssessmentQuestionOption";
					id: string;
					isCorrect: boolean;
					optionText: string;
					order: number;
				}>;
			}>;
			attachments: {
				__typename?: "AttachmentInterfaceConnection";
				nodes?: Array<
					| {
							__typename: "AudioAttachment";
							duration?: number | null;
							waveformUrl?: string | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "ImageAttachment";
							height?: number | null;
							width?: number | null;
							blurhash?: string | null;
							aspectRatio?: number | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "OtherAttachment";
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| {
							__typename: "VideoAttachment";
							height?: number | null;
							width?: number | null;
							duration?: number | null;
							aspectRatio?: number | null;
							id: string;
							signedId?: string | null;
							analyzed: boolean;
							byteSizeV2?: string | null;
							filename?: string | null;
							contentType?: string | null;
							preview: { __typename?: "AttachmentSource"; url: string };
							source: { __typename?: "AttachmentSource"; url: string };
					  }
					| null
				> | null;
			};
			mainPdf?:
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null;
		} | null;
	} | null;
};

export type GetUserLessonInteractionsQueryVariables = Exact<{
	courseId: Scalars["ID"]["input"];
}>;

export type GetUserLessonInteractionsQuery = {
	__typename?: "PublicQuery";
	course?: {
		__typename?: "Course";
		chapters: Array<{
			__typename?: "Chapter";
			id: string;
			lessons: Array<{
				__typename?: "Lesson";
				id: string;
				lessonInteraction?: {
					__typename?: "LessonInteraction";
					id: string;
					completed: boolean;
					createdAt: number;
				} | null;
			}>;
		}>;
	} | null;
};

export type ListCoursesForCompanyQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	first?: InputMaybe<Scalars["Int"]["input"]>;
	after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListCoursesForCompanyQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		courses: {
			__typename?: "CourseConnection";
			totalCount: number;
			nodes?: Array<{
				__typename?: "Course";
				id: string;
				title?: string | null;
				coverImage?: string | null;
				experience: {
					__typename?: "PublicExperience";
					id: string;
					accessPasses: Array<{
						__typename?: "PublicAccessPass";
						id: string;
						title: string;
					}>;
				};
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				hasNextPage: boolean;
				endCursor?: string | null;
			};
		};
	} | null;
};

export type ListCoursesForExperienceQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
	first?: InputMaybe<Scalars["Int"]["input"]>;
	after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListCoursesForExperienceQuery = {
	__typename?: "PublicQuery";
	publicExperience: {
		__typename?: "PublicExperience";
		courses: {
			__typename?: "CourseConnection";
			totalCount: number;
			nodes?: Array<{
				__typename?: "Course";
				certificateAfterCompletionEnabled?: boolean | null;
				coverImage?: string | null;
				description?: string | null;
				id: string;
				language: Languages;
				requireCompletingLessonsInOrder: boolean;
				tagline?: string | null;
				title?: string | null;
				videoProtectionEnabled: boolean;
				chapters: Array<{
					__typename?: "Chapter";
					id: string;
					title: string;
					order: number;
					lessons: Array<{
						__typename?: "Lesson";
						id: string;
						lessonType: LessonTypes;
						title: string;
						order: number;
						visibility: LessonVisibilities;
						daysFromCourseStartUntilUnlock?: number | null;
						content?: string | null;
						muxAsset?: {
							__typename?: "MuxAsset";
							id: string;
							muxAssetId?: string | null;
							playbackId?: string | null;
							signedPlaybackId?: string | null;
							signedThumbnailPlaybackToken?: string | null;
							signedVideoPlaybackToken?: string | null;
							signedStoryboardPlaybackToken?: string | null;
							durationSeconds?: number | null;
							status: MuxAssetStatuses;
							finishedUploadingAt?: number | null;
						} | null;
					}>;
				}>;
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				hasNextPage: boolean;
				endCursor?: string | null;
			};
		};
	};
};

export type MarkLessonAsCompletedMutationVariables = Exact<{
	input: MarkLessonAsCompletedInput;
}>;

export type MarkLessonAsCompletedMutation = {
	__typename?: "PublicMutation";
	markLessonAsCompleted?: boolean | null;
};

export type MoveCourseMutationVariables = Exact<{
	input: MoveCourseInput;
}>;

export type MoveCourseMutation = {
	__typename?: "PublicMutation";
	moveCourse?: boolean | null;
};

export type UpdateChapterOrderMutationVariables = Exact<{
	input: UpdateChapterOrderInput;
}>;

export type UpdateChapterOrderMutation = {
	__typename?: "PublicMutation";
	updateChapterOrder?: {
		__typename?: "Chapter";
		id: string;
		title: string;
		order: number;
		lessons: Array<{
			__typename?: "Lesson";
			id: string;
			lessonType: LessonTypes;
			title: string;
			order: number;
			visibility: LessonVisibilities;
			daysFromCourseStartUntilUnlock?: number | null;
			content?: string | null;
			muxAsset?: {
				__typename?: "MuxAsset";
				id: string;
				muxAssetId?: string | null;
				playbackId?: string | null;
				signedPlaybackId?: string | null;
				signedThumbnailPlaybackToken?: string | null;
				signedVideoPlaybackToken?: string | null;
				signedStoryboardPlaybackToken?: string | null;
				durationSeconds?: number | null;
				status: MuxAssetStatuses;
				finishedUploadingAt?: number | null;
			} | null;
		}>;
	} | null;
};

export type UpdateChapterMutationVariables = Exact<{
	input: UpdateChapterInput;
}>;

export type UpdateChapterMutation = {
	__typename?: "PublicMutation";
	updateChapter?: {
		__typename?: "Chapter";
		id: string;
		title: string;
		order: number;
		lessons: Array<{
			__typename?: "Lesson";
			id: string;
			lessonType: LessonTypes;
			title: string;
			order: number;
			visibility: LessonVisibilities;
			daysFromCourseStartUntilUnlock?: number | null;
			content?: string | null;
			muxAsset?: {
				__typename?: "MuxAsset";
				id: string;
				muxAssetId?: string | null;
				playbackId?: string | null;
				signedPlaybackId?: string | null;
				signedThumbnailPlaybackToken?: string | null;
				signedVideoPlaybackToken?: string | null;
				signedStoryboardPlaybackToken?: string | null;
				durationSeconds?: number | null;
				status: MuxAssetStatuses;
				finishedUploadingAt?: number | null;
			} | null;
		}>;
	} | null;
};

export type UpdateLessonOrderMutationVariables = Exact<{
	input: UpdateLessonOrderInput;
}>;

export type UpdateLessonOrderMutation = {
	__typename?: "PublicMutation";
	updateLessonOrder?: {
		__typename?: "Lesson";
		id: string;
		lessonType: LessonTypes;
		title: string;
		order: number;
		visibility: LessonVisibilities;
		content?: string | null;
		daysFromCourseStartUntilUnlock?: number | null;
		muxAsset?: {
			__typename?: "MuxAsset";
			id: string;
			muxAssetId?: string | null;
			playbackId?: string | null;
			signedPlaybackId?: string | null;
			signedThumbnailPlaybackToken?: string | null;
			signedVideoPlaybackToken?: string | null;
			signedStoryboardPlaybackToken?: string | null;
			durationSeconds?: number | null;
			status: MuxAssetStatuses;
			finishedUploadingAt?: number | null;
		} | null;
		assessmentQuestions: Array<{
			__typename?: "AssessmentQuestion";
			id: string;
			correctAnswer: string;
			order: number;
			questionText: string;
			questionType: CoursesAssessmentQuestionTypes;
			image?:
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null;
			options: Array<{
				__typename?: "AssessmentQuestionOption";
				id: string;
				isCorrect: boolean;
				optionText: string;
				order: number;
			}>;
		}>;
		attachments: {
			__typename?: "AttachmentInterfaceConnection";
			nodes?: Array<
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null
			> | null;
		};
		mainPdf?:
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type UpdateLessonMutationVariables = Exact<{
	input: UpdateLessonInput;
}>;

export type UpdateLessonMutation = {
	__typename?: "PublicMutation";
	updateLesson?: {
		__typename?: "Lesson";
		id: string;
		lessonType: LessonTypes;
		title: string;
		order: number;
		visibility: LessonVisibilities;
		content?: string | null;
		daysFromCourseStartUntilUnlock?: number | null;
		muxAsset?: {
			__typename?: "MuxAsset";
			id: string;
			muxAssetId?: string | null;
			playbackId?: string | null;
			signedPlaybackId?: string | null;
			signedThumbnailPlaybackToken?: string | null;
			signedVideoPlaybackToken?: string | null;
			signedStoryboardPlaybackToken?: string | null;
			durationSeconds?: number | null;
			status: MuxAssetStatuses;
			finishedUploadingAt?: number | null;
		} | null;
		assessmentQuestions: Array<{
			__typename?: "AssessmentQuestion";
			id: string;
			correctAnswer: string;
			order: number;
			questionText: string;
			questionType: CoursesAssessmentQuestionTypes;
			image?:
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null;
			options: Array<{
				__typename?: "AssessmentQuestionOption";
				id: string;
				isCorrect: boolean;
				optionText: string;
				order: number;
			}>;
		}>;
		attachments: {
			__typename?: "AttachmentInterfaceConnection";
			nodes?: Array<
				| {
						__typename: "AudioAttachment";
						duration?: number | null;
						waveformUrl?: string | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "ImageAttachment";
						height?: number | null;
						width?: number | null;
						blurhash?: string | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "OtherAttachment";
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| {
						__typename: "VideoAttachment";
						height?: number | null;
						width?: number | null;
						duration?: number | null;
						aspectRatio?: number | null;
						id: string;
						signedId?: string | null;
						analyzed: boolean;
						byteSizeV2?: string | null;
						filename?: string | null;
						contentType?: string | null;
						preview: { __typename?: "AttachmentSource"; url: string };
						source: { __typename?: "AttachmentSource"; url: string };
				  }
				| null
			> | null;
		};
		mainPdf?:
			| {
					__typename: "AudioAttachment";
					duration?: number | null;
					waveformUrl?: string | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "ImageAttachment";
					height?: number | null;
					width?: number | null;
					blurhash?: string | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "OtherAttachment";
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| {
					__typename: "VideoAttachment";
					height?: number | null;
					width?: number | null;
					duration?: number | null;
					aspectRatio?: number | null;
					id: string;
					signedId?: string | null;
					analyzed: boolean;
					byteSizeV2?: string | null;
					filename?: string | null;
					contentType?: string | null;
					preview: { __typename?: "AttachmentSource"; url: string };
					source: { __typename?: "AttachmentSource"; url: string };
			  }
			| null;
	} | null;
};

export type GetExperienceQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
}>;

export type GetExperienceQuery = {
	__typename?: "PublicQuery";
	experience: {
		__typename?: "PublicExperience";
		upsellType?: UpsellTypes | null;
		id: string;
		name: string;
		description?: string | null;
		upsellPlan?: {
			__typename?: "PublicPlan";
			id: string;
			baseCurrency: Currencies;
			rawRenewalPrice: number;
			rawInitialPrice: number;
			initialPriceDue: number;
			createdAt: number;
			updatedAt: number;
			billingPeriod?: number | null;
			trialPeriodDays?: number | null;
			expirationDays?: number | null;
			unlimitedStock: boolean;
			paymentLinkDescription?: string | null;
			releaseMethod: ReleaseMethod;
			stock?: number | null;
			visibility: Visibility;
			planType: PlanTypes;
		} | null;
		logo?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		app: {
			__typename?: "PublicApp";
			id: string;
			name: string;
			icon?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
		company: {
			__typename?: "PublicCompany";
			id: string;
			title: string;
			route: string;
			logo?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
			bannerImage?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
	};
};

export type ListAccessPassesForExperienceQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
}>;

export type ListAccessPassesForExperienceQuery = {
	__typename?: "PublicQuery";
	experience: {
		__typename?: "PublicExperience";
		experienceId: string;
		accessPasses: Array<{
			__typename?: "PublicAccessPass";
			id: string;
			title: string;
			shortenedDescription?: string | null;
			verified: boolean;
			visibility: Visibility;
			route: string;
			activeUsersCount: number;
			logo?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		}>;
	};
};

export type ListExperiencesQueryVariables = Exact<{
	after?: InputMaybe<Scalars["String"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	accessPassId?: InputMaybe<Scalars["ID"]["input"]>;
	appId?: InputMaybe<Scalars["ID"]["input"]>;
	onAccessPass?: InputMaybe<Scalars["Boolean"]["input"]>;
	companyId: Scalars["ID"]["input"];
}>;

export type ListExperiencesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		experiencesV2: {
			__typename?: "ExperienceInterfaceConnection";
			totalCount: number;
			nodes?: Array<{
				__typename?: "CustomPrivate";
				id: string;
				name?: string | null;
				description?: string | null;
				logo?: { __typename?: "ImgSrcset"; sourceUrl: string } | null;
				app: {
					__typename?: "PublicApp";
					id: string;
					name: string;
					icon?:
						| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
						| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
						| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
						| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
						| null;
				};
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				hasNextPage: boolean;
				endCursor?: string | null;
			};
		};
	} | null;
};

export type ListUsersForExperienceQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	direction?: InputMaybe<Direction>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	searchQuery?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListUsersForExperienceQuery = {
	__typename?: "PublicQuery";
	publicExperience: {
		__typename?: "PublicExperience";
		users?: {
			__typename?: "PublicProfileUserConnection";
			totalCount: number;
			nodes?: Array<{
				__typename?: "PublicProfileUser";
				id: string;
				username: string;
				profilePicture?:
					| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
					| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
					| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
					| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
					| null;
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
			};
		} | null;
	};
};

export type CreateForumPostMutationVariables = Exact<{
	input: CreateForumPostInput;
}>;

export type CreateForumPostMutation = {
	__typename?: "PublicMutation";
	createForumPost?: {
		__typename?: "ForumPost";
		id: string;
		createdAt: string;
		updatedAt: string;
		content?: string | null;
		richContent?: string | null;
		isDeleted: boolean;
		isEdited: boolean;
		mentionedUserIds: Array<string>;
		parentId?: string | null;
		viewCount?: number | null;
		isPinned: boolean;
		attachments: Array<
			| {
					__typename?: "AudioAttachment";
					id: string;
					contentType?: string | null;
					sourceUrl?: string | null;
			  }
			| {
					__typename?: "ImageAttachment";
					id: string;
					contentType?: string | null;
					sourceUrl?: string | null;
			  }
			| {
					__typename?: "OtherAttachment";
					id: string;
					contentType?: string | null;
					sourceUrl?: string | null;
			  }
			| {
					__typename?: "VideoAttachment";
					id: string;
					contentType?: string | null;
					sourceUrl?: string | null;
			  }
		>;
		user: {
			__typename?: "PublicProfileUser";
			id: string;
			name?: string | null;
			username: string;
			phoneVerified: boolean;
			city?: string | null;
			country?: string | null;
			profilePicture?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
	} | null;
};

export type FindOrCreateForumMutationVariables = Exact<{
	input: CreateForumInput;
}>;

export type FindOrCreateForumMutation = {
	__typename?: "PublicMutation";
	createForum?: { __typename?: "Experience"; id: string; link: string } | null;
};

export type ListForumPostsFromForumQueryVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
}>;

export type ListForumPostsFromForumQuery = {
	__typename?: "PublicQuery";
	feedPosts?: {
		__typename?: "FeedPostsResponse";
		posts: Array<
			| { __typename?: "ChatFeed" }
			| { __typename?: "DmsFeed" }
			| { __typename?: "DmsFeedMember" }
			| { __typename?: "DmsPost" }
			| { __typename?: "ForumFeed" }
			| {
					__typename?: "ForumPost";
					id: string;
					createdAt: string;
					updatedAt: string;
					content?: string | null;
					richContent?: string | null;
					isDeleted: boolean;
					isEdited: boolean;
					mentionedUserIds: Array<string>;
					parentId?: string | null;
					viewCount?: number | null;
					isPinned: boolean;
					attachments: Array<
						| {
								__typename?: "AudioAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "ImageAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "OtherAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "VideoAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
					>;
					user: {
						__typename?: "PublicProfileUser";
						id: string;
						name?: string | null;
						username: string;
						phoneVerified: boolean;
						city?: string | null;
						country?: string | null;
						profilePicture?:
							| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
							| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
							| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
							| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
							| null;
					};
			  }
			| { __typename?: "LivestreamFeed" }
			| { __typename?: "MutedUser" }
			| { __typename?: "PublicLivestreamFeed" }
			| { __typename?: "Reaction" }
			| { __typename?: "ReactionCount" }
		>;
	} | null;
};

export type CreateInvoiceMutationVariables = Exact<{
	input: CreateInvoiceInput;
}>;

export type CreateInvoiceMutation = {
	__typename?: "PublicMutation";
	createInvoice?: {
		__typename?: "CreateInvoicePayload";
		checkoutJobId?: string | null;
		invoice?: {
			__typename?: "Invoice";
			id: string;
			createdAt: number;
			status: InvoiceStatuses;
			number: string;
			dueDate?: number | null;
			emailAddress?: string | null;
			fetchInvoiceToken: string;
			currentPlan: {
				__typename?: "Plan";
				id: string;
				formattedPrice: string;
				baseCurrency: Currencies;
			};
			member?: {
				__typename?: "Member";
				id: string;
				email?: string | null;
				name?: string | null;
				username?: string | null;
			} | null;
		} | null;
	} | null;
};

export type GetInvoiceQueryVariables = Exact<{
	invoiceId: Scalars["ID"]["input"];
	companyId: Scalars["ID"]["input"];
}>;

export type GetInvoiceQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		invoice: {
			__typename?: "Invoice";
			id: string;
			createdAt: number;
			status: InvoiceStatuses;
			number: string;
			dueDate?: number | null;
			emailAddress?: string | null;
			fetchInvoiceToken: string;
			currentPlan: {
				__typename?: "Plan";
				id: string;
				formattedPrice: string;
				baseCurrency: Currencies;
			};
			member?: {
				__typename?: "Member";
				id: string;
				email?: string | null;
				name?: string | null;
				username?: string | null;
			} | null;
		};
	} | null;
};

export type ListInvoicesQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListInvoicesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		invoices: {
			__typename?: "InvoiceConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "Invoice";
				id: string;
				createdAt: number;
				status: InvoiceStatuses;
				number: string;
				dueDate?: number | null;
				emailAddress?: string | null;
				fetchInvoiceToken: string;
				currentPlan: {
					__typename?: "Plan";
					id: string;
					formattedPrice: string;
					baseCurrency: Currencies;
				};
				member?: {
					__typename?: "Member";
					id: string;
					email?: string | null;
					name?: string | null;
					username?: string | null;
				} | null;
			} | null> | null;
		};
	} | null;
};

export type FindOrCreateChatMutationVariables = Exact<{
	input: CreateChatInput;
}>;

export type FindOrCreateChatMutation = {
	__typename?: "PublicMutation";
	createChat?: { __typename?: "Experience"; id: string; link: string } | null;
};

export type ListDirectMessageConversationsQueryVariables = Exact<{
	beforeTimestamp?: InputMaybe<Scalars["BigInt"]["input"]>;
	limit?: InputMaybe<Scalars["Int"]["input"]>;
	query?: InputMaybe<Scalars["String"]["input"]>;
	status?: InputMaybe<DmsFeedMemberStatuses>;
	unread?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListDirectMessageConversationsQuery = {
	__typename?: "PublicQuery";
	myDmsChannelsV2: Array<{
		__typename?: "DmsChannel";
		createdAt: number;
		id: string;
		isPinned: boolean;
		customName?: string | null;
		isGroupChat: boolean;
		isUnread: boolean;
		feedMembers: Array<{
			__typename?: "FeedMember";
			username: string;
			id: string;
		}>;
		lastMessage?: {
			__typename?: "Post";
			content?: string | null;
			userId: string;
		} | null;
	}>;
};

export type ListMessagesFromChatQueryVariables = Exact<{
	chatExperienceId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type ListMessagesFromChatQuery = {
	__typename?: "PublicQuery";
	feedPosts?: {
		__typename?: "FeedPostsResponse";
		posts: Array<
			| { __typename?: "ChatFeed" }
			| { __typename?: "DmsFeed" }
			| { __typename?: "DmsFeedMember" }
			| {
					__typename?: "DmsPost";
					id: string;
					createdAt: string;
					updatedAt: string;
					content?: string | null;
					richContent?: string | null;
					isDeleted: boolean;
					isEdited: boolean;
					isPinned: boolean;
					isEveryoneMentioned: boolean;
					mentionedUserIds: Array<string>;
					messageType: DmsPostTypes;
					replyingToPostId?: string | null;
					viewCount?: number | null;
					attachments: Array<
						| {
								__typename?: "AudioAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "ImageAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "OtherAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
						| {
								__typename?: "VideoAttachment";
								id: string;
								contentType?: string | null;
								sourceUrl?: string | null;
						  }
					>;
					user: {
						__typename?: "PublicProfileUser";
						id: string;
						name?: string | null;
						username: string;
						phoneVerified: boolean;
						city?: string | null;
						country?: string | null;
						profilePicture?:
							| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
							| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
							| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
							| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
							| null;
					};
			  }
			| { __typename?: "ForumFeed" }
			| { __typename?: "ForumPost" }
			| { __typename?: "LivestreamFeed" }
			| { __typename?: "MutedUser" }
			| { __typename?: "PublicLivestreamFeed" }
			| { __typename?: "Reaction" }
			| { __typename?: "ReactionCount" }
		>;
	} | null;
};

export type SendDirectMessageToUserMutationVariables = Exact<{
	toUserIdOrUsername: Scalars["ID"]["input"];
	message: Scalars["String"]["input"];
	attachments?: InputMaybe<Array<AttachmentInput> | AttachmentInput>;
}>;

export type SendDirectMessageToUserMutation = {
	__typename?: "PublicMutation";
	sendMessage?: string | null;
};

export type SendMessageToChatMutationVariables = Exact<{
	experienceId: Scalars["ID"]["input"];
	message: Scalars["String"]["input"];
	attachments?: InputMaybe<Array<AttachmentInput> | AttachmentInput>;
}>;

export type SendMessageToChatMutation = {
	__typename?: "PublicMutation";
	sendMessage?: string | null;
};

export type SendPushNotificationMutationVariables = Exact<{
	input: SendNotificationInput;
}>;

export type SendPushNotificationMutation = {
	__typename?: "PublicMutation";
	sendNotification?: boolean | null;
};

export type ChargeUserMutationVariables = Exact<{
	input: ChargeUserInput;
}>;

export type ChargeUserMutation = {
	__typename?: "PublicMutation";
	chargeUser?: {
		__typename?: "ChargeUserResponse";
		status: ChargeUserResponseStatus;
		inAppPurchase?: {
			__typename?: "CheckoutSession";
			id: string;
			planId: string;
		} | null;
	} | null;
};

export type CreateCheckoutSessionMutationVariables = Exact<{
	input: CreateCheckoutSessionInput;
}>;

export type CreateCheckoutSessionMutation = {
	__typename?: "PublicMutation";
	createCheckoutSession?: {
		__typename?: "CheckoutSession";
		id: string;
		planId: string;
	} | null;
};

export type ListReceiptsForCompanyQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	first?: InputMaybe<Scalars["Int"]["input"]>;
	after?: InputMaybe<Scalars["String"]["input"]>;
	filter?: InputMaybe<ReceiptV2Filters>;
}>;

export type ListReceiptsForCompanyQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		receipts?: {
			__typename?: "ReceiptConnection";
			nodes?: Array<{
				__typename?: "Receipt";
				id: string;
				settledUsdAmount?: number | null;
				billingReason?: string | null;
				last4?: string | null;
				currency?: Currencies | null;
				status?: ReceiptStatus | null;
				createdAt: number;
				total?: number | null;
				brand?: string | null;
				paymentProcessor?: ReceiptPaymentProcessor | null;
				paymentMethodType?: string | null;
				disputeAlertedAt?: number | null;
				finalAmount: number;
				presentedFinalAmount?: number | null;
				presentedSettledUsdAmount?: number | null;
				refundedAmount?: number | null;
				friendlyStatus: FriendlyReceiptStatus;
				failureMessage?: string | null;
				refundable: boolean;
				retryable: boolean;
				paidAt?: number | null;
				amountAfterFees: number;
				chargeSkippedPriceTooLow: boolean;
				lastPaymentAttempt?: number | null;
				autoRefunded: boolean;
				totalUsdAmount?: number | null;
				mostRecentRiskScore?: number | null;
				address?: {
					__typename?: "Address";
					name?: string | null;
					line1?: string | null;
					line2?: string | null;
					city?: string | null;
					state?: string | null;
					postalCode?: string | null;
					country?: string | null;
				} | null;
				member?: {
					__typename?: "CompanyMember";
					header: string;
					user?: {
						__typename?: "CompanyMemberUser";
						id: string;
						username: string;
						name?: string | null;
						email?: string | null;
						country?: string | null;
						countryName?: string | null;
					} | null;
					imageSrcset: {
						__typename?: "ImgSrcset";
						original: string;
						double: string;
						isVideo: boolean;
					};
				} | null;
				plan?: {
					__typename?: "Plan";
					id: string;
					title: string;
					formattedPrice: string;
					initialPrice: number;
					renewalPrice: number;
					paymentLinkDescription?: string | null;
				} | null;
				membership?: {
					__typename?: "Membership";
					id: string;
					status: MembershipStatus;
				} | null;
				promoCode?: {
					__typename?: "PromoCode";
					id: string;
					code?: string | null;
					amountOff: number;
					baseCurrency: Currencies;
					promoType: PromoTypes;
					numberOfIntervals?: number | null;
				} | null;
				accessPass?: {
					__typename?: "AccessPass";
					id: string;
					title: string;
				} | null;
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				hasNextPage: boolean;
				endCursor?: string | null;
			};
		} | null;
	} | null;
};

export type PayUserMutationVariables = Exact<{
	input: TransferFundsInput;
}>;

export type PayUserMutation = {
	__typename?: "PublicMutation";
	transferFunds?: boolean | null;
};

export type CreatePromoCodeMutationVariables = Exact<{
	input: CreatePromoCodeInput;
}>;

export type CreatePromoCodeMutation = {
	__typename?: "PublicMutation";
	createPromoCode?: {
		__typename?: "PromoCode";
		id: string;
		code?: string | null;
		promoType: PromoTypes;
		duration?: PromoDurations | null;
		createdAt: number;
		expirationDatetime?: number | null;
		baseCurrency: Currencies;
		amountOff: number;
		discountOff: string;
		existingMembershipsOnly: boolean;
		numberOfIntervals?: number | null;
		status: PromoCodeStatus;
		stock: number;
		unlimitedStock: boolean;
		uses: number;
		onePerCustomer: boolean;
		churnedUsersOnly: boolean;
		newUsersOnly: boolean;
		accessPass?: {
			__typename?: "AccessPass";
			id: string;
			title: string;
		} | null;
	} | null;
};

export type DeletePromoCodeMutationVariables = Exact<{
	input: DeletePromoCodeInput;
}>;

export type DeletePromoCodeMutation = {
	__typename?: "PublicMutation";
	deletePromoCode?: boolean | null;
};

export type GetPromoCodeQueryVariables = Exact<{
	code: Scalars["String"]["input"];
	planId: Scalars["ID"]["input"];
}>;

export type GetPromoCodeQuery = {
	__typename?: "PublicQuery";
	promoCode: {
		__typename?: "PublicPromoCode";
		id: string;
		code: string;
		createdAt: number;
		promoType: PromoTypes;
		baseCurrency: Currencies;
		duration: PromoDurations;
		amountOff: number;
		discountOff: string;
		existingMembershipsOnly: boolean;
		numberOfIntervals: number;
		isPopupPromo: boolean;
	};
};

export type ListPromoCodesQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
	filters?: InputMaybe<PromoCodeFilters>;
}>;

export type ListPromoCodesQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		promoCodes: {
			__typename?: "PromoCodeConnection";
			totalCount: number;
			pageInfo: {
				__typename?: "PageInfo";
				startCursor?: string | null;
				hasPreviousPage: boolean;
				hasNextPage: boolean;
				endCursor?: string | null;
			};
			nodes?: Array<{
				__typename?: "PromoCode";
				id: string;
				code?: string | null;
				promoType: PromoTypes;
				duration?: PromoDurations | null;
				createdAt: number;
				expirationDatetime?: number | null;
				baseCurrency: Currencies;
				amountOff: number;
				discountOff: string;
				existingMembershipsOnly: boolean;
				numberOfIntervals?: number | null;
				status: PromoCodeStatus;
				stock: number;
				unlimitedStock: boolean;
				uses: number;
				onePerCustomer: boolean;
				churnedUsersOnly: boolean;
				newUsersOnly: boolean;
				accessPass?: {
					__typename?: "AccessPass";
					id: string;
					title: string;
				} | null;
			} | null> | null;
		};
	} | null;
};

export type BanUserMutationVariables = Exact<{
	input: BanUserInput;
}>;

export type BanUserMutation = {
	__typename?: "PublicMutation";
	banUser?: boolean | null;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
	__typename?: "PublicQuery";
	viewer: {
		__typename?: "Viewer";
		user: {
			__typename?: "User";
			bio?: string | null;
			phoneVerified: boolean;
			bannerImage?: string | null;
			createdAt: number;
			dateOfBirthDay?: number | null;
			dateOfBirthMonth?: number | null;
			dateOfBirthYear?: number | null;
			id: string;
			email?: string | null;
			name?: string | null;
			username: string;
			ledgerAccount: {
				__typename?: "LedgerAccount";
				id: string;
				transferFee?: number | null;
				balanceCaches: {
					__typename?: "BalanceCacheConnection";
					nodes?: Array<{
						__typename?: "BalanceCache";
						balance: number;
						pendingBalance: number;
						currency: Currencies;
					} | null> | null;
				};
			};
			profilePicture?:
				| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
				| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
				| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
				| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
				| null;
		};
	};
};

export type GetUserLedgerAccountQueryVariables = Exact<{
	[key: string]: never;
}>;

export type GetUserLedgerAccountQuery = {
	__typename?: "PublicQuery";
	viewer: {
		__typename?: "Viewer";
		user: {
			__typename?: "User";
			ledgerAccount: {
				__typename?: "LedgerAccount";
				id: string;
				transferFee?: number | null;
				balanceCaches: {
					__typename?: "BalanceCacheConnection";
					nodes?: Array<{
						__typename?: "BalanceCache";
						balance: number;
						pendingBalance: number;
						currency: Currencies;
					} | null> | null;
				};
			};
		};
	};
};

export type GetUserQueryVariables = Exact<{
	userId: Scalars["ID"]["input"];
}>;

export type GetUserQuery = {
	__typename?: "PublicQuery";
	publicUser: {
		__typename?: "PublicProfileUser";
		bio?: string | null;
		phoneVerified: boolean;
		createdAt: number;
		id: string;
		name?: string | null;
		username: string;
		city?: string | null;
		country?: string | null;
		banner?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
		userStat?: {
			__typename?: "UserStat";
			moneyEarned24Hours?: number | null;
			moneyEarned30Days?: number | null;
			moneyEarned7Days?: number | null;
			moneyEarnedLifetime?: number | null;
		} | null;
		profilePicture?:
			| { __typename?: "AudioAttachment"; sourceUrl?: string | null }
			| { __typename?: "ImageAttachment"; sourceUrl?: string | null }
			| { __typename?: "OtherAttachment"; sourceUrl?: string | null }
			| { __typename?: "VideoAttachment"; sourceUrl?: string | null }
			| null;
	};
};

export type ListUserSocialsQueryVariables = Exact<{
	userId: Scalars["ID"]["input"];
	after?: InputMaybe<Scalars["String"]["input"]>;
	before?: InputMaybe<Scalars["String"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListUserSocialsQuery = {
	__typename?: "PublicQuery";
	publicUser: {
		__typename?: "PublicProfileUser";
		socialLinks: {
			__typename?: "UserSocialLinksConnection";
			totalCount: number;
			nodes?: Array<{
				__typename?: "UserSocialLinks";
				id: string;
				profilePic?: string | null;
				url: string;
				username?: string | null;
				website: UserSocialLinkWebsites;
				accountId?: string | null;
				fullName?: string | null;
				verified: boolean;
			} | null> | null;
			pageInfo: {
				__typename?: "PageInfo";
				endCursor?: string | null;
				hasNextPage: boolean;
				hasPreviousPage: boolean;
				startCursor?: string | null;
			};
		};
	};
};

export type MuteUserMutationVariables = Exact<{
	input: CreateCompanyMutedUserInput;
}>;

export type MuteUserMutation = {
	__typename?: "PublicMutation";
	createCompanyMutedUser?: boolean | null;
};

export type UnbanUserMutationVariables = Exact<{
	input: UnbanUserInput;
}>;

export type UnbanUserMutation = {
	__typename?: "PublicMutation";
	unbanUser?: boolean | null;
};

export type UnmuteUserMutationVariables = Exact<{
	input: DeleteCompanyMutedUserInput;
}>;

export type UnmuteUserMutation = {
	__typename?: "PublicMutation";
	deleteCompanyMutedUser?: boolean | null;
};

export type CreateWebhookMutationVariables = Exact<{
	input: CreateWebhookInput;
}>;

export type CreateWebhookMutation = {
	__typename?: "PublicMutation";
	createWebhook?: {
		__typename?: "Webhook";
		id: string;
		url: string;
		apiVersion: ApiVersion;
		createdAt: number;
		enabled: boolean;
		events: Array<WebhookEvent>;
		resourceId: string;
		webhookSecret: string;
	} | null;
};

export type DeleteWebhookMutationVariables = Exact<{
	input: DeleteWebhookInput;
}>;

export type DeleteWebhookMutation = {
	__typename?: "PublicMutation";
	deleteWebhook?: boolean | null;
};

export type GetWebhookQueryVariables = Exact<{
	webhookId: Scalars["ID"]["input"];
	companyId: Scalars["ID"]["input"];
}>;

export type GetWebhookQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		webhook: {
			__typename?: "Webhook";
			id: string;
			url: string;
			apiVersion: ApiVersion;
			createdAt: number;
			enabled: boolean;
			events: Array<WebhookEvent>;
			resourceId: string;
			webhookSecret: string;
		};
	} | null;
};

export type ListWebhooksQueryVariables = Exact<{
	companyId: Scalars["ID"]["input"];
}>;

export type ListWebhooksQuery = {
	__typename?: "PublicQuery";
	company?: {
		__typename?: "Company";
		webhooks: Array<{
			__typename?: "Webhook";
			id: string;
			url: string;
			apiVersion: ApiVersion;
			createdAt: number;
			enabled: boolean;
			events: Array<WebhookEvent>;
			resourceId: string;
			webhookSecret: string;
		}>;
	} | null;
};

export type TestWebhookMutationVariables = Exact<{
	input: TestWebhookV2Input;
}>;

export type TestWebhookMutation = {
	__typename?: "PublicMutation";
	testWebhookV2?: {
		__typename?: "WebhookTestResult";
		body: { [key: string]: any };
		status: number;
		success: boolean;
	} | null;
};

export type UpdateWebhookMutationVariables = Exact<{
	input: UpdateWebhookInput;
}>;

export type UpdateWebhookMutation = {
	__typename?: "PublicMutation";
	updateWebhook?: {
		__typename?: "Webhook";
		id: string;
		url: string;
		apiVersion: ApiVersion;
		createdAt: number;
		enabled: boolean;
		events: Array<WebhookEvent>;
		resourceId: string;
		webhookSecret: string;
	} | null;
};

export type Requester<C = {}> = <R, V>(
	operationId: string,
	operationName: string,
	operationType: "query" | "mutation",
	vars?: V,
	options?: C,
) => Promise<R>;

export type WithError<T> = T extends object ? T & { _error?: Error } : T;
export function carryErrors<Full, Extracted>(
	res: Full,
	data: Extracted,
): WithError<Extracted> {
	if (
		typeof res === "object" &&
		res &&
		"_error" in res &&
		res._error &&
		res._error instanceof Error &&
		typeof data === "object" &&
		data
	) {
		(data as any)._error = res._error;
	}
	return data as WithError<Extracted>;
}

export function getSdk<C>(requester: Requester<C>) {
	return {
		accessPasses: {
			createAccessPass(
				variables: CreateAccessPassMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateAccessPassMutation["createAccessPass"]>> {
				return requester<
					CreateAccessPassMutation,
					CreateAccessPassMutationVariables
				>(
					"whop-sdk-ts-server/sha256:20ae526780e39f4766202cec9041775e39dcf12c6254d9ce3c80ceeed146ad9c",
					"createAccessPass",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createAccessPass));
			},
			deleteAccessPass(
				variables: DeleteAccessPassMutationVariables["input"],
				options?: C,
			): Promise<WithError<DeleteAccessPassMutation["deleteAccessPass"]>> {
				return requester<
					DeleteAccessPassMutation,
					DeleteAccessPassMutationVariables
				>(
					"whop-sdk-ts-server/sha256:cc4cb9f78f298bfc5067091adca56a07833d22f4011255aedd317a9c78b2a3ba",
					"deleteAccessPass",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteAccessPass));
			},
			getAccessPass(
				variables: GetAccessPassQueryVariables,
				options?: C,
			): Promise<WithError<GetAccessPassQuery["accessPass"]>> {
				return requester<GetAccessPassQuery, GetAccessPassQueryVariables>(
					"whop-sdk-ts-server/sha256:fa2b3d0ff6975e2e05c1e649fb853892460355f2a4e9bd33a67ef9bcdf6ed686",
					"getAccessPass",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.accessPass));
			},
			updateAccessPass(
				variables: UpdateAccessPassMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateAccessPassMutation["updateAccessPass"]>> {
				return requester<
					UpdateAccessPassMutation,
					UpdateAccessPassMutationVariables
				>(
					"whop-sdk-ts-server/sha256:45e0d72fec2c61a8763e7febcdfeea44c780fb657358614e5d6fa18d68b46aed",
					"updateAccessPass",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateAccessPass));
			},
		},
		access: {
			checkIfUserHasAccessToAccessPass(
				variables: CheckIfUserHasAccessToAccessPassQueryVariables,
				options?: C,
			): Promise<
				WithError<
					CheckIfUserHasAccessToAccessPassQuery["hasAccessToAccessPass"]
				>
			> {
				return requester<
					CheckIfUserHasAccessToAccessPassQuery,
					CheckIfUserHasAccessToAccessPassQueryVariables
				>(
					"whop-sdk-ts-server/sha256:a5ee1715113ab68b87dcfd5b578b6c20d1ca1fe50d8c0e2ec43e462a9b86632d",
					"checkIfUserHasAccessToAccessPass",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.hasAccessToAccessPass));
			},
			checkIfUserHasAccessToCompany(
				variables: CheckIfUserHasAccessToCompanyQueryVariables,
				options?: C,
			): Promise<
				WithError<CheckIfUserHasAccessToCompanyQuery["hasAccessToCompany"]>
			> {
				return requester<
					CheckIfUserHasAccessToCompanyQuery,
					CheckIfUserHasAccessToCompanyQueryVariables
				>(
					"whop-sdk-ts-server/sha256:b894321dc004894f993e91f5e7451554b0ae8af7da950a5c84ac69180599edc2",
					"checkIfUserHasAccessToCompany",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.hasAccessToCompany));
			},
			checkIfUserHasAccessToExperience(
				variables: CheckIfUserHasAccessToExperienceQueryVariables,
				options?: C,
			): Promise<
				WithError<
					CheckIfUserHasAccessToExperienceQuery["hasAccessToExperience"]
				>
			> {
				return requester<
					CheckIfUserHasAccessToExperienceQuery,
					CheckIfUserHasAccessToExperienceQueryVariables
				>(
					"whop-sdk-ts-server/sha256:b16d7fe717171fb936dfb6de679558e149f5070bbe25ade44e38af83c330ad71",
					"checkIfUserHasAccessToExperience",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.hasAccessToExperience));
			},
		},
		affiliates: {
			createAffiliate(
				variables: CreateAffiliateMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateAffiliateMutation["createAffiliate"]>> {
				return requester<
					CreateAffiliateMutation,
					CreateAffiliateMutationVariables
				>(
					"whop-sdk-ts-server/sha256:a8aab2d61c40493e5fe0c03979c9f252412d37ac4c4034d4dfc9391d4f71368d",
					"createAffiliate",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createAffiliate));
			},
			getAffiliate(
				variables: GetAffiliateQueryVariables,
				options?: C,
			): Promise<WithError<GetAffiliateQuery["company"]>> {
				return requester<GetAffiliateQuery, GetAffiliateQueryVariables>(
					"whop-sdk-ts-server/sha256:0361bff066bcb4ec9d86ae9ce45d812b5b0978252fbeb347418e16c8d6c56de2",
					"getAffiliate",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listAffiliates(
				variables: ListAffiliatesQueryVariables,
				options?: C,
			): Promise<WithError<ListAffiliatesQuery["company"]>> {
				return requester<ListAffiliatesQuery, ListAffiliatesQueryVariables>(
					"whop-sdk-ts-server/sha256:85622f8b63f7b6e23dbaa6c04a58e3fb5e3237cb03fa112ee17c98ebf925285c",
					"listAffiliates",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			updateAffiliate(
				variables: UpdateAffiliateMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateAffiliateMutation["updateAffiliate"]>> {
				return requester<
					UpdateAffiliateMutation,
					UpdateAffiliateMutationVariables
				>(
					"whop-sdk-ts-server/sha256:781a4e1b84f64748e882eb8f5e09aa3962fdbafee01874b3eb96fe1fbb261f1d",
					"updateAffiliate",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateAffiliate));
			},
		},
		apps: {
			createAppBuild(
				variables: CreateAppBuildMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateAppBuildMutation["createAppBuild"]>> {
				return requester<
					CreateAppBuildMutation,
					CreateAppBuildMutationVariables
				>(
					"whop-sdk-ts-server/sha256:221275dcd40898079c1e7bc1510b364a487581d6cdfc1a9524da74f2f82689cc",
					"createAppBuild",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createAppBuild));
			},
			createApp(
				variables: CreateAppMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateAppMutation["createApp"]>> {
				return requester<CreateAppMutation, CreateAppMutationVariables>(
					"whop-sdk-ts-server/sha256:be663b827a8dabcf7b9cbd0f65e80972811c1bc86009cc6a420b66d8e1c36f40",
					"createApp",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createApp));
			},
			getApp(
				variables: GetAppQueryVariables,
				options?: C,
			): Promise<WithError<GetAppQuery["company"]>> {
				return requester<GetAppQuery, GetAppQueryVariables>(
					"whop-sdk-ts-server/sha256:07248adff9447a8ddc20c810fbb780eddb10f9c3b4de9c2e8cc125de5735c9ef",
					"getApp",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listApps(
				variables: ListAppsQueryVariables,
				options?: C,
			): Promise<WithError<ListAppsQuery["company"]>> {
				return requester<ListAppsQuery, ListAppsQueryVariables>(
					"whop-sdk-ts-server/sha256:46bbea222f2bb22c7622d0554383c50246d97daf9dc92bb54790b6a330810628",
					"listApps",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			promoteAppBuild(
				variables: PromoteAppBuildMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<PromoteAppBuildMutation["promoteAppBuildToProduction"]>
			> {
				return requester<
					PromoteAppBuildMutation,
					PromoteAppBuildMutationVariables
				>(
					"whop-sdk-ts-server/sha256:dea1f52e9a4e332c258517b6bd0905ea8c2a738d861a9e9bb648f7ecead843a9",
					"promoteAppBuild",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.promoteAppBuildToProduction));
			},
			unassignAppBuild(
				variables: UnassignAppBuildMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<UnassignAppBuildMutation["unassignProductionAppBuild"]>
			> {
				return requester<
					UnassignAppBuildMutation,
					UnassignAppBuildMutationVariables
				>(
					"whop-sdk-ts-server/sha256:fb574bc621e2dee1d3bebddf5a6f3b438337778e9e66370a9dbe8163dc7c23bc",
					"unassignAppBuild",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.unassignProductionAppBuild));
			},
			updateAppPermissions(
				variables: UpdateAppPermissionsMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<
					UpdateAppPermissionsMutation["updateAppPermissionRequirements"]
				>
			> {
				return requester<
					UpdateAppPermissionsMutation,
					UpdateAppPermissionsMutationVariables
				>(
					"whop-sdk-ts-server/sha256:20a225127a6164553f5eebef17ac8447e8f8a4f220483f4922874def2a7fe423",
					"updateAppPermissions",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateAppPermissionRequirements));
			},
			updateApp(
				variables: UpdateAppMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateAppMutation["updateApp"]>> {
				return requester<UpdateAppMutation, UpdateAppMutationVariables>(
					"whop-sdk-ts-server/sha256:b8d41fdc2d5d3c0cd850bc4f8dedc81a3d65a59da3cc70b50397aaba2be3894a",
					"updateApp",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateApp));
			},
		},
		attachments: {
			getAttachment(
				variables: GetAttachmentQueryVariables,
				options?: C,
			): Promise<WithError<GetAttachmentQuery["attachment"]>> {
				return requester<GetAttachmentQuery, GetAttachmentQueryVariables>(
					"whop-sdk-ts-server/sha256:07f48fb0c1292fda5a8dd5f54b5d1b637635a87b6012769819ebcf7795a045ba",
					"getAttachment",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.attachment));
			},
			processAttachment(
				variables: ProcessAttachmentMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<ProcessAttachmentMutation["mediaAnalyzeAttachment"]>
			> {
				return requester<
					ProcessAttachmentMutation,
					ProcessAttachmentMutationVariables
				>(
					"whop-sdk-ts-server/sha256:396c5803051b3c9bcedd3ce310505a4f57a6b94bc190e7142e897d9aa5036ece",
					"processAttachment",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.mediaAnalyzeAttachment));
			},
			uploadMedia(
				variables: UploadMediaMutationVariables["input"],
				options?: C,
			): Promise<WithError<UploadMediaMutation["mediaDirectUpload"]>> {
				return requester<UploadMediaMutation, UploadMediaMutationVariables>(
					"whop-sdk-ts-server/sha256:a3d06ed16e52126d96aae83cad3400471246f37fc275e4c8f4836c98bf8e9d59",
					"uploadMedia",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.mediaDirectUpload));
			},
		},
		companies: {
			getCompanyLedgerAccount(
				variables: GetCompanyLedgerAccountQueryVariables,
				options?: C,
			): Promise<WithError<GetCompanyLedgerAccountQuery["company"]>> {
				return requester<
					GetCompanyLedgerAccountQuery,
					GetCompanyLedgerAccountQueryVariables
				>(
					"whop-sdk-ts-server/sha256:38c83c1105b29a010208830b29d38af3d87a885b9c54a3da65d6dd2749128773",
					"getCompanyLedgerAccount",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			getCompany(
				variables: GetCompanyQueryVariables,
				options?: C,
			): Promise<WithError<GetCompanyQuery["company"]>> {
				return requester<GetCompanyQuery, GetCompanyQueryVariables>(
					"whop-sdk-ts-server/sha256:e640d46816020225ad7ec377936056cabb7e8e07a88ba376e926ba18aca1cc5c",
					"getCompany",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			getMember(
				variables: GetMemberQueryVariables,
				options?: C,
			): Promise<WithError<GetMemberQuery["company"]>> {
				return requester<GetMemberQuery, GetMemberQueryVariables>(
					"whop-sdk-ts-server/sha256:e2628bcd1daff66d27443145965cc34f26a76da715d9781174316be703b0ac02",
					"getMember",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listAccessPasses(
				variables: ListAccessPassesQueryVariables,
				options?: C,
			): Promise<WithError<ListAccessPassesQuery["company"]>> {
				return requester<ListAccessPassesQuery, ListAccessPassesQueryVariables>(
					"whop-sdk-ts-server/sha256:d3c047dfcf88fae7603b04a3f46c9a7abd6638c13591ac64d7f86226a5edb438",
					"listAccessPasses",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listAuthorizedUsers(
				variables: ListAuthorizedUsersQueryVariables,
				options?: C,
			): Promise<WithError<ListAuthorizedUsersQuery["company"]>> {
				return requester<
					ListAuthorizedUsersQuery,
					ListAuthorizedUsersQueryVariables
				>(
					"whop-sdk-ts-server/sha256:c8c7d8e926bba8ecd46f9976cc1ce265ac666570706606295931f19c622c50dc",
					"listAuthorizedUsers",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listMembers(
				variables: ListMembersQueryVariables,
				options?: C,
			): Promise<WithError<ListMembersQuery["company"]>> {
				return requester<ListMembersQuery, ListMembersQueryVariables>(
					"whop-sdk-ts-server/sha256:d71ca5f1a332e7b42f405eb284aaf5d8ba094c99fd6a9d5ac503dff9a927d301",
					"listMembers",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listMemberships(
				variables: ListMembershipsQueryVariables,
				options?: C,
			): Promise<WithError<ListMembershipsQuery["company"]>> {
				return requester<ListMembershipsQuery, ListMembershipsQueryVariables>(
					"whop-sdk-ts-server/sha256:cfa788e5edcaf72ae9cb749035cf7bca20fd380c7d0d548c02d6ae978262f5cf",
					"listMemberships",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listPlans(
				variables: ListPlansQueryVariables,
				options?: C,
			): Promise<WithError<ListPlansQuery["company"]>> {
				return requester<ListPlansQuery, ListPlansQueryVariables>(
					"whop-sdk-ts-server/sha256:51d610ed0e4994b2c6f3514f9f478fb301366adc33c3e09166b3de3801c9c26a",
					"listPlans",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listWaitlistEntries(
				variables: ListWaitlistEntriesQueryVariables,
				options?: C,
			): Promise<WithError<ListWaitlistEntriesQuery["company"]>> {
				return requester<
					ListWaitlistEntriesQuery,
					ListWaitlistEntriesQueryVariables
				>(
					"whop-sdk-ts-server/sha256:14e1c30b9e364214d378cdb0b8ebf929397295e3644ffc22205ebe915b79e79f",
					"listWaitlistEntries",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
		},
		courses: {
			createAssessmentQuestion(
				variables: CreateAssessmentQuestionMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<CreateAssessmentQuestionMutation["createAssessmentQuestion"]>
			> {
				return requester<
					CreateAssessmentQuestionMutation,
					CreateAssessmentQuestionMutationVariables
				>(
					"whop-sdk-ts-server/sha256:52902016f3a8cf2b819038945ded34a0caafd80c9a867403ca36451c39f56ac6",
					"createAssessmentQuestion",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createAssessmentQuestion));
			},
			createChapter(
				variables: CreateChapterMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateChapterMutation["createChapter"]>> {
				return requester<CreateChapterMutation, CreateChapterMutationVariables>(
					"whop-sdk-ts-server/sha256:8ebe9533278b00eded622eef765baeebf70fccedcd5d60854f8777812da20311",
					"createChapter",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createChapter));
			},
			createCourse(
				variables: CreateCourseMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateCourseMutation["createCourse"]>> {
				return requester<CreateCourseMutation, CreateCourseMutationVariables>(
					"whop-sdk-ts-server/sha256:41f957dfc0e147131265e62e4b5ae6f743256f6bf7a4e28e042a3469777e9c35",
					"createCourse",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createCourse));
			},
			createLesson(
				variables: CreateLessonMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateLessonMutation["createLesson"]>> {
				return requester<CreateLessonMutation, CreateLessonMutationVariables>(
					"whop-sdk-ts-server/sha256:33069f4d2b756d6a9a2a486d0ac6d91272c9acbd9d3774c15e12d7b39f3df6f4",
					"createLesson",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createLesson));
			},
			deleteAssessmentQuestionImage(
				variables: DeleteAssessmentQuestionImageMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<
					DeleteAssessmentQuestionImageMutation["deleteAssessmentQuestionImage"]
				>
			> {
				return requester<
					DeleteAssessmentQuestionImageMutation,
					DeleteAssessmentQuestionImageMutationVariables
				>(
					"whop-sdk-ts-server/sha256:07563fb79b45fd9fbe7ef7d14923014e5f3407dae067d0393b84bd6724970aaa",
					"deleteAssessmentQuestionImage",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteAssessmentQuestionImage));
			},
			deleteChapter(
				variables: DeleteChapterMutationVariables["input"],
				options?: C,
			): Promise<WithError<DeleteChapterMutation["deleteChapter"]>> {
				return requester<DeleteChapterMutation, DeleteChapterMutationVariables>(
					"whop-sdk-ts-server/sha256:021c10ea5b5f776e229d4c2cd25578b8aec3c869c898c747d4dcb889ddad32b6",
					"deleteChapter",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteChapter));
			},
			deleteLessonAttachment(
				variables: DeleteLessonAttachmentMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<DeleteLessonAttachmentMutation["deleteLessonAttachment"]>
			> {
				return requester<
					DeleteLessonAttachmentMutation,
					DeleteLessonAttachmentMutationVariables
				>(
					"whop-sdk-ts-server/sha256:7af840d8ddbf664a04ec3da2283e9a540f68da24adedbe7a2af9718f1c70f10c",
					"deleteLessonAttachment",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteLessonAttachment));
			},
			deleteLesson(
				variables: DeleteLessonMutationVariables["input"],
				options?: C,
			): Promise<WithError<DeleteLessonMutation["deleteLesson"]>> {
				return requester<DeleteLessonMutation, DeleteLessonMutationVariables>(
					"whop-sdk-ts-server/sha256:6be8fd89af64aec7db125bac7d67bad8530cc8f5b8ee98c879351acd59aa6fac",
					"deleteLesson",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteLesson));
			},
			getCourse(
				variables: GetCourseQueryVariables,
				options?: C,
			): Promise<WithError<GetCourseQuery["course"]>> {
				return requester<GetCourseQuery, GetCourseQueryVariables>(
					"whop-sdk-ts-server/sha256:5e81c304ac7c4c19b2d07ea7c2a32b2fd8998774bf90900a81999b9077b383a1",
					"getCourse",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.course));
			},
			getLesson(
				variables: GetLessonQueryVariables,
				options?: C,
			): Promise<WithError<GetLessonQuery["course"]>> {
				return requester<GetLessonQuery, GetLessonQueryVariables>(
					"whop-sdk-ts-server/sha256:372989bc0ffb7ff3c36d1325f1af4115c06205e95378a2e344d91a857e732630",
					"getLesson",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.course));
			},
			getUserLessonInteractions(
				variables: GetUserLessonInteractionsQueryVariables,
				options?: C,
			): Promise<WithError<GetUserLessonInteractionsQuery["course"]>> {
				return requester<
					GetUserLessonInteractionsQuery,
					GetUserLessonInteractionsQueryVariables
				>(
					"whop-sdk-ts-server/sha256:6b12c8ccabe59b65d8869029d4e4e56ddbeac7256137e5e79012a3e33aa81523",
					"getUserLessonInteractions",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.course));
			},
			listCoursesForCompany(
				variables: ListCoursesForCompanyQueryVariables,
				options?: C,
			): Promise<WithError<ListCoursesForCompanyQuery["company"]>> {
				return requester<
					ListCoursesForCompanyQuery,
					ListCoursesForCompanyQueryVariables
				>(
					"whop-sdk-ts-server/sha256:76dd2b0b09b6083392dcce8c1df423cc6e6eb290e58bdd2d830f50ef1a4828b3",
					"listCoursesForCompany",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listCoursesForExperience(
				variables: ListCoursesForExperienceQueryVariables,
				options?: C,
			): Promise<WithError<ListCoursesForExperienceQuery["publicExperience"]>> {
				return requester<
					ListCoursesForExperienceQuery,
					ListCoursesForExperienceQueryVariables
				>(
					"whop-sdk-ts-server/sha256:a579fee2663d841a23be014b234d89eadb097dac387722dfe9d0e87911a7598e",
					"listCoursesForExperience",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.publicExperience));
			},
			markLessonAsCompleted(
				variables: MarkLessonAsCompletedMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<MarkLessonAsCompletedMutation["markLessonAsCompleted"]>
			> {
				return requester<
					MarkLessonAsCompletedMutation,
					MarkLessonAsCompletedMutationVariables
				>(
					"whop-sdk-ts-server/sha256:941178d021bd72247401d347d5dd969036579147777e0a754f5102cddc5074c7",
					"markLessonAsCompleted",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.markLessonAsCompleted));
			},
			moveCourse(
				variables: MoveCourseMutationVariables["input"],
				options?: C,
			): Promise<WithError<MoveCourseMutation["moveCourse"]>> {
				return requester<MoveCourseMutation, MoveCourseMutationVariables>(
					"whop-sdk-ts-server/sha256:ce7d38029113792bf1ff544db18f000732fed4db3ebc766767a367cef5691c2b",
					"moveCourse",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.moveCourse));
			},
			updateChapterOrder(
				variables: UpdateChapterOrderMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateChapterOrderMutation["updateChapterOrder"]>> {
				return requester<
					UpdateChapterOrderMutation,
					UpdateChapterOrderMutationVariables
				>(
					"whop-sdk-ts-server/sha256:c749c5c4907afd39ab2d3f8c44b3e65c8c9928e0cf06f8687deaa40d144a0df6",
					"updateChapterOrder",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateChapterOrder));
			},
			updateChapter(
				variables: UpdateChapterMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateChapterMutation["updateChapter"]>> {
				return requester<UpdateChapterMutation, UpdateChapterMutationVariables>(
					"whop-sdk-ts-server/sha256:9fda8d867b07c1b31622cb73084523577519ca35822d8ce3938fa2b07efaf6e5",
					"updateChapter",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateChapter));
			},
			updateLessonOrder(
				variables: UpdateLessonOrderMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateLessonOrderMutation["updateLessonOrder"]>> {
				return requester<
					UpdateLessonOrderMutation,
					UpdateLessonOrderMutationVariables
				>(
					"whop-sdk-ts-server/sha256:8ae83382f97b182c08bf5851e3bbed05fd8269856c00b82b5577939c00e39e43",
					"updateLessonOrder",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateLessonOrder));
			},
			updateLesson(
				variables: UpdateLessonMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateLessonMutation["updateLesson"]>> {
				return requester<UpdateLessonMutation, UpdateLessonMutationVariables>(
					"whop-sdk-ts-server/sha256:c872c79e5469f162f4de0f64ed6decc489cc3e05d66781a2f33ae1eef4d762bd",
					"updateLesson",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateLesson));
			},
		},
		experiences: {
			getExperience(
				variables: GetExperienceQueryVariables,
				options?: C,
			): Promise<WithError<GetExperienceQuery["experience"]>> {
				return requester<GetExperienceQuery, GetExperienceQueryVariables>(
					"whop-sdk-ts-server/sha256:61d7778965bc84e700a681ec856251c59070ebc6b0e00b6e5c91568df734db7e",
					"getExperience",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.experience));
			},
			listAccessPassesForExperience(
				variables: ListAccessPassesForExperienceQueryVariables,
				options?: C,
			): Promise<WithError<ListAccessPassesForExperienceQuery["experience"]>> {
				return requester<
					ListAccessPassesForExperienceQuery,
					ListAccessPassesForExperienceQueryVariables
				>(
					"whop-sdk-ts-server/sha256:699621f62be7675bfaf9fc49cb6d7abfe244bf691aee274cb492036f0b59bddc",
					"listAccessPassesForExperience",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.experience));
			},
			listExperiences(
				variables: ListExperiencesQueryVariables,
				options?: C,
			): Promise<WithError<ListExperiencesQuery["company"]>> {
				return requester<ListExperiencesQuery, ListExperiencesQueryVariables>(
					"whop-sdk-ts-server/sha256:6ca8515118d4710204bb2e32ea020bb98de8ea1cada4929ecfe7cae606cf6e79",
					"listExperiences",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listUsersForExperience(
				variables: ListUsersForExperienceQueryVariables,
				options?: C,
			): Promise<WithError<ListUsersForExperienceQuery["publicExperience"]>> {
				return requester<
					ListUsersForExperienceQuery,
					ListUsersForExperienceQueryVariables
				>(
					"whop-sdk-ts-server/sha256:85c827d8660dc2a97e8b930e213b83493ae132c00988e0f03e02c5dc99559a5a",
					"listUsersForExperience",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.publicExperience));
			},
		},
		forums: {
			createForumPost(
				variables: CreateForumPostMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateForumPostMutation["createForumPost"]>> {
				return requester<
					CreateForumPostMutation,
					CreateForumPostMutationVariables
				>(
					"whop-sdk-ts-server/sha256:e6253ed15def017eef4bc2e2f8b01ecd9cf480b5c54fffed439d0afe01a864f2",
					"createForumPost",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createForumPost));
			},
			findOrCreateForum(
				variables: FindOrCreateForumMutationVariables["input"],
				options?: C,
			): Promise<WithError<FindOrCreateForumMutation["createForum"]>> {
				return requester<
					FindOrCreateForumMutation,
					FindOrCreateForumMutationVariables
				>(
					"whop-sdk-ts-server/sha256:5219219796ebdeb29023d098bd9498cf8c64b3536dc9d42cbc4e19708e0b317d",
					"findOrCreateForum",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createForum));
			},
			listForumPostsFromForum(
				variables: ListForumPostsFromForumQueryVariables,
				options?: C,
			): Promise<WithError<ListForumPostsFromForumQuery["feedPosts"]>> {
				return requester<
					ListForumPostsFromForumQuery,
					ListForumPostsFromForumQueryVariables
				>(
					"whop-sdk-ts-server/sha256:97a7d797f3a5f6f83bf4628cc7c586d529b90e54c0a8e193493a55b4ad05df46",
					"listForumPostsFromForum",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.feedPosts));
			},
		},
		invoices: {
			createInvoice(
				variables: CreateInvoiceMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateInvoiceMutation["createInvoice"]>> {
				return requester<CreateInvoiceMutation, CreateInvoiceMutationVariables>(
					"whop-sdk-ts-server/sha256:58c3f4ebbb92ebf44d07d781d8f27250f497516c0b492f1ad155ee4f00c64cca",
					"createInvoice",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createInvoice));
			},
			getInvoice(
				variables: GetInvoiceQueryVariables,
				options?: C,
			): Promise<WithError<GetInvoiceQuery["company"]>> {
				return requester<GetInvoiceQuery, GetInvoiceQueryVariables>(
					"whop-sdk-ts-server/sha256:d38c77f13bb55a0b427a0e5f5c5f4121c9f2679a7ac5b35a6c98af6d9e819702",
					"getInvoice",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listInvoices(
				variables: ListInvoicesQueryVariables,
				options?: C,
			): Promise<WithError<ListInvoicesQuery["company"]>> {
				return requester<ListInvoicesQuery, ListInvoicesQueryVariables>(
					"whop-sdk-ts-server/sha256:3cb820ba6eab6d1557eb842140f5b54701c6046f51e663f8a12fdff7142f1941",
					"listInvoices",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
		},
		messages: {
			findOrCreateChat(
				variables: FindOrCreateChatMutationVariables["input"],
				options?: C,
			): Promise<WithError<FindOrCreateChatMutation["createChat"]>> {
				return requester<
					FindOrCreateChatMutation,
					FindOrCreateChatMutationVariables
				>(
					"whop-sdk-ts-server/sha256:f69684c08f79192b7a4722a3c24a347fd0074e04e1c940517e54b52a9c27f40c",
					"findOrCreateChat",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createChat));
			},
			listDirectMessageConversations(
				variables?: ListDirectMessageConversationsQueryVariables,
				options?: C,
			): Promise<
				WithError<ListDirectMessageConversationsQuery["myDmsChannelsV2"]>
			> {
				return requester<
					ListDirectMessageConversationsQuery,
					ListDirectMessageConversationsQueryVariables
				>(
					"whop-sdk-ts-server/sha256:ea4457aace3d29d8c376dd9de3629cee00d4a76ff0fc9b9d51b6ffeab1cc6ead",
					"listDirectMessageConversations",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.myDmsChannelsV2));
			},
			listMessagesFromChat(
				variables?: ListMessagesFromChatQueryVariables,
				options?: C,
			): Promise<WithError<ListMessagesFromChatQuery["feedPosts"]>> {
				return requester<
					ListMessagesFromChatQuery,
					ListMessagesFromChatQueryVariables
				>(
					"whop-sdk-ts-server/sha256:5fdbf50fe489888e5b0a98e9fe6170584bf47ab38f87d1e0b7fce8f523513894",
					"listMessagesFromChat",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.feedPosts));
			},
			sendDirectMessageToUser(
				variables: SendDirectMessageToUserMutationVariables,
				options?: C,
			): Promise<WithError<SendDirectMessageToUserMutation["sendMessage"]>> {
				return requester<
					SendDirectMessageToUserMutation,
					SendDirectMessageToUserMutationVariables
				>(
					"whop-sdk-ts-server/sha256:f538092a21961a949a75e07b02d58dc05666535c8c8e03aed867fd82d98a58d4",
					"sendDirectMessageToUser",
					"mutation",
					variables,
					options,
				).then((res) => carryErrors(res, res.sendMessage));
			},
			sendMessageToChat(
				variables: SendMessageToChatMutationVariables,
				options?: C,
			): Promise<WithError<SendMessageToChatMutation["sendMessage"]>> {
				return requester<
					SendMessageToChatMutation,
					SendMessageToChatMutationVariables
				>(
					"whop-sdk-ts-server/sha256:4c25b180736d2868e65ab97791a12bb22e80d2bc03f29ecba86ccd1d91da292c",
					"sendMessageToChat",
					"mutation",
					variables,
					options,
				).then((res) => carryErrors(res, res.sendMessage));
			},
		},
		notifications: {
			sendPushNotification(
				variables: SendPushNotificationMutationVariables["input"],
				options?: C,
			): Promise<WithError<SendPushNotificationMutation["sendNotification"]>> {
				return requester<
					SendPushNotificationMutation,
					SendPushNotificationMutationVariables
				>(
					"whop-sdk-ts-server/sha256:6239cbdb659f0698ed81ca9533740337b4d2d44e25e22297188d7d1e1a7037d2",
					"sendPushNotification",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.sendNotification));
			},
		},
		payments: {
			chargeUser(
				variables: ChargeUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<ChargeUserMutation["chargeUser"]>> {
				return requester<ChargeUserMutation, ChargeUserMutationVariables>(
					"whop-sdk-ts-server/sha256:2392cef9bb6e08d243f102a52c4a6a6e6bd9371e2fced2ad598b2dc14685af81",
					"chargeUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.chargeUser));
			},
			createCheckoutSession(
				variables: CreateCheckoutSessionMutationVariables["input"],
				options?: C,
			): Promise<
				WithError<CreateCheckoutSessionMutation["createCheckoutSession"]>
			> {
				return requester<
					CreateCheckoutSessionMutation,
					CreateCheckoutSessionMutationVariables
				>(
					"whop-sdk-ts-server/sha256:498eba2f4b9b6b8fe4ed5f93423af054ea1c4995bf2f3258089c40b68a4919e8",
					"createCheckoutSession",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createCheckoutSession));
			},
			listReceiptsForCompany(
				variables: ListReceiptsForCompanyQueryVariables,
				options?: C,
			): Promise<WithError<ListReceiptsForCompanyQuery["company"]>> {
				return requester<
					ListReceiptsForCompanyQuery,
					ListReceiptsForCompanyQueryVariables
				>(
					"whop-sdk-ts-server/sha256:4b5163aa1e6398851da21ce465640243418d36bb26e7b1a87287cddcf677e6ca",
					"listReceiptsForCompany",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			payUser(
				variables: PayUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<PayUserMutation["transferFunds"]>> {
				return requester<PayUserMutation, PayUserMutationVariables>(
					"whop-sdk-ts-server/sha256:d8cbac8b275a7c41e05ab4daa01084b0e54c31c6b5375261f8aee241e5f6c794",
					"payUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.transferFunds));
			},
		},
		promoCodes: {
			createPromoCode(
				variables: CreatePromoCodeMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreatePromoCodeMutation["createPromoCode"]>> {
				return requester<
					CreatePromoCodeMutation,
					CreatePromoCodeMutationVariables
				>(
					"whop-sdk-ts-server/sha256:c80f3d5230cb85c4e47cd1521e607c1f58cf393dfc73fce813bc584acd3e0f4b",
					"createPromoCode",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createPromoCode));
			},
			deletePromoCode(
				variables: DeletePromoCodeMutationVariables["input"],
				options?: C,
			): Promise<WithError<DeletePromoCodeMutation["deletePromoCode"]>> {
				return requester<
					DeletePromoCodeMutation,
					DeletePromoCodeMutationVariables
				>(
					"whop-sdk-ts-server/sha256:bcd719e36f0a392a4aca1cd2bcaa758327cba282531dcf18220f24cc92d6210c",
					"deletePromoCode",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deletePromoCode));
			},
			getPromoCode(
				variables: GetPromoCodeQueryVariables,
				options?: C,
			): Promise<WithError<GetPromoCodeQuery["promoCode"]>> {
				return requester<GetPromoCodeQuery, GetPromoCodeQueryVariables>(
					"whop-sdk-ts-server/sha256:29fb69c7df1cb36af0db92cc3951cc84fbbaad8166733158667f0136483bb0ca",
					"getPromoCode",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.promoCode));
			},
			listPromoCodes(
				variables: ListPromoCodesQueryVariables,
				options?: C,
			): Promise<WithError<ListPromoCodesQuery["company"]>> {
				return requester<ListPromoCodesQuery, ListPromoCodesQueryVariables>(
					"whop-sdk-ts-server/sha256:5722ed2369ad9f1c62eb2579de00b765a7b5857e9340f366fb5d6612fb97633f",
					"listPromoCodes",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
		},
		users: {
			banUser(
				variables: BanUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<BanUserMutation["banUser"]>> {
				return requester<BanUserMutation, BanUserMutationVariables>(
					"whop-sdk-ts-server/sha256:cb1bc4d8fada30e5cecd68182f98129c24da6f252b60829e5b680b1c45b95be3",
					"banUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.banUser));
			},
			getCurrentUser(
				variables?: GetCurrentUserQueryVariables,
				options?: C,
			): Promise<WithError<GetCurrentUserQuery["viewer"]>> {
				return requester<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
					"whop-sdk-ts-server/sha256:9f7cc9ff353a2778e55b674cfd5737a7dcaff19be9ac13d6f79aabd5d8ef69ff",
					"getCurrentUser",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.viewer));
			},
			getUserLedgerAccount(
				variables?: GetUserLedgerAccountQueryVariables,
				options?: C,
			): Promise<WithError<GetUserLedgerAccountQuery["viewer"]>> {
				return requester<
					GetUserLedgerAccountQuery,
					GetUserLedgerAccountQueryVariables
				>(
					"whop-sdk-ts-server/sha256:d7eeaf0a388395edb82220877e72a7fc91d1f06a6d89f1cfa5e56bb400d2aa49",
					"getUserLedgerAccount",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.viewer));
			},
			getUser(
				variables: GetUserQueryVariables,
				options?: C,
			): Promise<WithError<GetUserQuery["publicUser"]>> {
				return requester<GetUserQuery, GetUserQueryVariables>(
					"whop-sdk-ts-server/sha256:c6cd0172ca06b30e54b818c216ccb00023ffa4d6392becd6fb80a5a0312b1b65",
					"getUser",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.publicUser));
			},
			listUserSocials(
				variables: ListUserSocialsQueryVariables,
				options?: C,
			): Promise<WithError<ListUserSocialsQuery["publicUser"]>> {
				return requester<ListUserSocialsQuery, ListUserSocialsQueryVariables>(
					"whop-sdk-ts-server/sha256:37ac821ca48a89c91a53f91cbba77d0ffa401807815a88e1e1d25819baf8d877",
					"listUserSocials",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.publicUser));
			},
			muteUser(
				variables: MuteUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<MuteUserMutation["createCompanyMutedUser"]>> {
				return requester<MuteUserMutation, MuteUserMutationVariables>(
					"whop-sdk-ts-server/sha256:57e050f6c8afa900a0e947157ee629d1435bfb8455ee0aebcc27d82d43ee26bb",
					"muteUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createCompanyMutedUser));
			},
			unbanUser(
				variables: UnbanUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<UnbanUserMutation["unbanUser"]>> {
				return requester<UnbanUserMutation, UnbanUserMutationVariables>(
					"whop-sdk-ts-server/sha256:fa0ff56a45a8dc977e12814ad25bee498fdb6adc280ce30722df8ff4f4c1a4d8",
					"unbanUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.unbanUser));
			},
			unmuteUser(
				variables: UnmuteUserMutationVariables["input"],
				options?: C,
			): Promise<WithError<UnmuteUserMutation["deleteCompanyMutedUser"]>> {
				return requester<UnmuteUserMutation, UnmuteUserMutationVariables>(
					"whop-sdk-ts-server/sha256:9c1f64ede76760c37850648c4541d50186d28dd656e4f69dd94501ae3babf8c7",
					"unmuteUser",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteCompanyMutedUser));
			},
		},
		webhooks: {
			createWebhook(
				variables: CreateWebhookMutationVariables["input"],
				options?: C,
			): Promise<WithError<CreateWebhookMutation["createWebhook"]>> {
				return requester<CreateWebhookMutation, CreateWebhookMutationVariables>(
					"whop-sdk-ts-server/sha256:203020195489ea56d6c664b7c4483367ba438db78f5ab057ccb8bcb3d6804186",
					"createWebhook",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.createWebhook));
			},
			deleteWebhook(
				variables: DeleteWebhookMutationVariables["input"],
				options?: C,
			): Promise<WithError<DeleteWebhookMutation["deleteWebhook"]>> {
				return requester<DeleteWebhookMutation, DeleteWebhookMutationVariables>(
					"whop-sdk-ts-server/sha256:84d542a9790c9ba9da706cee4cadeb8932fab37daf23775489066ca6f5ead1f2",
					"deleteWebhook",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.deleteWebhook));
			},
			getWebhook(
				variables: GetWebhookQueryVariables,
				options?: C,
			): Promise<WithError<GetWebhookQuery["company"]>> {
				return requester<GetWebhookQuery, GetWebhookQueryVariables>(
					"whop-sdk-ts-server/sha256:c8b6985c11fe9dafc0117d6ae57b27a8331427bf93844dbedf6376bc51800545",
					"getWebhook",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			listWebhooks(
				variables: ListWebhooksQueryVariables,
				options?: C,
			): Promise<WithError<ListWebhooksQuery["company"]>> {
				return requester<ListWebhooksQuery, ListWebhooksQueryVariables>(
					"whop-sdk-ts-server/sha256:eef881aaf99c3cad84eb3b113552d3272712562ce13cc487b6a38c6099ee4498",
					"listWebhooks",
					"query",
					variables,
					options,
				).then((res) => carryErrors(res, res.company));
			},
			testWebhook(
				variables: TestWebhookMutationVariables["input"],
				options?: C,
			): Promise<WithError<TestWebhookMutation["testWebhookV2"]>> {
				return requester<TestWebhookMutation, TestWebhookMutationVariables>(
					"whop-sdk-ts-server/sha256:cc8b4c644a503d29ebb1c62f812b2292a83298813d5d1ce0a66f667d27039e4c",
					"testWebhook",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.testWebhookV2));
			},
			updateWebhook(
				variables: UpdateWebhookMutationVariables["input"],
				options?: C,
			): Promise<WithError<UpdateWebhookMutation["updateWebhook"]>> {
				return requester<UpdateWebhookMutation, UpdateWebhookMutationVariables>(
					"whop-sdk-ts-server/sha256:362bc60c363078102712be7cd0483cfa5ed01a745046a041b98dc3846100eaf3",
					"updateWebhook",
					"mutation",
					{ input: variables },
					options,
				).then((res) => carryErrors(res, res.updateWebhook));
			},
		},
	};
}

export type Sdk = ReturnType<typeof getSdk>;
